<template>
  <!-- Edit -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-if="iconName === 'edit'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1215_6938"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      :width="size"
      :height="size"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 4.00012H19.9993V20H4V4.00012Z"
        :fill="iconColor"
      />
    </mask>
    <g mask="url(#mask0_1215_6938)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5559 18.2371L6.6419 14.9741L13.9239 7.67612L16.3239 10.0761L9.0549 17.3501L5.7619 18.4431C5.6349 18.4861 5.5139 18.3651 5.5559 18.2371V18.2371ZM15.9839 5.63112C16.0889 5.52612 16.2319 5.46712 16.3799 5.46812C16.5289 5.46712 16.6709 5.52612 16.7769 5.63112L18.3689 7.22812C18.4719 7.33312 18.5309 7.47212 18.5309 7.61912C18.5319 7.76712 18.4739 7.91012 18.3689 8.01512L18.3469 8.03812L17.2979 9.08712L14.9129 6.70212L15.9839 5.63112ZM10.4179 17.9461L19.4839 8.87512C20.1709 8.18612 20.1709 7.07012 19.4839 6.38112L17.6479 4.51612C17.3039 4.17212 16.8529 4.00012 16.4019 4.00012H16.4009C15.9499 4.00012 15.4979 4.17212 15.1539 4.51612L6.0539 13.5811C5.8619 13.7771 5.7159 14.0141 5.6299 14.2751L4.0379 19.0411C3.8489 19.6091 4.3899 20.1511 4.9589 19.9621L9.7299 18.3691C9.9879 18.2801 10.2229 18.1351 10.4179 17.9461V17.9461Z"
        :fill="iconColor"
      />
    </g>
  </svg>
  <!-- Open New Tab -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? '#7d838d' : '#9AAAC3'"
    v-else-if="iconName === 'open-new-tab'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
      :fill="iconColor"
    />
  </svg>
  <!-- Copy -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'copy'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.64934 6.20769C7.64934 4.98842 8.63775 4 9.85703 4H17.7902C19.0095 4 19.9979 4.98842 19.9979 6.20769V14.1407C19.9979 15.3599 19.0095 16.3483 17.7902 16.3483H16.3486V17.7902C16.3486 19.0095 15.3602 19.9979 14.1409 19.9979H6.20769C4.98842 19.9979 4 19.0095 4 17.7902V9.85724C4 8.63796 4.98842 7.64954 6.20769 7.64954H7.64934V6.20769ZM9.04934 7.64954H14.1409C15.3602 7.64954 16.3486 8.63796 16.3486 9.85724V14.9483H17.7902C18.2363 14.9483 18.5979 14.5867 18.5979 14.1407V6.20769C18.5979 5.76162 18.2363 5.4 17.7902 5.4H9.85703C9.41095 5.4 9.04934 5.76162 9.04934 6.20769V7.64954ZM5.4 9.85724C5.4 9.41116 5.76162 9.04954 6.20769 9.04954H14.1409C14.587 9.04954 14.9486 9.41116 14.9486 9.85724V17.7902C14.9486 18.2363 14.587 18.5979 14.1409 18.5979H6.20769C5.76162 18.5979 5.4 18.2363 5.4 17.7902V9.85724Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Delete -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'delete'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1215_6967"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="5"
      y="3"
      :width="size"
      :height="size"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 3.59985H18.7138V19.8427H5V3.59985Z"
        :fill="iconColor"
      />
    </mask>
    <g mask="url(#mask0_1215_6967)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.542 3.59961C13.489 3.59961 14.257 4.36761 14.257 5.31461V6.12861H18.314C18.5349 6.12861 18.714 6.3077 18.714 6.52861V7.12861C18.714 7.34952 18.5349 7.52861 18.314 7.52861H17.571V18.1286C17.571 19.0756 16.804 19.8426 15.856 19.8426H7.856C6.91 19.8426 6.143 19.0756 6.143 18.1286V7.52861H5.4C5.17909 7.52861 5 7.34952 5 7.12861V6.52861C5 6.3077 5.17909 6.12861 5.4 6.12861H9.457V5.31461C9.457 4.36761 10.225 3.59961 11.172 3.59961H12.542ZM16.169 7.53661H7.557V17.8976C7.557 18.1986 7.801 18.4426 8.102 18.4426H15.624C15.925 18.4426 16.169 18.1986 16.169 17.8976V7.53661ZM12.356 4.86461H11.357C11.081 4.86461 10.857 5.12061 10.857 5.43561V6.12861H12.856V5.43561C12.856 5.12061 12.633 4.86461 12.356 4.86461Z"
        :fill="iconColor"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.65967 16.0139C8.65967 16.2348 8.83875 16.4139 9.05967 16.4139H9.65867C9.87958 16.4139 10.0587 16.2348 10.0587 16.0139V9.95689C10.0587 9.73597 9.87958 9.55688 9.65867 9.55688H9.05967C8.83875 9.55688 8.65967 9.73597 8.65967 9.95688V16.0139Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1626 16.0139C11.1626 16.2348 11.3417 16.4139 11.5626 16.4139H12.1616C12.3825 16.4139 12.5616 16.2348 12.5616 16.0139V9.95689C12.5616 9.73597 12.3825 9.55688 12.1616 9.55688H11.5626C11.3417 9.55688 11.1626 9.73597 11.1626 9.95688V16.0139Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.666 16.0139C13.666 16.2348 13.8451 16.4139 14.066 16.4139H14.666C14.8869 16.4139 15.066 16.2348 15.066 16.0139V9.95689C15.066 9.73597 14.8869 9.55688 14.666 9.55688H14.066C13.8451 9.55688 13.666 9.73597 13.666 9.95688V16.0139Z"
      :fill="iconColor"
    />
  </svg>

  <svg
    v-else-if="iconName === 'delete-new'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 7.5H20.5M10.5 11.5V17.5M14.5 11.5V17.5M5.5 7.5V19.5C5.5 20.0304 5.71071 20.5391 6.08579 20.9142C6.46086 21.2893 6.96957 21.5 7.5 21.5H17.5C18.0304 21.5 18.5391 21.2893 18.9142 20.9142C19.2893 20.5391 19.5 20.0304 19.5 19.5V7.5M9.5 7.5V4.5C9.5 4.23478 9.60536 3.98043 9.79289 3.79289C9.98043 3.60536 10.2348 3.5 10.5 3.5H14.5C14.7652 3.5 15.0196 3.60536 15.2071 3.79289C15.3946 3.98043 15.5 4.23478 15.5 4.5V7.5"
      :stroke="strokeColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- Lock -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'lock'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.91504 11.8922C5.91504 10.691 6.87447 9.7138 8.06885 9.68519V8.2307C8.06885 6.05979 9.82871 4.29993 11.9996 4.29993C14.1705 4.29993 15.9304 6.05979 15.9304 8.2307V9.68519C17.1248 9.71376 18.0843 10.6909 18.0843 11.8922V17.4922C18.0843 18.7115 17.0959 19.6999 15.8766 19.6999H8.12273C6.90346 19.6999 5.91504 18.7115 5.91504 17.4922V11.8922ZM14.5304 8.2307V9.68454H9.46885V8.2307C9.46885 6.83299 10.6019 5.69993 11.9996 5.69993C13.3973 5.69993 14.5304 6.83299 14.5304 8.2307ZM8.12273 11.0845H8.93712H15.0621H15.8766C16.3227 11.0845 16.6843 11.4462 16.6843 11.8922V17.4922C16.6843 17.9383 16.3227 18.2999 15.8766 18.2999H8.12273C7.67666 18.2999 7.31504 17.9383 7.31504 17.4922V11.8922C7.31504 11.4462 7.67666 11.0845 8.12273 11.0845ZM11.9996 13.3462C11.613 13.3462 11.2996 13.6596 11.2996 14.0462V15.3385C11.2996 15.7251 11.613 16.0385 11.9996 16.0385C12.3862 16.0385 12.6996 15.7251 12.6996 15.3385V14.0462C12.6996 13.6596 12.3862 13.3462 11.9996 13.3462Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Unlock -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'unlock'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.1998 7.72593V9.68442H15.8766C17.0959 9.68442 18.0843 10.6728 18.0843 11.8921V17.4921C18.0843 18.7114 17.0959 19.6998 15.8766 19.6998H8.12273C6.90346 19.6998 5.91504 18.7114 5.91504 17.4921V11.8921C5.91504 10.6728 6.90346 9.68442 8.12273 9.68442H13.7998V7.72593C13.7998 5.55503 15.5597 3.79517 17.7306 3.79517C19.9015 3.79517 21.6613 5.55503 21.6613 7.72594V9.87978C21.6613 10.2664 21.3479 10.5798 20.9613 10.5798C20.5747 10.5798 20.2613 10.2664 20.2613 9.87978V7.72594C20.2613 6.32823 19.1283 5.19517 17.7306 5.19517C16.3329 5.19517 15.1998 6.32823 15.1998 7.72593ZM8.12273 11.0844C7.67666 11.0844 7.31504 11.446 7.31504 11.8921V17.4921C7.31504 17.9382 7.67666 18.2998 8.12273 18.2998H15.8766C16.3227 18.2998 16.6843 17.9382 16.6843 17.4921V11.8921C16.6843 11.446 16.3227 11.0844 15.8766 11.0844H8.12273ZM11.9996 13.3461C11.613 13.3461 11.2996 13.6595 11.2996 14.0461V15.3384C11.2996 15.725 11.613 16.0384 11.9996 16.0384C12.3862 16.0384 12.6996 15.725 12.6996 15.3384V14.0461C12.6996 13.6595 12.3862 13.3461 11.9996 13.3461Z"
      :fill="iconColor"
    />
  </svg>
  <!-- View -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'view'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5075 5.30005C6.28822 5.30005 5.2998 6.28847 5.2998 7.50774V16.4924C5.2998 17.7116 6.28822 18.7 7.5075 18.7H13.4921C14.5555 18.7 15.4434 17.9482 15.6529 16.947C15.4404 16.9819 15.2222 17 14.9998 17C14.7188 17 14.4446 16.9711 14.1799 16.9159C14.0377 17.1464 13.7828 17.3 13.4921 17.3H7.5075C7.06142 17.3 6.6998 16.9384 6.6998 16.4924V7.50774C6.6998 7.06167 7.06142 6.70005 7.5075 6.70005H13.4921C13.9382 6.70005 14.2998 7.06167 14.2998 7.50774V9.06109C14.5271 9.02097 14.761 9.00005 14.9998 9.00005C15.2386 9.00005 15.4725 9.02097 15.6998 9.06109V7.50774C15.6998 6.28847 14.7114 5.30005 13.4921 5.30005H7.5075Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6998 13C11.6998 11.1775 13.1773 9.70005 14.9998 9.70005C16.8223 9.70005 18.2998 11.1775 18.2998 13C18.2998 14.8226 16.8223 16.3 14.9998 16.3C13.1773 16.3 11.6998 14.8226 11.6998 13ZM14.9998 8.30005C12.4041 8.30005 10.2998 10.4043 10.2998 13C10.2998 15.5958 12.4041 17.7 14.9998 17.7C15.9724 17.7 16.8759 17.4047 17.6257 16.8987L19.8634 19.1364C20.2149 19.4879 20.7847 19.4879 21.1362 19.1364C21.4877 18.785 21.4877 18.2151 21.1362 17.8637L18.8984 15.6259C19.4044 14.8762 19.6998 13.9726 19.6998 13C19.6998 10.4043 17.5955 8.30005 14.9998 8.30005Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Folder -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'folder'"
    :width="size"
    :height="size"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4C1 2.89543 1.89543 2 3 2H6.85126C7.56259 2 8.2204 2.37782 8.57882 2.99226L9.46059 4.50387C9.6398 4.81109 9.9687 5 10.3244 5H13C14.1046 5 15 5.89543 15 7V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4Z"
      fill="#A6C7DB"
    />
  </svg>
  <!-- Folder Add -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'folder-add'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.82812 12.307C7.82812 12.5279 8.00721 12.707 8.22812 12.707H15.7721C15.993 12.707 16.1721 12.5279 16.1721 12.307V11.693C16.1721 11.4721 15.993 11.293 15.7721 11.293H8.22813C8.00721 11.293 7.82812 11.4721 7.82812 11.693V12.307Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.586 16.4872C17.586 17.0942 17.094 17.5862 16.487 17.5862H7.512C6.905 17.5862 6.414 17.0942 6.414 16.4872V7.51224C6.414 6.90624 6.905 6.41424 7.512 6.41424H16.487C17.094 6.41424 17.586 6.90624 17.586 7.51224V16.4872ZM16.846 5.00024H7.153C5.964 5.00024 5 5.96524 5 7.15424V16.8462C5 18.0362 5.964 19.0002 7.153 19.0002H16.846C18.035 19.0002 19 18.0362 19 16.8462V7.15424C19 5.96524 18.035 5.00024 16.846 5.00024V5.00024Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.293 15.7721C11.293 15.993 11.4721 16.1721 11.693 16.1721H12.307C12.5279 16.1721 12.707 15.993 12.707 15.7721V8.22813C12.707 8.00721 12.5279 7.82812 12.307 7.82812H11.693C11.4721 7.82812 11.293 8.00721 11.293 8.22812V15.7721Z"
      :fill="iconColor"
    />
  </svg>
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'add'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.65 6C11.4291 6 11.25 6.17909 11.25 6.4V11.25H6.4C6.17909 11.25 6 11.4291 6 11.65V12.35C6 12.5709 6.17909 12.75 6.4 12.75H11.25V17.6C11.25 17.8209 11.4291 18 11.65 18H12.35C12.5709 18 12.75 17.8209 12.75 17.6V12.75H17.6C17.8209 12.75 18 12.5709 18 12.35V11.65C18 11.4291 17.8209 11.25 17.6 11.25H12.75V6.4C12.75 6.17909 12.5709 6 12.35 6H11.65Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Save -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'save'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.75 5.75C6.19772 5.75 5.75 6.19772 5.75 6.75V17.25C5.75 17.8023 6.19772 18.25 6.75 18.25H17.25C17.8023 18.25 18.25 17.8023 18.25 17.25V9.22487C18.25 8.95966 18.1446 8.7053 17.9571 8.51777L15.4822 6.04289C15.4485 6.0092 15.4127 5.97816 15.375 5.9499V8.375C15.375 9.3415 14.5915 10.125 13.625 10.125H10.375C9.4085 10.125 8.625 9.3415 8.625 8.375V5.75H6.75ZM10.125 5.75H13.875V8.375C13.875 8.51307 13.7631 8.625 13.625 8.625H10.375C10.2369 8.625 10.125 8.51307 10.125 8.375V5.75ZM14.7751 4.25H14.425H9.375H8.625H6.75C5.36929 4.25 4.25 5.36929 4.25 6.75V17.25C4.25 18.6307 5.36929 19.75 6.75 19.75H17.25C18.6307 19.75 19.75 18.6307 19.75 17.25V9.22487C19.75 8.56183 19.4866 7.92595 19.0178 7.45711L16.5429 4.98223C16.0741 4.51339 15.4382 4.25 14.7751 4.25ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H13Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Cancel -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'cancel'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.75 12C5.75 8.54822 8.54822 5.75 12 5.75C15.4518 5.75 18.25 8.54822 18.25 12C18.25 15.4518 15.4518 18.25 12 18.25C8.54822 18.25 5.75 15.4518 5.75 12ZM12 4.25C7.71979 4.25 4.25 7.71979 4.25 12C4.25 16.2802 7.71979 19.75 12 19.75C16.2802 19.75 19.75 16.2802 19.75 12C19.75 7.71979 16.2802 4.25 12 4.25ZM14.8286 9.17157C15.1214 9.46447 15.1214 9.93934 14.8286 10.2322L13.0608 11.9999L14.8287 13.7678C15.1216 14.0607 15.1216 14.5355 14.8287 14.8284C14.5358 15.1213 14.0609 15.1213 13.768 14.8284L12.0002 13.0606L10.2324 14.8284C9.93947 15.1213 9.4646 15.1213 9.1717 14.8284C8.87881 14.5355 8.87881 14.0607 9.1717 13.7678L10.9395 11.9999L9.17182 10.2322C8.87892 9.93935 8.87892 9.46447 9.17182 9.17158C9.46471 8.87869 9.93958 8.87869 10.2325 9.17158L12.0002 10.9393L13.7679 9.17157C14.0608 8.87868 14.5357 8.87868 14.8286 9.17157Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Cut -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'cut'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.25 7.5C5.25 6.5335 6.0335 5.75 7 5.75C7.9665 5.75 8.75 6.5335 8.75 7.5C8.75 8.4665 7.9665 9.25 7 9.25C6.0335 9.25 5.25 8.4665 5.25 7.5ZM7 4.25C5.20507 4.25 3.75 5.70507 3.75 7.5C3.75 9.29493 5.20507 10.75 7 10.75C7.43669 10.75 7.85327 10.6639 8.23367 10.5077L18.9796 16.6511C19.3392 16.8567 19.7974 16.7319 20.003 16.3723C20.2086 16.0127 20.0837 15.5545 19.7241 15.3489L9.54058 9.527C9.98456 8.97126 10.25 8.26663 10.25 7.5C10.25 5.70507 8.79493 4.25 7 4.25Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.25 16.5001C5.25 17.4666 6.0335 18.2501 7 18.2501C7.9665 18.2501 8.75 17.4666 8.75 16.5001C8.75 15.5336 7.9665 14.7501 7 14.7501C6.0335 14.7501 5.25 15.5336 5.25 16.5001ZM7 19.7501C5.20507 19.7501 3.75 18.295 3.75 16.5001C3.75 14.7052 5.20507 13.2501 7 13.2501C7.43669 13.2501 7.85327 13.3363 8.23367 13.4924L18.9796 7.349C19.3392 7.14342 19.7974 7.26827 20.003 7.62787C20.2086 7.98746 20.0837 8.44563 19.7241 8.65121L9.54058 14.4731C9.98456 15.0289 10.25 15.7335 10.25 16.5001C10.25 18.295 8.79493 19.7501 7 19.7501Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Close -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'clear'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.56066 7.43934C8.84197 7.15803 9.2235 7 9.62132 7H17.5C18.3284 7 19 7.67157 19 8.5V15.5C19 16.3284 18.3284 17 17.5 17H9.62132C9.2235 17 8.84196 16.842 8.56066 16.5607L4.70711 12.7071C4.31658 12.3166 4.31658 11.6834 4.70711 11.2929L8.56066 7.43934Z"
      :stroke="iconColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 10L11.5 14"
      :stroke="iconColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 14L11.5 10"
      :stroke="iconColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <!-- Expand -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'expand'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.529 14.5317L7.81066 17.25H10C10.4142 17.25 10.75 17.5858 10.75 18C10.75 18.4142 10.4142 18.75 10 18.75H6C5.58579 18.75 5.25 18.4142 5.25 18V14C5.25 13.5858 5.58579 13.25 6 13.25C6.41421 13.25 6.75 13.5858 6.75 14V16.1893L9.46967 13.4697L11.4697 11.4697C11.4703 11.4691 11.4708 11.4685 11.4714 11.4679L13.4697 9.46967L16.1893 6.75L14 6.75C13.5858 6.75 13.25 6.41421 13.25 6C13.25 5.58579 13.5858 5.25 14 5.25H18C18.4142 5.25 18.75 5.58579 18.75 6L18.75 10C18.75 10.4142 18.4142 10.75 18 10.75C17.5858 10.75 17.25 10.4142 17.25 10L17.25 7.81066L14.5303 10.5303L12.5303 12.5303L10.5303 14.5303C10.5299 14.5308 10.5294 14.5312 10.529 14.5317Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Expand 2 -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'expand2'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="23"
      height="23"
      rx="2.5"
      :fill="$vuetify.theme.dark ? '#333640' : '#FFFFFF'"
      :stroke="$vuetify.theme.dark ? '' : '#C5D1E3'"
    />
    <g clip-path="url(#clip0_1591_25702)">
      <path
        d="M17 9.93756V7.31256C17.0002 7.23864 16.9864 7.16541 16.9596 7.09708C16.9327 7.02875 16.8933 6.96667 16.8435 6.9144C16.7937 6.86213 16.7346 6.8207 16.6695 6.7925C16.6044 6.7643 16.5347 6.74987 16.4643 6.75006H13.9643C13.4868 6.75006 13.248 7.35709 13.5848 7.711L14.3928 8.55943L12 11.0719L9.60647 8.55709L10.4152 7.711C10.752 7.35709 10.5132 6.75006 10.0357 6.75006H7.53572C7.46531 6.74987 7.39557 6.7643 7.3305 6.7925C7.26542 6.8207 7.2063 6.86213 7.15651 6.9144C7.10673 6.96667 7.06728 7.02875 7.04042 7.09708C7.01356 7.16541 6.99983 7.23864 7 7.31256V9.93756C7 10.4391 7.5779 10.6899 7.91518 10.336L8.72299 9.48756L11.1174 12.0001L8.72277 14.5149L7.91518 13.6641C7.57813 13.3102 7 13.561 7 14.0626V16.6876C6.99983 16.7615 7.01356 16.8347 7.04042 16.903C7.06728 16.9714 7.10673 17.0335 7.15651 17.0857C7.2063 17.138 7.26542 17.1794 7.3305 17.2076C7.39557 17.2358 7.46531 17.2502 7.53572 17.2501H10.0357C10.5132 17.2501 10.752 16.643 10.4152 16.2891L9.60714 15.4407L12 12.9282L14.3935 15.443L13.5848 16.2891C13.248 16.643 13.4868 17.2501 13.9643 17.2501H16.4643C16.5347 17.2502 16.6044 17.2358 16.6695 17.2076C16.7346 17.1794 16.7937 17.138 16.8435 17.0857C16.8933 17.0335 16.9327 16.9714 16.9596 16.903C16.9864 16.8347 17.0002 16.7615 17 16.6876V14.0626C17 13.561 16.4221 13.3102 16.0848 13.6641L15.277 14.5126L12.8826 12.0001L15.2772 9.48522L16.0848 10.3337C16.4219 10.6899 17 10.4391 17 9.93756Z"
        :fill="iconColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1591_25702">
        <rect
          width="10"
          height="12"
          fill="white"
          transform="matrix(1 0 0 -1 7 18)"
        />
      </clipPath>
    </defs>
  </svg>

  <!-- Execution -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'execution'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="7"
      :stroke="iconColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 12L10.25 15.4641L10.25 8.5359L15.5 12Z"
      :stroke="iconColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- Testing -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'testing'"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.70833 13.125L13.125 9L6.70833 4.875V13.125ZM2.58333 17.25C2.07917 17.25 1.64742 17.0706 1.28808 16.7119C0.929361 16.3526 0.75 15.9208 0.75 15.4167V2.58333C0.75 2.07917 0.929361 1.64742 1.28808 1.28808C1.64742 0.929361 2.07917 0.75 2.58333 0.75H15.4167C15.9208 0.75 16.3526 0.929361 16.7119 1.28808C17.0706 1.64742 17.25 2.07917 17.25 2.58333V15.4167C17.25 15.9208 17.0706 16.3526 16.7119 16.7119C16.3526 17.0706 15.9208 17.25 15.4167 17.25H2.58333ZM2.58333 15.4167H15.4167V2.58333H2.58333V15.4167Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Close -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'close'"
    :width="12"
    :height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1L1 11"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M11 11L1 0.999999"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>

  <!-- Discard Close -->
  <svg
    v-else-if="iconName === 'dis-close'"
    :width="18"
    :height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 1L1 17" stroke="#4C4F5A" stroke-width="2" />
    <path d="M17 17L1 0.999999" stroke="#4C4F5A" stroke-width="2" />
  </svg>

  <!-- Component Close -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'comp-close'"
    :width="12"
    :height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5.5" fill="white" stroke="#4C4F5A" />
    <path
      d="M8 4L4 8"
      stroke="#4C4F5A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M8 8L4 4"
      stroke="#4C4F5A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>

  <!-- Administrator -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Administrator'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2168 5.06116C12.0882 4.9775 11.9118 4.9775 11.7832 5.06116C10.7458 5.73596 8.51861 7.02116 6.09557 7.34224C5.86142 7.37327 5.75 7.54766 5.75 7.66671V10.3078C5.75 12.3476 6.42104 14.2861 7.60095 15.8591C8.28022 15.4715 9.06656 15.25 9.90463 15.25H14.0951C14.9333 15.25 15.7197 15.4716 16.399 15.8593C17.5789 14.2862 18.25 12.3476 18.25 10.3078V7.66671C18.25 7.54766 18.1386 7.37327 17.9044 7.34224C15.4814 7.02116 13.2542 5.73596 12.2168 5.06116ZM15.3679 17.0173C14.9786 16.8455 14.548 16.75 14.0951 16.75H9.90463C9.45182 16.75 9.02129 16.8454 8.63204 17.0172C9.27082 17.6236 10.0019 18.1439 10.811 18.5549L11.8868 19.1013C11.9579 19.1375 12.0421 19.1375 12.1132 19.1013L13.189 18.5549C13.9981 18.1439 14.7291 17.6237 15.3679 17.0173ZM10.9653 3.80376C11.5912 3.39663 12.4088 3.39663 13.0347 3.80376C14.0219 4.44593 16.019 5.57928 18.1015 5.85524C18.9623 5.96932 19.75 6.68119 19.75 7.66671V10.3078C19.75 14.3551 17.4768 18.0594 13.8683 19.8923L12.7925 20.4387C12.2945 20.6917 11.7055 20.6917 11.2075 20.4387L10.1317 19.8923C6.52321 18.0594 4.25 14.3551 4.25 10.3078V7.66671C4.25 6.68119 5.03768 5.96932 5.89853 5.85524C7.98102 5.57928 9.97807 4.44593 10.9653 3.80376ZM12 8.75004C10.7574 8.75004 9.75 9.7574 9.75 11C9.75 12.2427 10.7574 13.25 12 13.25C13.2426 13.25 14.25 12.2427 14.25 11C14.25 9.7574 13.2426 8.75004 12 8.75004ZM8.25 11C8.25 8.92897 9.92893 7.25004 12 7.25004C14.0711 7.25004 15.75 8.92897 15.75 11C15.75 13.0711 14.0711 14.75 12 14.75C9.92893 14.75 8.25 13.0711 8.25 11Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Communication -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Connector'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.29963 7.01034C9.58148 6.70681 9.5639 6.23226 9.26037 5.95041C8.95684 5.66856 8.48229 5.68613 8.20044 5.98966L4.95044 9.48966C4.74746 9.70826 4.69332 10.0264 4.81255 10.2998C4.93179 10.5732 5.20173 10.75 5.50003 10.75H18.5C18.9142 10.75 19.25 10.4142 19.25 10C19.25 9.58579 18.9142 9.25 18.5 9.25H7.21994L9.29963 7.01034ZM14.7004 16.9897C14.4186 17.2932 14.4361 17.7677 14.7397 18.0496C15.0432 18.3314 15.5177 18.3139 15.7996 18.0103L19.0496 14.5103C19.2526 14.2917 19.3067 13.9736 19.1875 13.7002C19.0682 13.4268 18.7983 13.25 18.5 13.25L5.5 13.25C5.08579 13.25 4.75 13.5858 4.75 14C4.75 14.4142 5.08579 14.75 5.5 14.75L16.7801 14.75L14.7004 16.9897Z"
      :fill="iconColor"
    />
  </svg>
  <!-- AI -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'AI'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9117 9.53909C7.91403 9.52509 7.92103 9.50992 7.9327 9.49359C7.9467 9.47725 7.96303 9.46209 7.9817 9.44809C8.00037 9.43409 8.0202 9.42359 8.0412 9.41659C8.0622 9.40725 8.08203 9.40259 8.1007 9.40259H8.9967C9.03637 9.40259 9.0702 9.41542 9.0982 9.44109C9.1262 9.46442 9.1472 9.48542 9.1612 9.50409L9.2487 9.70359L11.0862 14.4426C11.1049 14.4893 11.1014 14.5278 11.0757 14.5581C11.05 14.5861 11.0057 14.6001 10.9427 14.6001H9.9382C9.88453 14.6001 9.84253 14.5908 9.8122 14.5721C9.7842 14.5511 9.76203 14.5173 9.7457 14.4706C9.69903 14.3516 9.65353 14.2338 9.6092 14.1171C9.56487 13.9981 9.52053 13.8791 9.4762 13.7601H7.6177C7.57337 13.8791 7.52787 13.9981 7.4812 14.1171C7.43687 14.2338 7.39253 14.3516 7.3482 14.4706C7.31787 14.5569 7.25837 14.6001 7.1697 14.6001H6.1372C6.09287 14.6001 6.05553 14.5884 6.0252 14.5651C5.9972 14.5418 5.99253 14.5068 6.0112 14.4601L7.9117 9.53909ZM8.5487 11.0371C8.50437 11.1561 8.45887 11.2844 8.4122 11.4221C8.36787 11.5598 8.32353 11.6986 8.2792 11.8386C8.23487 11.9786 8.18937 12.1174 8.1427 12.2551C8.09837 12.3904 8.05403 12.5176 8.0097 12.6366H9.0842L8.5487 11.0371Z"
      :fill="iconColor"
    />
    <path
      d="M11.7171 9.56359C11.7171 9.51459 11.7299 9.47609 11.7556 9.44809C11.7812 9.41775 11.8197 9.40259 11.8711 9.40259H14.1076C14.2686 9.40259 14.4202 9.42475 14.5626 9.46909C14.7049 9.51342 14.8356 9.57525 14.9546 9.65459C15.0736 9.73159 15.1809 9.82492 15.2766 9.93459C15.3722 10.0419 15.4527 10.1586 15.5181 10.2846C15.5857 10.4106 15.6371 10.5436 15.6721 10.6836C15.7071 10.8213 15.7246 10.9613 15.7246 11.1036C15.7246 11.3136 15.6861 11.5189 15.6091 11.7196C15.5344 11.9203 15.4271 12.0988 15.2871 12.2551C15.1471 12.4114 14.9791 12.5386 14.7831 12.6366C14.5871 12.7323 14.3701 12.7813 14.1321 12.7836H13.0716V14.4496C13.0716 14.5499 13.0179 14.6001 12.9106 14.6001H11.8711C11.8244 14.6001 11.7871 14.5884 11.7591 14.5651C11.7311 14.5394 11.7171 14.5009 11.7171 14.4496V9.56359ZM14.3526 11.0966C14.3526 11.0266 14.3397 10.9566 14.3141 10.8866C14.2907 10.8166 14.2557 10.7548 14.2091 10.7011C14.1624 10.6451 14.1052 10.5996 14.0376 10.5646C13.9722 10.5296 13.8976 10.5121 13.8136 10.5121H13.0716V11.6811H13.8136C13.8976 11.6811 13.9734 11.6648 14.0411 11.6321C14.1087 11.5971 14.1647 11.5528 14.2091 11.4991C14.2557 11.4454 14.2907 11.3836 14.3141 11.3136C14.3397 11.2436 14.3526 11.1713 14.3526 11.0966Z"
      :fill="iconColor"
    />
    <path
      d="M16.5007 9.55659C16.5007 9.51459 16.5135 9.47842 16.5392 9.44809C16.5649 9.41775 16.6034 9.40259 16.6547 9.40259H17.6837C17.7187 9.40259 17.756 9.41659 17.7957 9.44459C17.8354 9.47259 17.8552 9.50992 17.8552 9.55659V14.4461C17.8552 14.5488 17.798 14.6001 17.6837 14.6001H16.6547C16.552 14.6001 16.5007 14.5488 16.5007 14.4461V9.55659Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 5.25C11.0589 5.25 9.32404 6.13579 8.17888 7.52242C8.04403 7.6857 7.91728 7.856 7.79927 8.0327C7.89175 8.01401 7.99259 8.0025 8.1007 8.0025H8.9967C9.21574 8.0025 9.43591 8.04835 9.64081 8.14165C10.5012 7.28096 11.6883 6.75 13 6.75C14.2647 6.75 15.4137 7.24364 16.2656 8.05053C16.4059 8.0156 16.5393 8.0025 16.6547 8.0025H17.6837C17.9022 8.0025 18.093 8.04826 18.252 8.11081C18.1197 7.90611 17.9758 7.70966 17.8211 7.52242C16.676 6.13579 14.9411 5.25 13 5.25ZM19.2552 11.5015V13.2805C19.5622 13.5963 19.75 14.0261 19.75 14.5C19.75 15.4665 18.9665 16.25 18 16.25H17.9924H17.9846H17.9767H17.9685H17.9601H17.9516H17.9429H17.9339H17.9248H17.9155H17.9061H17.8964H17.8866H17.8765H17.8663H17.8559H17.8454H17.8346H17.8237H17.8126H17.8013H17.7898H17.7782H17.7664H17.7544H17.7423H17.7299H17.7174H17.7048H17.6919H17.6789H17.6657H17.6524H17.6389H17.6252H17.6114H17.5974H17.5832H17.5689H17.5544H17.5397H17.5249H17.5099H17.4948H17.4795H17.4641H17.4485H17.4327H17.4168H17.4007H17.3845H17.3682H17.3516H17.335H17.3182H17.3012H17.2841H17.2668H17.2494H17.2319H17.2142H17.1963H17.1783H17.1602H17.1419H17.1235H17.105H17.0863H17.0675H17.0485H17.0294H17.0102H16.9908H16.9713H16.9517H16.9319H16.912H16.892H16.8718H16.8515H16.8311H16.8106H16.7899H16.7691H16.7482H16.7271H16.706H16.6847H16.6633H16.6417H16.6201H16.5983H16.5764H16.5544H16.5323H16.51H16.4877H16.4652H16.4426H16.4199H16.3971H16.3742H16.3511H16.328H16.3047H16.2814H16.2579H16.2343H16.2107H16.1869H16.163H16.139H16.1149H16.0907H16.0664H16.042H16.0175H15.9929H15.9682H15.9434H15.9186H15.8936H15.8685H15.8434H15.8181H15.7927H15.7673H15.7418H15.7162H15.6904H15.6647H15.6388H15.6128H15.5868H15.5606H15.5344H15.5081H15.4817H15.4552H15.4287H15.4021H15.3753H15.3486H15.3217H15.2948H15.2678H15.2407H15.2135H15.1863H15.159H15.1316H15.1041H15.0766H15.049H15.0214H14.9936H14.9659H14.938H14.9101H14.8821H14.854H14.8259H14.7978H14.7695H14.7412H14.7129H14.6845H14.656H14.6275H14.5989H14.5703H14.5416H14.5128H14.484H14.4552H14.4263H14.3973H14.3683H14.3393H14.3102H14.281H14.2518H14.2226H14.1933H14.164H14.1346H14.1052H14.0758H14.0463H14.0168H13.9872H13.9576H13.9279H13.8983H13.8685H13.8388H13.809H13.7792H13.7493H13.7194H13.6895H13.6596H13.6296H13.5996H13.5696H13.5395H13.5094H13.4793H13.4492H13.419H13.3889H13.3587H13.3284H13.2982H13.2679H13.2376H13.2074H13.177H13.1467H13.1164H13.086H13.0556H13.0252H12.9948H12.9644H12.934H12.9036H12.8731H12.8427H12.8122H12.7818H12.7513H12.7208H12.6903H12.6599H12.6294H12.5989H12.5684H12.5379H12.5074H12.477H12.4465H12.416H12.3855H12.3551H12.3246H12.2941H12.2637H12.2333H12.2028H12.1724H12.142H12.1116H12.0812H12.0508H12.0205H11.9901H11.9598H11.9295H11.8992H11.8689H11.8386H11.8084H11.7782H11.748H11.7178H11.6876H11.6575H11.6274H11.5973H11.5673H11.5372H11.5072H11.4773H11.4473H11.4174H11.3875H11.3577H11.3279H11.2981H11.2683H11.2386H11.2089H11.1793H11.1497H11.1201H11.0906H11.0611H11.0316H11.0022H10.9729H10.9435H10.9143H10.885H10.8558H10.8267H10.7976H10.7686H10.7396H10.7106H10.6817H10.6529H10.6241H10.5953H10.5666H10.538H10.5094H10.4809H10.4524H10.424H10.3957H10.3674H10.3392H10.311H10.2829H10.2548H10.2269H10.1989H10.1711H10.1433H10.1156H10.0879H10.0603H10.0328H10.0054H9.978H9.9507H9.92347H9.89631H9.86922H9.84222H9.81528H9.78842H9.76164H9.73494H9.70832H9.68177H9.65531H9.62892H9.60262H9.57641H9.55027H9.52422H9.49826H9.47238H9.44659H9.42088H9.39527H9.36974H9.34431H9.31896H9.29371H9.26855H9.24348H9.21851H9.19363H9.16885H9.14416H9.11958H9.09509H9.07069H9.0464H9.02221H8.99813H8.97414H8.95026H8.92648H8.9028H8.87923H8.85577H8.83242H8.80917H8.78603H8.763H8.74009H8.71728H8.69458H8.672H8.64953H8.62718H8.60494H8.58282H8.56081H8.53893H8.51716H8.49551H8.47398H8.45257H8.43128H8.41012H8.38908H8.36816H8.34737H8.3267H8.30617H8.28575H8.26547H8.24532H8.22529H8.2054H8.18564H8.16601H8.14651H8.12715H8.10793H8.08883H8.06988H8.05106H8.03238H8.01384H7.99544H7.97718H7.95906H7.94108H7.92325H7.90556H7.88801H7.87061H7.85335H7.83625H7.81929H7.80248H7.78581H7.7693H7.75294H7.73673H7.72068H7.70478H7.68903H7.67343H7.658H7.64272H7.62759H7.61263H7.59782H7.58318H7.56869H7.55437H7.54021H7.52621H7.51238H7.49871H7.48521H7.47187H7.4587H7.4457H7.43287H7.42021H7.40772H7.3954H7.38325H7.37127H7.35947H7.34784H7.33639H7.32512H7.31402H7.3031H7.29236H7.28179H7.27141H7.26121H7.25119H7.24136H7.2317H7.22223H7.21295H7.20385H7.19494H7.18622H7.17769H7.16934H7.16118H7.15322H7.14545H7.13787H7.13048H7.12329H7.11629H7.10949H7.10288H7.09647H7.09026H7.08425H7.07844H7.07283H7.06742H7.06221H7.05721H7.0524H7.04781H7.04342H7.03923H7.03526H7.03149H7.02793H7.02457H7.02143H7.0185H7.01579H7.01328H7.01099H7.00891H7.00705H7.0054H7.00398H7.00276H7.00177H7.001H7.00044H7.00011C7.00004 16.25 7 16.25 7 17V16.25C6.5543 16.25 6.13336 16.144 5.76104 15.9558C5.5634 15.9085 5.36052 15.82 5.1716 15.6747C5.15716 15.6636 5.14294 15.6522 5.12894 15.6405C4.91899 15.4656 4.75747 15.232 4.67075 14.9626C4.40419 14.5389 4.25 14.0375 4.25 13.5C4.25 12.3936 4.90339 11.4398 5.84536 11.0034L6.51182 9.27773C4.39453 9.51987 2.75 11.3179 2.75 13.5C2.75 15.8472 4.65279 17.75 7 17.75V17C7 17.75 7.00004 17.75 7.00011 17.75H7.00044H7.001H7.00177H7.00276H7.00398H7.0054H7.00705H7.00891H7.01099H7.01328H7.01579H7.0185H7.02143H7.02457H7.02793H7.03149H7.03526H7.03923H7.04342H7.04781H7.0524H7.05721H7.06221H7.06742H7.07283H7.07844H7.08425H7.09026H7.09647H7.10288H7.10949H7.11629H7.12329H7.13048H7.13787H7.14545H7.15322H7.16118H7.16934H7.17769H7.18622H7.19494H7.20385H7.21295H7.22223H7.2317H7.24136H7.25119H7.26121H7.27141H7.28179H7.29236H7.3031H7.31402H7.32512H7.33639H7.34784H7.35947H7.37127H7.38325H7.3954H7.40772H7.42021H7.43287H7.4457H7.4587H7.47187H7.48521H7.49871H7.51238H7.52621H7.54021H7.55437H7.56869H7.58318H7.59782H7.61263H7.62759H7.64272H7.658H7.67343H7.68903H7.70478H7.72068H7.73673H7.75294H7.7693H7.78581H7.80248H7.81929H7.83625H7.85335H7.87061H7.88801H7.90556H7.92325H7.94108H7.95906H7.97718H7.99544H8.01384H8.03238H8.05106H8.06988H8.08883H8.10793H8.12715H8.14651H8.16601H8.18564H8.2054H8.22529H8.24532H8.26547H8.28575H8.30617H8.3267H8.34737H8.36816H8.38908H8.41012H8.43128H8.45257H8.47398H8.49551H8.51716H8.53893H8.56081H8.58282H8.60494H8.62718H8.64953H8.672H8.69458H8.71728H8.74009H8.763H8.78603H8.80917H8.83242H8.85577H8.87923H8.9028H8.92648H8.95026H8.97414H8.99813H9.02221H9.0464H9.07069H9.09509H9.11958H9.14416H9.16885H9.19363H9.21851H9.24348H9.26855H9.29371H9.31896H9.34431H9.36974H9.39527H9.42088H9.44659H9.47238H9.49826H9.52422H9.55027H9.57641H9.60262H9.62892H9.65531H9.68177H9.70832H9.73494H9.76164H9.78842H9.81528H9.84222H9.86922H9.89631H9.92347H9.9507H9.978H10.0054H10.0328H10.0603H10.0879H10.1156H10.1433H10.1711H10.1989H10.2269H10.2548H10.2829H10.311H10.3392H10.3674H10.3957H10.424H10.4524H10.4809H10.5094H10.538H10.5666H10.5953H10.6241H10.6529H10.6817H10.7106H10.7396H10.7686H10.7976H10.8267H10.8558H10.885H10.9143H10.9435H10.9729H11.0022H11.0316H11.0611H11.0906H11.1201H11.1497H11.1793H11.2089H11.2386H11.2683H11.2981H11.3279H11.3577H11.3875H11.4174H11.4473H11.4773H11.5072H11.5372H11.5673H11.5973H11.6274H11.6575H11.6876H11.7178H11.748H11.7782H11.8084H11.8386H11.8689H11.8992H11.9295H11.9598H11.9901H12.0205H12.0508H12.0812H12.1116H12.142H12.1724H12.2028H12.2333H12.2637H12.2941H12.3246H12.3551H12.3855H12.416H12.4465H12.477H12.5074H12.5379H12.5684H12.5989H12.6294H12.6599H12.6903H12.7208H12.7513H12.7818H12.8122H12.8427H12.8731H12.9036H12.934H12.9644H12.9948H13.0252H13.0556H13.086H13.1164H13.1467H13.177H13.2074H13.2376H13.2679H13.2982H13.3284H13.3587H13.3889H13.419H13.4492H13.4793H13.5094H13.5395H13.5696H13.5996H13.6296H13.6596H13.6895H13.7194H13.7493H13.7792H13.809H13.8388H13.8685H13.8983H13.9279H13.9576H13.9872H14.0168H14.0463H14.0758H14.1052H14.1346H14.164H14.1933H14.2226H14.2518H14.281H14.3102H14.3393H14.3683H14.3973H14.4263H14.4552H14.484H14.5128H14.5416H14.5703H14.5989H14.6275H14.656H14.6845H14.7129H14.7412H14.7695H14.7978H14.8259H14.854H14.8821H14.9101H14.938H14.9659H14.9936H15.0214H15.049H15.0766H15.1041H15.1316H15.159H15.1863H15.2135H15.2407H15.2678H15.2948H15.3217H15.3486H15.3753H15.4021H15.4287H15.4552H15.4817H15.5081H15.5344H15.5606H15.5868H15.6128H15.6388H15.6647H15.6904H15.7162H15.7418H15.7673H15.7927H15.8181H15.8434H15.8685H15.8936H15.9186H15.9434H15.9682H15.9929H16.0175H16.042H16.0664H16.0907H16.1149H16.139H16.163H16.1869H16.2107H16.2343H16.2579H16.2814H16.3047H16.328H16.3511H16.3742H16.3971H16.4199H16.4426H16.4652H16.4877H16.51H16.5323H16.5544H16.5764H16.5983H16.6201H16.6417H16.6633H16.6847H16.706H16.7271H16.7482H16.7691H16.7899H16.8106H16.8311H16.8515H16.8718H16.892H16.912H16.9319H16.9517H16.9713H16.9908H17.0102H17.0294H17.0485H17.0675H17.0863H17.105H17.1235H17.1419H17.1602H17.1783H17.1963H17.2142H17.2319H17.2494H17.2668H17.2841H17.3012H17.3182H17.335H17.3516H17.3682H17.3845H17.4007H17.4168H17.4327H17.4485H17.4641H17.4795H17.4948H17.5099H17.5249H17.5397H17.5544H17.5689H17.5832H17.5974H17.6114H17.6252H17.6389H17.6524H17.6657H17.6789H17.6919H17.7048H17.7174H17.7299H17.7423H17.7544H17.7664H17.7782H17.7898H17.8013H17.8126H17.8237H17.8346H17.8454H17.8559H17.8663H17.8765H17.8866H17.8964H17.9061H17.9155H17.9248H17.9339H17.9429H17.9516H17.9601H17.9685H17.9767H17.9846H17.9924H18C19.7949 17.75 21.25 16.2949 21.25 14.5C21.25 13.4364 20.7383 12.4921 19.9508 11.9004C19.7379 11.7405 19.5045 11.6059 19.2552 11.5015ZM7.43109 10.7835C7.43109 10.7835 7.43108 10.7835 7.43108 10.7835L7.9117 9.539C7.91403 9.525 7.92103 9.50984 7.9327 9.4935C7.9467 9.47717 7.96303 9.462 7.9817 9.448C8.00037 9.434 8.0202 9.4235 8.0412 9.4165C8.0622 9.40717 8.08203 9.4025 8.1007 9.4025H8.73682C8.73682 9.40251 8.73681 9.40252 8.73681 9.40253H8.1007C8.08203 9.40253 8.0622 9.40719 8.0412 9.41653C8.0202 9.42353 8.00037 9.43403 7.9817 9.44803C7.96303 9.46203 7.9467 9.47719 7.9327 9.49353C7.92103 9.50986 7.91403 9.52503 7.9117 9.53903L7.43109 10.7835ZM17.2632 9.40253H17.6837C17.7187 9.40253 17.756 9.41653 17.7957 9.44453C17.8152 9.45831 17.83 9.47435 17.8399 9.49265C17.83 9.47434 17.8152 9.45829 17.7957 9.4445C17.756 9.4165 17.7187 9.4025 17.6837 9.4025H17.2632C17.2632 9.40251 17.2632 9.40252 17.2632 9.40253Z"
      :fill="iconColor"
    />
  </svg>
  <!-- API -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'API'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9117 9.53909C7.91403 9.52509 7.92103 9.50992 7.9327 9.49359C7.9467 9.47725 7.96303 9.46209 7.9817 9.44809C8.00037 9.43409 8.0202 9.42359 8.0412 9.41659C8.0622 9.40725 8.08203 9.40259 8.1007 9.40259H8.9967C9.03637 9.40259 9.0702 9.41542 9.0982 9.44109C9.1262 9.46442 9.1472 9.48542 9.1612 9.50409L9.2487 9.70359L11.0862 14.4426C11.1049 14.4893 11.1014 14.5278 11.0757 14.5581C11.05 14.5861 11.0057 14.6001 10.9427 14.6001H9.9382C9.88453 14.6001 9.84253 14.5908 9.8122 14.5721C9.7842 14.5511 9.76203 14.5173 9.7457 14.4706C9.69903 14.3516 9.65353 14.2338 9.6092 14.1171C9.56487 13.9981 9.52053 13.8791 9.4762 13.7601H7.6177C7.57337 13.8791 7.52787 13.9981 7.4812 14.1171C7.43687 14.2338 7.39253 14.3516 7.3482 14.4706C7.31787 14.5569 7.25837 14.6001 7.1697 14.6001H6.1372C6.09287 14.6001 6.05553 14.5884 6.0252 14.5651C5.9972 14.5418 5.99253 14.5068 6.0112 14.4601L7.9117 9.53909ZM8.5487 11.0371C8.50437 11.1561 8.45887 11.2844 8.4122 11.4221C8.36787 11.5598 8.32353 11.6986 8.2792 11.8386C8.23487 11.9786 8.18937 12.1174 8.1427 12.2551C8.09837 12.3904 8.05403 12.5176 8.0097 12.6366H9.0842L8.5487 11.0371Z"
      :fill="iconColor"
    />
    <path
      d="M11.7171 9.56359C11.7171 9.51459 11.7299 9.47609 11.7556 9.44809C11.7812 9.41775 11.8197 9.40259 11.8711 9.40259H14.1076C14.2686 9.40259 14.4202 9.42475 14.5626 9.46909C14.7049 9.51342 14.8356 9.57525 14.9546 9.65459C15.0736 9.73159 15.1809 9.82492 15.2766 9.93459C15.3722 10.0419 15.4527 10.1586 15.5181 10.2846C15.5857 10.4106 15.6371 10.5436 15.6721 10.6836C15.7071 10.8213 15.7246 10.9613 15.7246 11.1036C15.7246 11.3136 15.6861 11.5189 15.6091 11.7196C15.5344 11.9203 15.4271 12.0988 15.2871 12.2551C15.1471 12.4114 14.9791 12.5386 14.7831 12.6366C14.5871 12.7323 14.3701 12.7813 14.1321 12.7836H13.0716V14.4496C13.0716 14.5499 13.0179 14.6001 12.9106 14.6001H11.8711C11.8244 14.6001 11.7871 14.5884 11.7591 14.5651C11.7311 14.5394 11.7171 14.5009 11.7171 14.4496V9.56359ZM14.3526 11.0966C14.3526 11.0266 14.3397 10.9566 14.3141 10.8866C14.2907 10.8166 14.2557 10.7548 14.2091 10.7011C14.1624 10.6451 14.1052 10.5996 14.0376 10.5646C13.9722 10.5296 13.8976 10.5121 13.8136 10.5121H13.0716V11.6811H13.8136C13.8976 11.6811 13.9734 11.6648 14.0411 11.6321C14.1087 11.5971 14.1647 11.5528 14.2091 11.4991C14.2557 11.4454 14.2907 11.3836 14.3141 11.3136C14.3397 11.2436 14.3526 11.1713 14.3526 11.0966Z"
      :fill="iconColor"
    />
    <path
      d="M16.5007 9.55659C16.5007 9.51459 16.5135 9.47842 16.5392 9.44809C16.5649 9.41775 16.6034 9.40259 16.6547 9.40259H17.6837C17.7187 9.40259 17.756 9.41659 17.7957 9.44459C17.8354 9.47259 17.8552 9.50992 17.8552 9.55659V14.4461C17.8552 14.5488 17.798 14.6001 17.6837 14.6001H16.6547C16.552 14.6001 16.5007 14.5488 16.5007 14.4461V9.55659Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 5.25C11.0589 5.25 9.32404 6.13579 8.17888 7.52242C8.04403 7.6857 7.91728 7.856 7.79927 8.0327C7.89175 8.01401 7.99259 8.0025 8.1007 8.0025H8.9967C9.21574 8.0025 9.43591 8.04835 9.64081 8.14165C10.5012 7.28096 11.6883 6.75 13 6.75C14.2647 6.75 15.4137 7.24364 16.2656 8.05053C16.4059 8.0156 16.5393 8.0025 16.6547 8.0025H17.6837C17.9022 8.0025 18.093 8.04826 18.252 8.11081C18.1197 7.90611 17.9758 7.70966 17.8211 7.52242C16.676 6.13579 14.9411 5.25 13 5.25ZM19.2552 11.5015V13.2805C19.5622 13.5963 19.75 14.0261 19.75 14.5C19.75 15.4665 18.9665 16.25 18 16.25H17.9924H17.9846H17.9767H17.9685H17.9601H17.9516H17.9429H17.9339H17.9248H17.9155H17.9061H17.8964H17.8866H17.8765H17.8663H17.8559H17.8454H17.8346H17.8237H17.8126H17.8013H17.7898H17.7782H17.7664H17.7544H17.7423H17.7299H17.7174H17.7048H17.6919H17.6789H17.6657H17.6524H17.6389H17.6252H17.6114H17.5974H17.5832H17.5689H17.5544H17.5397H17.5249H17.5099H17.4948H17.4795H17.4641H17.4485H17.4327H17.4168H17.4007H17.3845H17.3682H17.3516H17.335H17.3182H17.3012H17.2841H17.2668H17.2494H17.2319H17.2142H17.1963H17.1783H17.1602H17.1419H17.1235H17.105H17.0863H17.0675H17.0485H17.0294H17.0102H16.9908H16.9713H16.9517H16.9319H16.912H16.892H16.8718H16.8515H16.8311H16.8106H16.7899H16.7691H16.7482H16.7271H16.706H16.6847H16.6633H16.6417H16.6201H16.5983H16.5764H16.5544H16.5323H16.51H16.4877H16.4652H16.4426H16.4199H16.3971H16.3742H16.3511H16.328H16.3047H16.2814H16.2579H16.2343H16.2107H16.1869H16.163H16.139H16.1149H16.0907H16.0664H16.042H16.0175H15.9929H15.9682H15.9434H15.9186H15.8936H15.8685H15.8434H15.8181H15.7927H15.7673H15.7418H15.7162H15.6904H15.6647H15.6388H15.6128H15.5868H15.5606H15.5344H15.5081H15.4817H15.4552H15.4287H15.4021H15.3753H15.3486H15.3217H15.2948H15.2678H15.2407H15.2135H15.1863H15.159H15.1316H15.1041H15.0766H15.049H15.0214H14.9936H14.9659H14.938H14.9101H14.8821H14.854H14.8259H14.7978H14.7695H14.7412H14.7129H14.6845H14.656H14.6275H14.5989H14.5703H14.5416H14.5128H14.484H14.4552H14.4263H14.3973H14.3683H14.3393H14.3102H14.281H14.2518H14.2226H14.1933H14.164H14.1346H14.1052H14.0758H14.0463H14.0168H13.9872H13.9576H13.9279H13.8983H13.8685H13.8388H13.809H13.7792H13.7493H13.7194H13.6895H13.6596H13.6296H13.5996H13.5696H13.5395H13.5094H13.4793H13.4492H13.419H13.3889H13.3587H13.3284H13.2982H13.2679H13.2376H13.2074H13.177H13.1467H13.1164H13.086H13.0556H13.0252H12.9948H12.9644H12.934H12.9036H12.8731H12.8427H12.8122H12.7818H12.7513H12.7208H12.6903H12.6599H12.6294H12.5989H12.5684H12.5379H12.5074H12.477H12.4465H12.416H12.3855H12.3551H12.3246H12.2941H12.2637H12.2333H12.2028H12.1724H12.142H12.1116H12.0812H12.0508H12.0205H11.9901H11.9598H11.9295H11.8992H11.8689H11.8386H11.8084H11.7782H11.748H11.7178H11.6876H11.6575H11.6274H11.5973H11.5673H11.5372H11.5072H11.4773H11.4473H11.4174H11.3875H11.3577H11.3279H11.2981H11.2683H11.2386H11.2089H11.1793H11.1497H11.1201H11.0906H11.0611H11.0316H11.0022H10.9729H10.9435H10.9143H10.885H10.8558H10.8267H10.7976H10.7686H10.7396H10.7106H10.6817H10.6529H10.6241H10.5953H10.5666H10.538H10.5094H10.4809H10.4524H10.424H10.3957H10.3674H10.3392H10.311H10.2829H10.2548H10.2269H10.1989H10.1711H10.1433H10.1156H10.0879H10.0603H10.0328H10.0054H9.978H9.9507H9.92347H9.89631H9.86922H9.84222H9.81528H9.78842H9.76164H9.73494H9.70832H9.68177H9.65531H9.62892H9.60262H9.57641H9.55027H9.52422H9.49826H9.47238H9.44659H9.42088H9.39527H9.36974H9.34431H9.31896H9.29371H9.26855H9.24348H9.21851H9.19363H9.16885H9.14416H9.11958H9.09509H9.07069H9.0464H9.02221H8.99813H8.97414H8.95026H8.92648H8.9028H8.87923H8.85577H8.83242H8.80917H8.78603H8.763H8.74009H8.71728H8.69458H8.672H8.64953H8.62718H8.60494H8.58282H8.56081H8.53893H8.51716H8.49551H8.47398H8.45257H8.43128H8.41012H8.38908H8.36816H8.34737H8.3267H8.30617H8.28575H8.26547H8.24532H8.22529H8.2054H8.18564H8.16601H8.14651H8.12715H8.10793H8.08883H8.06988H8.05106H8.03238H8.01384H7.99544H7.97718H7.95906H7.94108H7.92325H7.90556H7.88801H7.87061H7.85335H7.83625H7.81929H7.80248H7.78581H7.7693H7.75294H7.73673H7.72068H7.70478H7.68903H7.67343H7.658H7.64272H7.62759H7.61263H7.59782H7.58318H7.56869H7.55437H7.54021H7.52621H7.51238H7.49871H7.48521H7.47187H7.4587H7.4457H7.43287H7.42021H7.40772H7.3954H7.38325H7.37127H7.35947H7.34784H7.33639H7.32512H7.31402H7.3031H7.29236H7.28179H7.27141H7.26121H7.25119H7.24136H7.2317H7.22223H7.21295H7.20385H7.19494H7.18622H7.17769H7.16934H7.16118H7.15322H7.14545H7.13787H7.13048H7.12329H7.11629H7.10949H7.10288H7.09647H7.09026H7.08425H7.07844H7.07283H7.06742H7.06221H7.05721H7.0524H7.04781H7.04342H7.03923H7.03526H7.03149H7.02793H7.02457H7.02143H7.0185H7.01579H7.01328H7.01099H7.00891H7.00705H7.0054H7.00398H7.00276H7.00177H7.001H7.00044H7.00011C7.00004 16.25 7 16.25 7 17V16.25C6.5543 16.25 6.13336 16.144 5.76104 15.9558C5.5634 15.9085 5.36052 15.82 5.1716 15.6747C5.15716 15.6636 5.14294 15.6522 5.12894 15.6405C4.91899 15.4656 4.75747 15.232 4.67075 14.9626C4.40419 14.5389 4.25 14.0375 4.25 13.5C4.25 12.3936 4.90339 11.4398 5.84536 11.0034L6.51182 9.27773C4.39453 9.51987 2.75 11.3179 2.75 13.5C2.75 15.8472 4.65279 17.75 7 17.75V17C7 17.75 7.00004 17.75 7.00011 17.75H7.00044H7.001H7.00177H7.00276H7.00398H7.0054H7.00705H7.00891H7.01099H7.01328H7.01579H7.0185H7.02143H7.02457H7.02793H7.03149H7.03526H7.03923H7.04342H7.04781H7.0524H7.05721H7.06221H7.06742H7.07283H7.07844H7.08425H7.09026H7.09647H7.10288H7.10949H7.11629H7.12329H7.13048H7.13787H7.14545H7.15322H7.16118H7.16934H7.17769H7.18622H7.19494H7.20385H7.21295H7.22223H7.2317H7.24136H7.25119H7.26121H7.27141H7.28179H7.29236H7.3031H7.31402H7.32512H7.33639H7.34784H7.35947H7.37127H7.38325H7.3954H7.40772H7.42021H7.43287H7.4457H7.4587H7.47187H7.48521H7.49871H7.51238H7.52621H7.54021H7.55437H7.56869H7.58318H7.59782H7.61263H7.62759H7.64272H7.658H7.67343H7.68903H7.70478H7.72068H7.73673H7.75294H7.7693H7.78581H7.80248H7.81929H7.83625H7.85335H7.87061H7.88801H7.90556H7.92325H7.94108H7.95906H7.97718H7.99544H8.01384H8.03238H8.05106H8.06988H8.08883H8.10793H8.12715H8.14651H8.16601H8.18564H8.2054H8.22529H8.24532H8.26547H8.28575H8.30617H8.3267H8.34737H8.36816H8.38908H8.41012H8.43128H8.45257H8.47398H8.49551H8.51716H8.53893H8.56081H8.58282H8.60494H8.62718H8.64953H8.672H8.69458H8.71728H8.74009H8.763H8.78603H8.80917H8.83242H8.85577H8.87923H8.9028H8.92648H8.95026H8.97414H8.99813H9.02221H9.0464H9.07069H9.09509H9.11958H9.14416H9.16885H9.19363H9.21851H9.24348H9.26855H9.29371H9.31896H9.34431H9.36974H9.39527H9.42088H9.44659H9.47238H9.49826H9.52422H9.55027H9.57641H9.60262H9.62892H9.65531H9.68177H9.70832H9.73494H9.76164H9.78842H9.81528H9.84222H9.86922H9.89631H9.92347H9.9507H9.978H10.0054H10.0328H10.0603H10.0879H10.1156H10.1433H10.1711H10.1989H10.2269H10.2548H10.2829H10.311H10.3392H10.3674H10.3957H10.424H10.4524H10.4809H10.5094H10.538H10.5666H10.5953H10.6241H10.6529H10.6817H10.7106H10.7396H10.7686H10.7976H10.8267H10.8558H10.885H10.9143H10.9435H10.9729H11.0022H11.0316H11.0611H11.0906H11.1201H11.1497H11.1793H11.2089H11.2386H11.2683H11.2981H11.3279H11.3577H11.3875H11.4174H11.4473H11.4773H11.5072H11.5372H11.5673H11.5973H11.6274H11.6575H11.6876H11.7178H11.748H11.7782H11.8084H11.8386H11.8689H11.8992H11.9295H11.9598H11.9901H12.0205H12.0508H12.0812H12.1116H12.142H12.1724H12.2028H12.2333H12.2637H12.2941H12.3246H12.3551H12.3855H12.416H12.4465H12.477H12.5074H12.5379H12.5684H12.5989H12.6294H12.6599H12.6903H12.7208H12.7513H12.7818H12.8122H12.8427H12.8731H12.9036H12.934H12.9644H12.9948H13.0252H13.0556H13.086H13.1164H13.1467H13.177H13.2074H13.2376H13.2679H13.2982H13.3284H13.3587H13.3889H13.419H13.4492H13.4793H13.5094H13.5395H13.5696H13.5996H13.6296H13.6596H13.6895H13.7194H13.7493H13.7792H13.809H13.8388H13.8685H13.8983H13.9279H13.9576H13.9872H14.0168H14.0463H14.0758H14.1052H14.1346H14.164H14.1933H14.2226H14.2518H14.281H14.3102H14.3393H14.3683H14.3973H14.4263H14.4552H14.484H14.5128H14.5416H14.5703H14.5989H14.6275H14.656H14.6845H14.7129H14.7412H14.7695H14.7978H14.8259H14.854H14.8821H14.9101H14.938H14.9659H14.9936H15.0214H15.049H15.0766H15.1041H15.1316H15.159H15.1863H15.2135H15.2407H15.2678H15.2948H15.3217H15.3486H15.3753H15.4021H15.4287H15.4552H15.4817H15.5081H15.5344H15.5606H15.5868H15.6128H15.6388H15.6647H15.6904H15.7162H15.7418H15.7673H15.7927H15.8181H15.8434H15.8685H15.8936H15.9186H15.9434H15.9682H15.9929H16.0175H16.042H16.0664H16.0907H16.1149H16.139H16.163H16.1869H16.2107H16.2343H16.2579H16.2814H16.3047H16.328H16.3511H16.3742H16.3971H16.4199H16.4426H16.4652H16.4877H16.51H16.5323H16.5544H16.5764H16.5983H16.6201H16.6417H16.6633H16.6847H16.706H16.7271H16.7482H16.7691H16.7899H16.8106H16.8311H16.8515H16.8718H16.892H16.912H16.9319H16.9517H16.9713H16.9908H17.0102H17.0294H17.0485H17.0675H17.0863H17.105H17.1235H17.1419H17.1602H17.1783H17.1963H17.2142H17.2319H17.2494H17.2668H17.2841H17.3012H17.3182H17.335H17.3516H17.3682H17.3845H17.4007H17.4168H17.4327H17.4485H17.4641H17.4795H17.4948H17.5099H17.5249H17.5397H17.5544H17.5689H17.5832H17.5974H17.6114H17.6252H17.6389H17.6524H17.6657H17.6789H17.6919H17.7048H17.7174H17.7299H17.7423H17.7544H17.7664H17.7782H17.7898H17.8013H17.8126H17.8237H17.8346H17.8454H17.8559H17.8663H17.8765H17.8866H17.8964H17.9061H17.9155H17.9248H17.9339H17.9429H17.9516H17.9601H17.9685H17.9767H17.9846H17.9924H18C19.7949 17.75 21.25 16.2949 21.25 14.5C21.25 13.4364 20.7383 12.4921 19.9508 11.9004C19.7379 11.7405 19.5045 11.6059 19.2552 11.5015ZM7.43109 10.7835C7.43109 10.7835 7.43108 10.7835 7.43108 10.7835L7.9117 9.539C7.91403 9.525 7.92103 9.50984 7.9327 9.4935C7.9467 9.47717 7.96303 9.462 7.9817 9.448C8.00037 9.434 8.0202 9.4235 8.0412 9.4165C8.0622 9.40717 8.08203 9.4025 8.1007 9.4025H8.73682C8.73682 9.40251 8.73681 9.40252 8.73681 9.40253H8.1007C8.08203 9.40253 8.0622 9.40719 8.0412 9.41653C8.0202 9.42353 8.00037 9.43403 7.9817 9.44803C7.96303 9.46203 7.9467 9.47719 7.9327 9.49353C7.92103 9.50986 7.91403 9.52503 7.9117 9.53903L7.43109 10.7835ZM17.2632 9.40253H17.6837C17.7187 9.40253 17.756 9.41653 17.7957 9.44453C17.8152 9.45831 17.83 9.47435 17.8399 9.49265C17.83 9.47434 17.8152 9.45829 17.7957 9.4445C17.756 9.4165 17.7187 9.4025 17.6837 9.4025H17.2632C17.2632 9.40251 17.2632 9.40252 17.2632 9.40253Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Dashboard -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Dashboard'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 4.25C5.41421 4.25 5.75 4.58579 5.75 5V18.25H19C19.4142 18.25 19.75 18.5858 19.75 19C19.75 19.4142 19.4142 19.75 19 19.75H5C4.58579 19.75 4.25 19.4142 4.25 19V5C4.25 4.58579 4.58579 4.25 5 4.25Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.9 10.6C9.39706 10.6 9.8 11.0029 9.8 11.5V15.5C9.8 15.997 9.39706 16.4 8.9 16.4C8.40294 16.4 8 15.997 8 15.5V11.5C8 11.0029 8.40294 10.6 8.9 10.6Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9 7.59998C13.3971 7.59998 13.8 8.00292 13.8 8.49998V15.5C13.8 15.997 13.3971 16.4 12.9 16.4C12.4029 16.4 12 15.997 12 15.5V8.49998C12 8.00292 12.4029 7.59998 12.9 7.59998Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9 9.59998C17.3971 9.59998 17.8 10.0029 17.8 10.5V15.5C17.8 15.997 17.3971 16.4 16.9 16.4C16.4029 16.4 16 15.997 16 15.5V10.5C16 10.0029 16.4029 9.59998 16.9 9.59998Z"
      :fill="iconColor"
    />
  </svg>
  <!-- DLB -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'DLB'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="9" y="15" width="6" height="1" rx="0.5" :fill="iconColor" />
    <rect x="9" y="11.5" width="2" height="2" rx="1" :fill="iconColor" />
    <rect x="13" y="11.5" width="2" height="2" rx="1" :fill="iconColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 5C10.25 4.0335 11.0335 3.25 12 3.25C12.9665 3.25 13.75 4.0335 13.75 5C13.75 5.70484 13.3333 6.31236 12.7328 6.58964C12.7441 6.64131 12.75 6.69496 12.75 6.75V7.25H15C16.8451 7.25 18.3789 8.58253 18.6917 10.3377C19.8757 10.6445 20.75 11.7201 20.75 13C20.75 14.2588 19.9043 15.32 18.75 15.6465V16C18.75 18.0711 17.0711 19.75 15 19.75H9C6.92893 19.75 5.25 18.0711 5.25 16V15.6465C4.09575 15.32 3.25 14.2588 3.25 13C3.25 11.7201 4.12434 10.6445 5.3083 10.3377C5.62106 8.58253 7.15492 7.25 9 7.25H11.25V6.75C11.25 6.69496 11.2559 6.64131 11.2672 6.58964C10.6667 6.31236 10.25 5.70484 10.25 5ZM17.25 15V11C17.25 9.75736 16.2426 8.75 15 8.75H9C7.75736 8.75 6.75 9.75736 6.75 11V15V16C6.75 17.2426 7.75736 18.25 9 18.25H15C16.2426 18.25 17.25 17.2426 17.25 16V15ZM18.75 14.0001C19.0536 13.772 19.25 13.409 19.25 13C19.25 12.591 19.0536 12.228 18.75 11.9999V14.0001ZM4.75 13C4.75 12.591 4.94639 12.228 5.25 11.9999V14.0001C4.94639 13.772 4.75 13.409 4.75 13ZM12 4.75C11.8619 4.75 11.75 4.86193 11.75 5C11.75 5.13807 11.8619 5.25 12 5.25C12.1381 5.25 12.25 5.13807 12.25 5C12.25 4.86193 12.1381 4.75 12 4.75Z"
      :fill="iconColor"
    />
  </svg>
  <!-- EDI Asset -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'EDI Asset'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.75 7.75H7V12.3748C6.34174 12.604 5.81105 13.1325 5.59323 13.8244L5.5 14.1205V9C5.5 8.30964 6.05964 7.75 6.75 7.75ZM7.4764 19.75H6.75C5.23122 19.75 4 18.5188 4 17V9C4 7.48122 5.23122 6.25 6.75 6.25H7.01772C7.13903 5.40193 7.86838 4.75 8.75 4.75H15.75C16.7165 4.75 17.5 5.5335 17.5 6.5V9.35352C18.6543 9.67998 19.5 10.7412 19.5 12V12.2535C20.6221 12.3239 21.3997 13.4342 21.0562 14.5255L20.0172 17.8258C19.6567 18.971 18.5948 19.75 17.3941 19.75H7.47655C7.4765 19.75 7.47645 19.75 7.4764 19.75ZM18 12.25V12C18 11.591 17.8036 11.228 17.5 10.9999V12.25H18ZM16 12.25V6.5C16 6.36193 15.8881 6.25 15.75 6.25H8.75C8.61193 6.25 8.5 6.36193 8.5 6.5V12.25H16ZM7.75 13.75H7.73939C7.41194 13.75 7.12234 13.9624 7.02401 14.2748L6.28424 16.6246C6.03067 17.4301 6.63214 18.25 7.47655 18.25H17.3941C17.9399 18.25 18.4226 17.8959 18.5864 17.3754L19.6254 14.0751C19.6761 13.914 19.5558 13.75 19.387 13.75H16.75H7.75ZM9.5 8.5C9.5 8.22386 9.72386 8 10 8H14.5C14.7761 8 15 8.22386 15 8.5C15 8.77614 14.7761 9 14.5 9H10C9.72386 9 9.5 8.77614 9.5 8.5ZM10 10.5C9.72386 10.5 9.5 10.7239 9.5 11C9.5 11.2761 9.72386 11.5 10 11.5H14.5C14.7761 11.5 15 11.2761 15 11C15 10.7239 14.7761 10.5 14.5 10.5H10Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Integration SET -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Integration SETs'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0005 4C12.4147 4 12.7505 4.33579 12.7505 4.75V9.11371L13.2343 8.62995C13.5271 8.33706 14.002 8.33706 14.2949 8.62995C14.5878 8.92284 14.5878 9.39772 14.2949 9.69061L12.5308 11.4547C12.2379 11.7476 11.763 11.7476 11.4701 11.4547L9.706 9.69061C9.41311 9.39772 9.41311 8.92284 9.706 8.62995C9.99889 8.33706 10.4738 8.33706 10.7667 8.62995L11.2505 9.11378V4.75C11.2505 4.33579 11.5863 4 12.0005 4ZM18.0726 16.8173C18.4314 17.0245 18.8901 16.9015 19.0972 16.5428C19.3043 16.1841 19.1814 15.7254 18.8226 15.5183L15.0435 13.3364L15.7048 13.1592C16.1049 13.052 16.3423 12.6408 16.2351 12.2407C16.1279 11.8406 15.7166 11.6031 15.3165 11.7104L12.9067 12.3561C12.5066 12.4633 12.2691 12.8745 12.3764 13.2746L13.0221 15.6845C13.1293 16.0846 13.5405 16.322 13.9406 16.2148C14.3407 16.1076 14.5782 15.6963 14.471 15.2962L14.294 14.6357L18.0726 16.8173ZM5.17296 15.5126C4.81424 15.7197 4.69133 16.1784 4.89844 16.5371C5.10554 16.8958 5.56424 17.0188 5.92296 16.8116L9.70175 14.63L9.52468 15.2908C9.41748 15.6909 9.65491 16.1021 10.055 16.2093C10.4551 16.3165 10.8664 16.0791 10.9736 15.679L11.6193 13.2692C11.7265 12.8691 11.4891 12.4578 11.089 12.3506L8.67912 11.7049C8.27902 11.5977 7.86776 11.8351 7.76056 12.2352C7.65335 12.6353 7.89079 13.0466 8.29089 13.1538L8.95184 13.3309L5.17296 15.5126ZM4.25 12C4.25 8.5946 6.44637 5.70221 9.49979 4.66213V6.27013C7.29252 7.23462 5.75 9.43717 5.75 12C5.75 12.4836 5.80492 12.9543 5.90886 13.4063L4.56198 14.184C4.35892 13.4913 4.25 12.7583 4.25 12ZM18.25 12C18.25 12.4661 18.199 12.9202 18.1022 13.3572L19.4518 14.1363C19.646 13.4577 19.75 12.741 19.75 12C19.75 8.59445 17.5534 5.70195 14.4998 4.66199V6.26995C16.7073 7.23435 18.25 9.43701 18.25 12ZM12 18.25C10.8807 18.25 9.83021 17.9558 8.9215 17.4405L7.462 18.2831C8.73756 19.206 10.3053 19.75 12 19.75C13.7136 19.75 15.2974 19.1938 16.5806 18.2521L15.1268 17.4128C14.2071 17.9452 13.1391 18.25 12 18.25Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Management -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Management'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 5.75C10.4812 5.75 9.25 6.98122 9.25 8.5C9.25 10.0188 10.4812 11.25 12 11.25C13.5188 11.25 14.75 10.0188 14.75 8.5C14.75 6.98122 13.5188 5.75 12 5.75ZM7.75 8.5C7.75 6.15279 9.65279 4.25 12 4.25C14.3472 4.25 16.25 6.15279 16.25 8.5C16.25 10.8472 14.3472 12.75 12 12.75C9.65279 12.75 7.75 10.8472 7.75 8.5Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.974 15.25H9.88095C7.81402 15.25 6.10164 16.768 5.79788 18.75H13.5858C13.575 18.8516 13.5951 18.9574 13.6501 19.0527L14.1973 20.0004C14.2858 20.1537 14.4432 20.2424 14.6078 20.25H5.11905C4.63908 20.25 4.25 19.8609 4.25 19.381C4.25 16.2711 6.77106 13.75 9.88095 13.75H14.119C14.9718 13.75 15.7802 13.9395 16.5046 14.2788V14.4701C16.1438 14.5974 15.8053 14.7905 15.5087 15.0441L14.8798 14.6811C14.6407 14.543 14.3349 14.6249 14.1968 14.8641L13.974 15.25ZM19.621 19.8367L19.5933 19.8207C19.3944 19.9908 19.1766 20.1336 18.946 20.2476C19.2315 20.2265 19.4787 20.0674 19.621 19.8367ZM16.1617 20.25C16.1007 20.2198 16.0402 20.1875 15.9804 20.1529C15.8105 20.0549 15.6532 19.9433 15.5091 19.8204L14.8803 20.1835C14.8086 20.2248 14.731 20.2464 14.6537 20.25H16.1617Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2603 17.2644C17.1677 17.4248 17.2226 17.63 17.3831 17.7226C17.5435 17.8152 17.7486 17.7602 17.8413 17.5998C17.9339 17.4394 17.8789 17.2342 17.7185 17.1416C17.5581 17.049 17.3529 17.104 17.2603 17.2644ZM16.8831 18.5886C16.2443 18.2198 16.0255 17.4031 16.3943 16.7644C16.763 16.1257 17.5798 15.9068 18.2185 16.2756C18.8572 16.6444 19.0761 17.4611 18.7073 18.0998C18.3385 18.7385 17.5218 18.9574 16.8831 18.5886Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6128 16.9367C13.1345 16.6605 12.9706 16.049 13.2468 15.5707L13.7862 14.6363C14.0624 14.158 14.674 13.9941 15.1523 14.2703L15.4836 14.4616C15.6516 14.3448 15.8284 14.2432 16.0118 14.1572L16.0118 13.7747C16.0118 13.2224 16.4595 12.7747 17.0118 12.7747L18.0907 12.7747C18.643 12.7747 19.0907 13.2224 19.0907 13.7747L19.0907 14.1578C19.1816 14.2007 19.2714 14.2476 19.3598 14.2987C19.4484 14.3498 19.5341 14.4042 19.6167 14.4616L19.9483 14.2701C20.4266 13.994 21.0382 14.1579 21.3143 14.6362L21.8538 15.5705C22.1299 16.0488 21.9661 16.6604 21.4878 16.9365L21.1565 17.1278C21.1737 17.3295 21.174 17.5333 21.1569 17.737L21.4879 17.9281C21.9662 18.2042 22.1301 18.8158 21.8539 19.2941L21.3145 20.2285C21.0383 20.7067 20.4268 20.8706 19.9485 20.5945L19.6173 20.4033C19.4498 20.5197 19.2735 20.6211 19.0907 20.7069L19.0907 21.09L18.5907 21.09L19.0907 21.09C19.0907 21.6422 18.643 22.09 18.0907 22.09L17.0118 22.09C16.4595 22.09 16.0118 21.6422 16.0118 21.09L16.0118 20.7073C15.9205 20.6643 15.8303 20.6172 15.7415 20.5659C15.6528 20.5147 15.5671 20.4603 15.4843 20.4029L15.1527 20.5943C14.6744 20.8705 14.0628 20.7066 13.7867 20.2283L13.2472 19.2939C12.9711 18.8157 13.1349 18.2041 13.6132 17.9279L13.9448 17.7365C13.9277 17.5351 13.9273 17.3315 13.9444 17.1281L13.6128 16.9367ZM14.6523 15.1363L14.1128 16.0707L14.734 16.4293C14.9175 16.5352 15.0143 16.7453 14.9756 16.9537C14.9163 17.2726 14.9179 17.597 14.9763 17.9105C15.0151 18.1189 14.9183 18.3291 14.7347 18.4351L14.1132 18.7939L14.6527 19.7283L15.2737 19.3698C15.4571 19.2639 15.6872 19.285 15.8482 19.4224C15.9682 19.5247 16.0994 19.6178 16.2415 19.6999C16.3838 19.782 16.5301 19.8491 16.6789 19.9019C16.8784 19.9726 17.0118 20.1614 17.0118 20.3731L17.0118 21.09L18.0907 21.09L18.0907 20.3722C18.0907 20.1602 18.2243 19.9713 18.4242 19.9007C18.7247 19.7946 19.0063 19.6338 19.2528 19.4231C19.4138 19.2853 19.6442 19.2641 19.8277 19.3701L20.4485 19.7285L20.9879 18.7941L20.3673 18.4358C20.1837 18.3298 20.0869 18.1197 20.1257 17.9113C20.1851 17.5922 20.1835 17.2675 20.125 16.9538C20.0861 16.7454 20.1829 16.5352 20.3665 16.4292L20.9878 16.0705L20.4483 15.1362L19.8274 15.4946C19.6441 15.6005 19.414 15.5794 19.2529 15.4421C19.133 15.3398 19.0019 15.2467 18.8598 15.1647C18.7179 15.0828 18.5718 15.0158 18.4234 14.9631C18.224 14.8923 18.0907 14.7036 18.0907 14.4919L18.0907 13.7747L17.0118 13.7747L17.0118 14.492C17.0118 14.704 16.8781 14.893 16.6781 14.9635C16.3771 15.0697 16.0951 15.2307 15.8483 15.4418C15.6872 15.5796 15.4568 15.6008 15.2733 15.4948L14.6523 15.1363Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Parallel Process -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Parallel Process Log'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5V5.5H12C11.7239 5.5 11.5 5.72386 11.5 6V11H9.5V10.5C9.5 9.67157 8.82843 9 8 9H6C5.17157 9 4.5 9.67157 4.5 10.5V12.5C4.5 13.3284 5.17157 14 6 14H8C8.82843 14 9.5 13.3284 9.5 12.5V12H11.5V17C11.5 17.2761 11.7239 17.5 12 17.5H14.5V18C14.5 18.8284 15.1716 19.5 16 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V16C19.5 15.1716 18.8284 14.5 18 14.5H16C15.1716 14.5 14.5 15.1716 14.5 16V16.5H12.5V12H14.5V12.5C14.5 13.3284 15.1716 14 16 14H18C18.8284 14 19.5 13.3284 19.5 12.5V10.5C19.5 9.67157 18.8284 9 18 9H16C15.1716 9 14.5 9.67157 14.5 10.5V11H12.5V6.5H14.5V7C14.5 7.82843 15.1716 8.5 16 8.5H18C18.8284 8.5 19.5 7.82843 19.5 7V5C19.5 4.17157 18.8284 3.5 18 3.5H16ZM15.5 6V7C15.5 7.27614 15.7239 7.5 16 7.5H18C18.2761 7.5 18.5 7.27614 18.5 7V5C18.5 4.72386 18.2761 4.5 18 4.5H16C15.7239 4.5 15.5 4.72386 15.5 5V6ZM16 18.5C15.7239 18.5 15.5 18.2761 15.5 18V17V16C15.5 15.7239 15.7239 15.5 16 15.5H18C18.2761 15.5 18.5 15.7239 18.5 16V18C18.5 18.2761 18.2761 18.5 18 18.5H16ZM15.5 12.5C15.5 12.7761 15.7239 13 16 13H18C18.2761 13 18.5 12.7761 18.5 12.5V10.5C18.5 10.2239 18.2761 10 18 10H16C15.7239 10 15.5 10.2239 15.5 10.5V11.5V12.5ZM8.5 10.5V11.5V12.5C8.5 12.7761 8.27614 13 8 13H6C5.72386 13 5.5 12.7761 5.5 12.5V10.5C5.5 10.2239 5.72386 10 6 10H8C8.27614 10 8.5 10.2239 8.5 10.5Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Process Setup -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Process Setup'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.25 6.25C15.25 5.00736 16.2574 4 17.5 4C18.7426 4 19.75 5.00736 19.75 6.25C19.75 7.49264 18.7426 8.5 17.5 8.5C16.2574 8.5 15.25 7.49264 15.25 6.25ZM17.5 5.5C17.0858 5.5 16.75 5.83579 16.75 6.25C16.75 6.66421 17.0858 7 17.5 7C17.9142 7 18.25 6.66421 18.25 6.25C18.25 5.83579 17.9142 5.5 17.5 5.5Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12ZM12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.25 17.75C4.25 16.5074 5.25736 15.5 6.5 15.5C7.74264 15.5 8.75 16.5074 8.75 17.75C8.75 18.9926 7.74264 20 6.5 20C5.25736 20 4.25 18.9926 4.25 17.75ZM6.5 17C6.08579 17 5.75 17.3358 5.75 17.75C5.75 18.1642 6.08579 18.5 6.5 18.5C6.91421 18.5 7.25 18.1642 7.25 17.75C7.25 17.3358 6.91421 17 6.5 17Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.875 6.75C6.56332 6.75 5.5 7.81332 5.5 9.125C5.5 10.3146 6.37463 11.2999 7.51593 11.473L7.39645 11.3536C7.20118 11.1583 7.20118 10.8417 7.39645 10.6464C7.59171 10.4512 7.90829 10.4512 8.10355 10.6464L9.10355 11.6464C9.29882 11.8417 9.29882 12.1583 9.10355 12.3536L8.10355 13.3536C7.90829 13.5488 7.59171 13.5488 7.39645 13.3536C7.20118 13.1583 7.20118 12.8417 7.39645 12.6464L7.55762 12.4853C5.84249 12.3253 4.5 10.8819 4.5 9.125C4.5 7.26104 6.01104 5.75 7.875 5.75H14.25C14.5261 5.75 14.75 5.97386 14.75 6.25C14.75 6.52614 14.5261 6.75 14.25 6.75H7.875Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.125 12.5C17.4367 12.5 18.5 13.5633 18.5 14.875C18.5 16.1867 17.4367 17.25 16.125 17.25H10.9571L11.1036 17.1036C11.2988 16.9083 11.2988 16.5917 11.1036 16.3964C10.9083 16.2012 10.5917 16.2012 10.3964 16.3964L9.39645 17.3964C9.20118 17.5917 9.20118 17.9083 9.39645 18.1036L10.3964 19.1036C10.5917 19.2988 10.9083 19.2988 11.1036 19.1036C11.2988 18.9083 11.2988 18.5917 11.1036 18.3964L10.9571 18.25H16.125C17.989 18.25 19.5 16.739 19.5 14.875C19.5 13.011 17.989 11.5 16.125 11.5H15.25C14.9739 11.5 14.75 11.7239 14.75 12C14.75 12.2761 14.9739 12.5 15.25 12.5H16.125Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Component -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    class="component"
    v-else-if="iconName === 'Component'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75006 4.875L12.5001 3L16.2501 4.875M8.75006 4.875L12.5001 6.75M8.75006 4.875V9.875M16.2501 4.875L12.5001 6.75M16.2501 4.875V9.875M12.5001 6.75V11.75M16.2501 9.875L12.5001 11.75M16.2501 9.875L20 11.75M12.5001 11.75L8.75006 9.875M12.5001 11.75L8.75 13.625M12.5001 11.75L12.5 16.75M12.5001 11.75L16.25 13.625M8.75006 9.875L5 11.75M5 11.75L8.75 13.625M5 11.75V16.75L8.75 18.625M8.75 13.625V18.625M12.5 16.75L8.75 18.625M12.5 16.75L16.25 18.625M20 11.75L16.25 13.625M20 11.75V16.75L16.25 18.625M16.25 13.625V18.625"
      :stroke="iconColor"
      stroke-linejoin="round"
    />
  </svg>
  <!-- Transaction Log -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Transaction Log'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25 7C3.25 4.92893 4.92893 3.25 7 3.25H17C19.0711 3.25 20.75 4.92893 20.75 7V17C20.75 19.0711 19.0711 20.75 17 20.75H7C4.92893 20.75 3.25 19.0711 3.25 17V7ZM7 4.75C5.75736 4.75 4.75 5.75736 4.75 7V17C4.75 18.2426 5.75736 19.25 7 19.25H17C18.2426 19.25 19.25 18.2426 19.25 17V7C19.25 5.75736 18.2426 4.75 17 4.75H7Z"
      :fill="iconColor"
    />
    <rect x="7" y="8.25" width="1.5" height="1.5" rx="0.75" :fill="iconColor" />
    <rect
      x="7"
      y="11.25"
      width="1.5"
      height="1.5"
      rx="0.75"
      :fill="iconColor"
    />
    <rect
      x="7"
      y="14.25"
      width="1.5"
      height="1.5"
      rx="0.75"
      :fill="iconColor"
    />
    <rect x="10" y="8.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
    <rect x="10" y="11.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
    <rect x="10" y="14.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
  </svg>
  <!-- Transformation -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Transformation'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3244 13.7452L19.0252 14.9589C19.2323 15.3176 19.691 15.4405 20.0497 15.2334C20.4084 15.0263 20.5313 14.5676 20.3242 14.2089L18.616 11.2502C18.4089 10.8915 17.9502 10.7686 17.5915 10.9757L14.6329 12.6839C14.2742 12.891 14.1512 13.3497 14.3584 13.7084C14.5655 14.0671 15.0242 14.19 15.3829 13.9829L16.9592 13.0728C16.3503 15.2983 14.3136 16.9338 11.895 16.9338C9.95265 16.9338 8.25573 15.8795 7.34685 14.3083C7.13944 13.9497 6.68064 13.8272 6.3221 14.0346C5.96355 14.242 5.84103 14.7008 6.04844 15.0594C7.21441 17.075 9.39555 18.4338 11.895 18.4338C14.904 18.4338 17.4532 16.4649 18.3244 13.7452ZM4.9747 8.72496C4.7676 8.36624 4.3089 8.24333 3.95018 8.45044C3.59146 8.65754 3.46856 9.11624 3.67566 9.47496L5.38383 12.4336C5.59094 12.7923 6.04963 12.9152 6.40835 12.7081L9.36699 10.9999C9.72571 10.7928 9.84862 10.3341 9.64151 9.97542C9.4344 9.6167 8.97571 9.4938 8.61699 9.7009L7.04061 10.611C7.64958 8.38557 9.68624 6.75 12.1049 6.75C14.0472 6.75 15.7441 7.80436 16.653 9.37554C16.8604 9.73409 17.3192 9.85661 17.6778 9.6492C18.0363 9.4418 18.1588 8.983 17.9514 8.62446C16.7854 6.60883 14.6043 5.25 12.1049 5.25C9.09588 5.25 6.54671 7.21891 5.67545 9.93868L4.9747 8.72496Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Report -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Report'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 4.25C6.0335 4.25 5.25 5.0335 5.25 6V19C5.25 19.9665 6.0335 20.75 7 20.75H17C17.9665 20.75 18.75 19.9665 18.75 19V6C18.75 5.0335 17.9665 4.25 17 4.25H7ZM6.75 6C6.75 5.86193 6.86193 5.75 7 5.75H17C17.1381 5.75 17.25 5.86193 17.25 6V19C17.25 19.1381 17.1381 19.25 17 19.25H7C6.86193 19.25 6.75 19.1381 6.75 19V6ZM8.5 15C8.22386 15 8 14.7761 8 14.5C8 14.2239 8.22386 14 8.5 14H15.5C15.7761 14 16 14.2239 16 14.5C16 14.7761 15.7761 15 15.5 15H8.5ZM8 16.5C8 16.7761 8.22386 17 8.5 17H15.5C15.7761 17 16 16.7761 16 16.5C16 16.2239 15.7761 16 15.5 16H8.5C8.22386 16 8 16.2239 8 16.5ZM10.4999 7.40186C10.2608 7.53993 10.1788 7.84572 10.3169 8.08487L10.9634 9.20455L9.71453 8.86992C9.58644 8.8356 9.44996 8.85357 9.33512 8.91987C9.22027 8.98618 9.13648 9.09538 9.10215 9.22347C8.90364 9.96433 8.98771 10.7826 9.40186 11.4999C10.2303 12.9348 12.0651 13.4264 13.4999 12.598C14.9348 11.7696 15.4264 9.93481 14.598 8.49993C13.7696 7.06505 11.9348 6.57343 10.4999 7.40186ZM12.4329 9.74993L11.4644 8.07245C12.3225 7.83342 13.266 8.19287 13.732 8.99993C14.2843 9.95652 13.9565 11.1797 12.9999 11.732C12.0433 12.2843 10.8202 11.9565 10.2679 10.9999C10.0823 10.6785 9.99603 10.3275 9.9996 9.98158L11.8705 10.4829C12.0659 10.5352 12.2735 10.4648 12.3966 10.3043C12.5197 10.1439 12.5341 9.92507 12.4329 9.74993Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Process Communication-->
  <svg
    v-else-if="iconName === 'proc-comm'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.29963 3.26034C5.58148 2.95681 5.5639 2.48226 5.26037 2.20041C4.95684 1.91856 4.48229 1.93613 4.20044 2.23966L0.950437 5.73966C0.747458 5.95826 0.693317 6.27636 0.812553 6.54979C0.931789 6.82323 1.20173 7 1.50003 7H14.5C14.9142 7 15.25 6.66422 15.25 6.25C15.25 5.83579 14.9142 5.5 14.5 5.5H3.21994L5.29963 3.26034ZM10.7004 13.2397C10.4186 13.5432 10.4361 14.0177 10.7397 14.2996C11.0432 14.5814 11.5177 14.5639 11.7996 14.2603L15.0496 10.7603C15.2526 10.5417 15.3067 10.2236 15.1875 9.95021C15.0682 9.67677 14.7983 9.5 14.5 9.5L1.5 9.5C1.08579 9.5 0.75 9.83578 0.75 10.25C0.75 10.6642 1.08579 11 1.5 11L12.7801 11L10.7004 13.2397Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Process Filter -->
  <svg
    v-else-if="iconName === 'proc-filter'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.43427 2.65493C0.873048 2.00736 1.33304 1 2.18996 1H13.81C14.667 1 15.127 2.00736 14.5657 2.65493L9.74431 8.2181C9.58674 8.39991 9.5 8.63244 9.5 8.87303V14.1958C9.5 14.9812 8.63605 15.46 7.97 15.0438L6.97 14.4188C6.67762 14.236 6.5 13.9155 6.5 13.5708V8.87303C6.5 8.63244 6.41326 8.39992 6.25569 8.2181L1.43427 2.65493Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Process Converter -->
  <svg
    v-else-if="iconName === 'proc-converter'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="5.5" height="5.5" rx="2" :fill="iconColor" />
    <rect x="9.25" y="9.25" width="5.5" height="5.5" rx="2" :fill="iconColor" />
    <path
      d="M10 3H11.5C12.3284 3 13 3.67157 13 4.5V6"
      :stroke="iconColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 5.5L13 6.5L14 5.5"
      :stroke="iconColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 14L4.5 14C3.67157 14 3 13.3284 3 12.5L3 11"
      :stroke="iconColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 11.5L3 10.5L2 11.5"
      :stroke="iconColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <!-- Process Folder -->
  <svg
    v-else-if="iconName === 'proc-folder'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4C1 2.89543 1.89543 2 3 2H6.85126C7.56259 2 8.2204 2.37782 8.57882 2.99226L9.46059 4.50387C9.6398 4.81109 9.9687 5 10.3244 5H13C14.1046 5 15 5.89543 15 7V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Process Folder -->
  <svg
    v-else-if="iconName === 'proc-cus-folder'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4C1 2.89543 1.89543 2 3 2H6.85126C7.56259 2 8.2204 2.37782 8.57882 2.99226L9.46059 4.50387C9.6398 4.81109 9.9687 5 10.3244 5H13C14.1046 5 15 5.89543 15 7V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4Z"
      fill="#A6C7DB"
    />
  </svg>
  <!-- Process Mapper -->
  <svg
    v-else-if="iconName === 'proc-mapper'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="4.5" height="4.5" rx="0.5" :fill="iconColor" />
    <rect x="11" y="11" width="4.5" height="4.5" rx="0.5" :fill="iconColor" />
    <rect x="11" y="0.5" width="4.5" height="4.5" rx="2.25" :fill="iconColor" />
    <rect x="0.5" y="11" width="4.5" height="4.5" rx="2.25" :fill="iconColor" />
    <circle cx="8" cy="8" r="0.5" :fill="iconColor" />
    <circle cx="9" cy="7" r="0.5" :fill="iconColor" />
    <circle cx="6" cy="10" r="0.5" :fill="iconColor" />
    <circle cx="10" cy="6" r="0.5" :fill="iconColor" />
    <circle cx="7" cy="9" r="0.5" :fill="iconColor" />
    <circle
      cx="9"
      cy="9"
      r="0.5"
      transform="rotate(90 9 9)"
      :fill="iconColor"
    />
    <circle
      cx="6"
      cy="6"
      r="0.5"
      transform="rotate(90 6 6)"
      :fill="iconColor"
    />
    <circle
      cx="10"
      cy="10"
      r="0.5"
      transform="rotate(90 10 10)"
      :fill="iconColor"
    />
    <circle
      cx="7"
      cy="7"
      r="0.5"
      transform="rotate(90 7 7)"
      :fill="iconColor"
    />
  </svg>

  <!-- Process Data Source -->
  <svg
    v-else-if="iconName === 'proc-dsm'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 6C11.5899 6 14.5 4.88071 14.5 3.5C14.5 2.11929 11.5899 1 8 1C4.41015 1 1.5 2.11929 1.5 3.5C1.5 4.88071 4.41015 6 8 6ZM14.5 4.5C14.5 5.88071 11.5899 7 8 7C4.41342 7 1.50531 5.88275 1.50001 4.50378L1.5 6.5C1.5 7.88071 4.41015 9 8 9C11.5899 9 14.5 7.88071 14.5 6.5L14.5 4.5ZM8 10C11.5899 10 14.5 8.88071 14.5 7.5L14.5 9.5C14.5 10.8807 11.5899 12 8 12C4.41015 12 1.5 10.8807 1.5 9.5L1.50001 7.50378C1.50531 8.88275 4.41342 10 8 10ZM14.5 10.5C14.5 11.8807 11.5899 13 8 13C4.41342 13 1.50531 11.8828 1.50001 10.5038L1.5 12.5C1.5 13.8807 4.41015 15 8 15C11.5899 15 14.5 13.8807 14.5 12.5L14.5 10.5Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Process User -->
  <svg
    v-else-if="iconName === 'proc-usr'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.125 17C1.67813 17 1.29571 16.841 0.97775 16.5231C0.65925 16.2046 0.5 15.8219 0.5 15.375V2.375C0.5 1.92813 0.65925 1.54544 0.97775 1.22694C1.29571 0.908979 1.67813 0.75 2.125 0.75H7.79657C8.32701 0.75 8.83571 0.960714 9.21079 1.33579L12.9142 5.03921C13.2893 5.41429 13.5 5.92299 13.5 6.45343V15.375C13.5 15.8219 13.341 16.2046 13.0231 16.5231C12.7046 16.841 12.3219 17 11.875 17H2.125ZM7.8125 5.4375C7.8125 5.98978 8.26022 6.4375 8.8125 6.4375H12.526L7.8125 1.72189V5.4375Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.91406 9.10718L3 11.1384L4.91406 13.1697"
      :stroke="$vuetify.theme.dark ? '#3E424E' : '#F0F7FB'"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.08594 13.1697L11 11.1384L9.08594 9.10718"
      :stroke="$vuetify.theme.dark ? '#3E424E' : '#F0F7FB'"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      :fill="iconColor"
    />
  </svg>

  <!-- Process Trigger -->
  <svg
    v-else-if="iconName === 'proc-trigger'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.98305 0H9.89763C10.229 0 10.4976 0.268629 10.4976 0.6V0.861308C10.4976 1.19268 10.229 1.46131 9.89763 1.46131H9.13414V2.05875C9.1377 2.15332 9.14801 2.21184 9.18031 2.25317C9.22829 2.31457 9.3248 2.33804 9.51977 2.38546L9.52858 2.38761C10.6882 2.66996 11.706 3.21728 12.5849 4.02638C13.3853 4.76329 13.9811 5.63993 14.362 6.65572C14.7247 7.62252 14.8664 8.62353 14.7803 9.65816C14.6815 10.8444 14.3153 11.9382 13.6445 12.9169C12.511 14.5707 10.9546 15.5987 8.96676 15.9094C7.2445 16.1788 5.62196 15.8509 4.16089 14.8884C2.46037 13.7683 1.38689 12.1991 1.0883 10.1777C0.7297 7.74891 1.46458 5.66515 3.27034 3.98347C4.178 3.13814 5.25264 2.60068 6.46613 2.34992C6.64761 2.31252 6.69718 2.23541 6.6908 2.06176V1.89247L6.69309 1.89247V1.46131H5.98305C5.65168 1.46131 5.38305 1.19268 5.38305 0.861308V0.6C5.38305 0.268629 5.65168 0 5.98305 0ZM7.89618 14.3742C10.7809 14.395 13.1879 12.0237 13.1902 9.09258C13.1926 6.16986 10.7995 3.79968 7.9043 3.79939C5.05725 3.79939 2.61488 6.08695 2.60996 9.08446C2.60503 12.0527 5.02681 14.3858 7.89618 14.3742ZM7.8933 6.99527C7.8933 7.16236 7.89354 7.32945 7.89377 7.49654V7.49655V7.49657V7.49658C7.89444 7.9721 7.89511 8.44759 7.89038 8.92293C7.88904 9.05582 7.93299 9.08805 8.05976 9.08751C9.10695 9.08404 10.1543 9.08446 11.2017 9.08488H11.2017H11.2017H11.2018L11.9153 9.08512C12.1015 9.08512 12.1044 9.08538 12.0978 9.26302C12.061 10.2727 11.6969 11.151 11.0269 11.9031C10.4314 12.5713 9.69233 13.0078 8.81958 13.195C7.62245 13.4518 6.50629 13.2371 5.49825 12.5356C4.60446 11.9132 4.03426 11.0604 3.80389 9.99701C3.54316 8.79323 3.7698 7.6744 4.48062 6.66743C5.11714 5.76565 5.98935 5.2085 7.06876 4.97919C7.29274 4.93152 7.51965 4.90649 7.74976 4.89983C7.8672 4.89637 7.89517 4.93099 7.89437 5.04072C7.89174 5.50056 7.89229 5.96053 7.89284 6.42045V6.42048V6.42051V6.42054C7.89307 6.61213 7.8933 6.80371 7.8933 6.99527ZM15.0661 3.01785L13.8975 1.84928C13.6632 1.61496 13.2833 1.61496 13.049 1.84928L12.213 2.68522L14.2301 4.70232L15.0661 3.86637C15.3004 3.63206 15.3004 3.25216 15.0661 3.01785Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Process Group -->
  <svg
    v-else-if="iconName === 'proc-group'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" :fill="iconColor" />
    <circle cx="1.5" cy="14.5" r="1.5" :fill="iconColor" />
    <circle cx="14.5" cy="1.5" r="1.5" :fill="iconColor" />
    <circle cx="14.5" cy="14.5" r="1.5" :fill="iconColor" />
    <rect
      x="6.1"
      y="6.1"
      width="6.8"
      height="6.8"
      rx="2.4"
      :fill="iconColor"
      :stroke="$vuetify.theme.dark ? '#3E424E' : '#F0F7FB'"
      stroke-width="0.8"
    />
    <rect
      x="3.1"
      y="3.1"
      width="6.8"
      height="6.8"
      rx="2.4"
      :fill="iconColor"
      :stroke="$vuetify.theme.dark ? '#3E424E' : '#F0F7FB'"
      stroke-width="0.8"
    />
    <circle
      cx="3.99961"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 3.99961 1.50039)"
      :fill="iconColor"
    />
    <circle
      cx="5.59922"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 5.59922 1.50039)"
      :fill="iconColor"
    />
    <circle
      cx="7.19883"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 7.19883 1.50039)"
      :fill="iconColor"
    />
    <circle
      cx="8.79844"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 8.79844 1.50039)"
      :fill="iconColor"
    />
    <circle
      cx="10.398"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 10.398 1.50039)"
      :fill="iconColor"
    />
    <circle
      cx="11.9977"
      cy="1.50039"
      r="0.6"
      transform="rotate(90 11.9977 1.50039)"
      :fill="iconColor"
    />
    <circle cx="1.50039" cy="11.9994" r="0.6" :fill="iconColor" />
    <circle cx="1.50039" cy="10.3998" r="0.6" :fill="iconColor" />
    <circle cx="1.50039" cy="8.8002" r="0.6" :fill="iconColor" />
    <circle cx="1.50039" cy="7.20059" r="0.6" :fill="iconColor" />
    <circle cx="1.50039" cy="5.60098" r="0.6" :fill="iconColor" />
    <circle cx="1.50039" cy="4.00137" r="0.6" :fill="iconColor" />
    <circle
      cx="3.99961"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 3.99961 14.5004)"
      :fill="iconColor"
    />
    <circle
      cx="5.59922"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 5.59922 14.5004)"
      :fill="iconColor"
    />
    <circle
      cx="7.19883"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 7.19883 14.5004)"
      :fill="iconColor"
    />
    <circle
      cx="8.79844"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 8.79844 14.5004)"
      :fill="iconColor"
    />
    <circle
      cx="10.398"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 10.398 14.5004)"
      :fill="iconColor"
    />
    <circle
      cx="11.9977"
      cy="14.5004"
      r="0.6"
      transform="rotate(90 11.9977 14.5004)"
      :fill="iconColor"
    />
    <circle cx="14.5004" cy="11.9994" r="0.6" :fill="iconColor" />
    <circle cx="14.5004" cy="10.3998" r="0.6" :fill="iconColor" />
    <circle cx="14.5004" cy="8.8002" r="0.6" :fill="iconColor" />
    <circle cx="14.5004" cy="7.20059" r="0.6" :fill="iconColor" />
    <circle cx="14.5004" cy="5.60098" r="0.6" :fill="iconColor" />
    <circle cx="14.5004" cy="4.00137" r="0.6" :fill="iconColor" />
  </svg>

  <!-- Process AI -->
  <svg
    v-else-if="iconName === 'proc-ai'"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92969 3.30859C6.80414 3.5082 6.72454 3.73809 6.70508 3.98145L6.7002 4.10059L6.70508 4.21973C6.75263 4.80973 7.14801 5.32112 7.7168 5.51074L8.97168 5.92773L9.38965 7.18359L9.43262 7.29492C9.6642 7.83989 10.201 8.2002 10.8008 8.2002C11.4402 8.19982 12.0085 7.79013 12.2109 7.18359L12.6279 5.92773L13.6406 5.59082C13.672 5.75853 13.6904 5.9316 13.6904 6.1084V13.8975C13.6902 15.4436 12.4369 16.6973 10.8906 16.6973H3.10352C1.55728 16.6973 0.302998 15.4436 0.302734 13.8975V6.1084C0.302857 4.56211 1.55719 3.30859 3.10352 3.30859H6.92969ZM5.48535 6.2041C4.88788 6.24294 4.36706 6.62707 4.15332 7.18457L4.1123 7.30469L2.33105 13.4199C2.18466 13.926 2.5645 14.4332 3.0918 14.4336L3.21973 14.4238C3.51306 14.3757 3.76022 14.1638 3.84961 13.873L4.49707 11.752H6.67383L7.32129 13.873L7.36816 13.9922C7.50003 14.2587 7.77459 14.4334 8.0791 14.4336L8.17578 14.4277C8.61976 14.374 8.93207 13.9567 8.86035 13.5156L8.83887 13.4199L7.05762 7.30469C6.87624 6.6827 6.32437 6.24542 5.68457 6.2041V6.2002H5.48535V6.2041ZM10.8506 8.90137C10.3812 8.90149 10 9.28161 10 9.75098V13.584L10.0049 13.6709C10.0489 14.0989 10.4109 14.4335 10.8506 14.4336L10.9375 14.4297C11.3368 14.3888 11.6542 14.0702 11.6953 13.6709L11.7002 13.584V9.75098C11.7002 9.3111 11.3657 8.94919 10.9375 8.90527L10.8506 8.90137ZM6.33008 10.4492H4.83984L5.58496 7.89355L6.33008 10.4492ZM10.7998 1.2002C10.9232 1.2002 11.0332 1.27943 11.0723 1.39648L11.6797 3.21973L13.5039 3.82812C13.6208 3.86711 13.7 3.9764 13.7002 4.09961C13.7002 4.22299 13.621 4.33305 13.5039 4.37207L12.7363 4.62695L11.6807 4.98047L11.3643 5.92773L11.6797 4.98047L12.6885 4.64355L11.6797 4.97949L11.0723 6.80371C11.0332 6.92076 10.9232 7 10.7998 7C10.6765 6.99996 10.5673 6.92073 10.5283 6.80371L9.91992 4.97949L8.0957 4.37207C7.97873 4.33301 7.90039 4.22294 7.90039 4.09961C7.90056 3.97646 7.97889 3.86716 8.0957 3.82812L9.91992 3.21973L10.5283 1.39648C10.5673 1.27947 10.6765 1.20024 10.7998 1.2002ZM14.6943 0.699219C14.8188 0.69925 14.9293 0.779775 14.9697 0.897461L15.251 1.71582L16.1064 1.99219C16.2207 2.02918 16.2987 2.13578 16.2988 2.25586C16.2986 2.3759 16.2207 2.4826 16.1064 2.51953L15.251 2.7959L14.9697 3.61523C14.9291 3.73255 14.8185 3.81149 14.6943 3.81152C14.5701 3.81152 14.4596 3.73255 14.4189 3.61523L14.1367 2.7959L13.2822 2.51953C13.168 2.4826 13.0901 2.3759 13.0898 2.25586C13.09 2.13578 13.168 2.02918 13.2822 1.99219L14.1367 1.71582L14.4189 0.897461C14.4594 0.779751 14.5699 0.699219 14.6943 0.699219Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Repo Menu Lv 2-->
  <!-- Data Analysis -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Data Analysis' || iconName === 'Data Anlalysis'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 13V8.02746C8.75002 8.27619 7 10.1837 7 12.5C7 14.9853 9.01472 17 11.5 17C13.8163 17 15.7238 15.25 15.9725 13H11ZM17.417 11.5C17.4716 11.8252 17.5 12.1593 17.5 12.5C17.5 15.8137 14.8137 18.5 11.5 18.5C8.18629 18.5 5.5 15.8137 5.5 12.5C5.5 9.18629 8.18629 6.5 11.5 6.5C11.8407 6.5 12.1748 6.5284 12.5 6.58296V11.5H17.417Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 6.25606V9H17.7439C17.292 7.72138 16.2786 6.70799 15 6.25606ZM15 4.68903C17.1084 5.23169 18.7683 6.89159 19.311 9C19.4344 9.47943 19.5 9.98205 19.5 10.5H13.5V4.5C14.0179 4.5 14.5206 4.56563 15 4.68903Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Repository Matching -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Repository Matching'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5V5.5H12C11.7239 5.5 11.5 5.72386 11.5 6V11H9.5V10.5C9.5 9.67157 8.82843 9 8 9H6C5.17157 9 4.5 9.67157 4.5 10.5V12.5C4.5 13.3284 5.17157 14 6 14H8C8.82843 14 9.5 13.3284 9.5 12.5V12H11.5V17C11.5 17.2761 11.7239 17.5 12 17.5H14.5V18C14.5 18.8284 15.1716 19.5 16 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V16C19.5 15.1716 18.8284 14.5 18 14.5H16C15.1716 14.5 14.5 15.1716 14.5 16V16.5H12.5V12H14.5V12.5C14.5 13.3284 15.1716 14 16 14H18C18.8284 14 19.5 13.3284 19.5 12.5V10.5C19.5 9.67157 18.8284 9 18 9H16C15.1716 9 14.5 9.67157 14.5 10.5V11H12.5V6.5H14.5V7C14.5 7.82843 15.1716 8.5 16 8.5H18C18.8284 8.5 19.5 7.82843 19.5 7V5C19.5 4.17157 18.8284 3.5 18 3.5H16ZM15.5 6V7C15.5 7.27614 15.7239 7.5 16 7.5H18C18.2761 7.5 18.5 7.27614 18.5 7V5C18.5 4.72386 18.2761 4.5 18 4.5H16C15.7239 4.5 15.5 4.72386 15.5 5V6ZM16 18.5C15.7239 18.5 15.5 18.2761 15.5 18V17V16C15.5 15.7239 15.7239 15.5 16 15.5H18C18.2761 15.5 18.5 15.7239 18.5 16V18C18.5 18.2761 18.2761 18.5 18 18.5H16ZM15.5 12.5C15.5 12.7761 15.7239 13 16 13H18C18.2761 13 18.5 12.7761 18.5 12.5V10.5C18.5 10.2239 18.2761 10 18 10H16C15.7239 10 15.5 10.2239 15.5 10.5V11.5V12.5ZM8.5 10.5V11.5V12.5C8.5 12.7761 8.27614 13 8 13H6C5.72386 13 5.5 12.7761 5.5 12.5V10.5C5.5 10.2239 5.72386 10 6 10H8C8.27614 10 8.5 10.2239 8.5 10.5Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Interface List -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Interface List'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25 7C3.25 4.92893 4.92893 3.25 7 3.25H17C19.0711 3.25 20.75 4.92893 20.75 7V17C20.75 19.0711 19.0711 20.75 17 20.75H7C4.92893 20.75 3.25 19.0711 3.25 17V7ZM7 4.75C5.75736 4.75 4.75 5.75736 4.75 7V17C4.75 18.2426 5.75736 19.25 7 19.25H17C18.2426 19.25 19.25 18.2426 19.25 17V7C19.25 5.75736 18.2426 4.75 17 4.75H7Z"
      :fill="iconColor"
    />
    <rect x="7" y="8.25" width="1.5" height="1.5" rx="0.75" :fill="iconColor" />
    <rect
      x="7"
      y="11.25"
      width="1.5"
      height="1.5"
      rx="0.75"
      :fill="iconColor"
    />
    <rect
      x="7"
      y="14.25"
      width="1.5"
      height="1.5"
      rx="0.75"
      :fill="iconColor"
    />
    <rect x="10" y="8.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
    <rect x="10" y="11.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
    <rect x="10" y="14.25" width="7" height="1.5" rx="0.75" :fill="iconColor" />
  </svg>
  <!-- Code Tables -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Code Tables'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.56505 5.77069C8.72535 5.28724 10.2936 5 12 5C13.7064 5 15.2747 5.28724 16.4349 5.77069C17.014 6.01197 17.5153 6.31199 17.8794 6.67069C18.2453 7.03113 18.5 7.48064 18.5 8V16C18.5 16.5194 18.2453 16.9689 17.8794 17.3293C17.5153 17.688 17.014 17.988 16.4349 18.2293C15.2747 18.7128 13.7064 19 12 19C10.2936 19 8.72535 18.7128 7.56505 18.2293C6.986 17.988 6.48475 17.688 6.12062 17.3293C5.75473 16.9689 5.5 16.5194 5.5 16V8C5.5 7.48064 5.75473 7.03113 6.12062 6.67069C6.48475 6.31199 6.986 6.01197 7.56505 5.77069ZM6.5 9.64815V11C6.5 11.171 6.58106 11.3792 6.8224 11.6169C7.06551 11.8564 7.44294 12.0951 7.94967 12.3062C8.96094 12.7276 10.3927 13 12 13C13.6073 13 15.0391 12.7276 16.0503 12.3062C16.5571 12.0951 16.9345 11.8564 17.1776 11.6169C17.4189 11.3792 17.5 11.171 17.5 11V9.64815C17.1947 9.86964 16.8332 10.0634 16.4349 10.2293C15.2747 10.7128 13.7064 11 12 11C10.2936 11 8.72535 10.7128 7.56505 10.2293C7.1668 10.0634 6.80535 9.86964 6.5 9.64815ZM17.5 8C17.5 8.171 17.4189 8.37917 17.1776 8.61692C16.9345 8.8564 16.5571 9.09509 16.0503 9.30623C15.0391 9.72759 13.6073 10 12 10C10.3927 10 8.96094 9.72759 7.94967 9.30623C7.44294 9.09509 7.06551 8.8564 6.8224 8.61692C6.58106 8.37917 6.5 8.171 6.5 8C6.5 7.829 6.58106 7.62083 6.8224 7.38308C7.06551 7.1436 7.44294 6.90491 7.94967 6.69377C8.96094 6.27241 10.3927 6 12 6C13.6073 6 15.0391 6.27241 16.0503 6.69377C16.5571 6.90491 16.9345 7.1436 17.1776 7.38308C17.4189 7.62083 17.5 7.829 17.5 8ZM17.5 12.6481C17.1947 12.8696 16.8332 13.0634 16.4349 13.2293C15.2747 13.7128 13.7064 14 12 14C10.2936 14 8.72535 13.7128 7.56505 13.2293C7.1668 13.0634 6.80535 12.8696 6.5 12.6481V13.5C6.5 13.671 6.58106 13.8792 6.8224 14.1169C7.06551 14.3564 7.44294 14.5951 7.94967 14.8062C8.96094 15.2276 10.3927 15.5 12 15.5C13.6073 15.5 15.0391 15.2276 16.0503 14.8062C16.5571 14.5951 16.9345 14.3564 17.1776 14.1169C17.4189 13.8792 17.5 13.671 17.5 13.5V12.6481ZM17.5 15.1481C17.1947 15.3696 16.8332 15.5634 16.4349 15.7293C15.2747 16.2128 13.7064 16.5 12 16.5C10.2936 16.5 8.72535 16.2128 7.56505 15.7293C7.1668 15.5634 6.80535 15.3696 6.5 15.1481V16C6.5 16.171 6.58106 16.3792 6.8224 16.6169C7.06551 16.8564 7.44294 17.0951 7.94967 17.3062C8.96094 17.7276 10.3927 18 12 18C13.6073 18 15.0391 17.7276 16.0503 17.3062C16.5571 17.0951 16.9345 16.8564 17.1776 16.6169C17.4189 16.3792 17.5 16.171 17.5 16V15.1481Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Repository Manager -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Repository Manager'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 12.5C10.7306 12.5 11.7963 12.1986 12.521 11.7638C13.2656 11.3171 13.5 10.8392 13.5 10.5C13.5 10.1608 13.2656 9.68293 12.521 9.23617C11.7963 8.80135 10.7306 8.5 9.5 8.5C8.26937 8.5 7.20366 8.80135 6.47896 9.23617C5.73436 9.68293 5.5 10.1608 5.5 10.5C5.5 10.8392 5.73436 11.3171 6.47896 11.7638C7.20366 12.1986 8.26937 12.5 9.5 12.5ZM9.5 13.5C11.1356 13.5 12.5878 13.0288 13.5 12.3003V12.3021V12.3099V12.3136V12.3177V12.3256V12.3285V12.3334V12.3412V12.3434V12.349V12.3569V12.3583V12.3647V12.3725V12.3733V12.3804V12.3882V12.3883V12.396V12.4033V12.4039V12.4117V12.4184V12.4195V12.4274V12.4335V12.4352V12.443V12.4486V12.4509V12.4587V12.4637V12.4665V12.4743V12.4789V12.4822V12.49V12.4941V12.4978V12.5056V12.5093V12.5134V12.5213V12.5246V12.5291V12.5369V12.5398V12.5447V12.5525V12.5551V12.5603V12.5681V12.5705V12.5759V12.5837V12.5858V12.5915V12.5993V12.6012V12.607V12.6148V12.6166V12.6226V12.6304V12.632V12.6381V12.6459V12.6475V12.6537V12.6614V12.663V12.6692V12.6769V12.6785V12.6847V12.6924V12.694V12.7001V12.7079V12.7095V12.7156V12.7233V12.7251V12.731V12.7387V12.7407V12.7464V12.7541V12.7563V12.7618V12.7695V12.7719V12.7772V12.7848V12.7876V12.7925V12.8002V12.8033V12.8078V12.8155V12.819V12.8231V12.8307V12.8347V12.8384V12.846V12.8504V12.8536V12.8612V12.8661V12.8688V12.8764V12.8819V12.884V12.8915V12.8977V12.8991V12.9067V12.9135V12.9142V12.9217V12.9293V12.9293V12.9368V12.9443V12.9451V12.9518V12.9593V12.961V12.9668V12.9743V12.9768V12.9817V12.9892V12.9927V12.9967V13.0041V13.0086V13.0115V13.0189V13.0245V13.0264V13.0338V13.0405V13.0411V13.0485V13.0559V13.0564V13.0632V13.0706V13.0723V13.0779V13.0853V13.0883V13.0926V13.0999V13.1043V13.1072V13.1144V13.1203V13.1217V13.129V13.1362V13.1363V13.1434V13.1507V13.1523V13.1579V13.1651V13.1683V13.1722V13.1794V13.1843V13.1866V13.1937V13.2004V13.2009V13.208V13.2151V13.2164V13.2222V13.2293V13.2325V13.2363V13.2434V13.2486V13.2504V13.2574V13.2644V13.2646V13.2714V13.2784V13.2807V13.2854V13.2923V13.2968V13.2993V13.3062V13.3129V13.3131V13.32V13.3269V13.329V13.3337V13.3406V13.3452V13.3474V13.3542V13.361V13.3613V13.3678V13.3746V13.3774V13.3813V13.3881V13.3936V13.3948V13.4015V13.4082V13.4097V13.4149V13.4215V13.4258V13.4282V13.4348V13.4414V13.442V13.448V13.4545V13.4581V13.4611V13.4676V13.4741V13.4743V13.4806V13.4871V13.4905V13.4936V13.5C13.5 13.8392 13.2656 14.3171 12.521 14.7638C11.7963 15.1986 10.7306 15.5 9.5 15.5C8.26937 15.5 7.20366 15.1986 6.47896 14.7638C5.73641 14.3183 5.50129 13.8418 5.50001 13.5028C5.5 13.5019 5.5 13.5009 5.5 13.5L5.50001 13.1507L5.50001 12.3003C6.41224 13.0288 7.86441 13.5 9.5 13.5ZM4.50001 10.5066L4.5 10.5C4.5 8.84315 6.73858 7.5 9.5 7.5C12.2614 7.5 14.5 8.84315 14.5 10.5V13.5V16.5C14.5 18.1569 12.2614 19.5 9.5 19.5C6.73858 19.5 4.5 18.1569 4.5 16.5L4.50001 13.5047C4.5 13.5031 4.5 13.5016 4.5 13.5L4.50001 10.5066ZM5.5 15.3003L5.5 16.5C5.5 16.8392 5.73436 17.3171 6.47896 17.7638C7.20366 18.1986 8.26937 18.5 9.5 18.5C10.7306 18.5 11.7963 18.1986 12.521 17.7638C13.2656 17.3171 13.5 16.8392 13.5 16.5V16.4935V16.487V16.4803V16.4736V16.4668V16.4598V16.4529V16.4458V16.4386V16.4314V16.4241V16.4166V16.4092V16.4016V16.3939V16.3862V16.3784V16.3705V16.3625V16.3544V16.3463V16.3381V16.3298V16.3214V16.313V16.3045V16.2959V16.2872V16.2784V16.2696V16.2607V16.2517V16.2426V16.2335V16.2243V16.215V16.2057V16.1962V16.1868V16.1772V16.1675V16.1578V16.1481V16.1382V16.1283V16.1183V16.1082V16.0981V16.0879V16.0776V16.0673V16.0569V16.0464V16.0359V16.0253V16.0146V16.0039V15.9931V15.9822V15.9713V15.9603V15.9493V15.9382V15.927V15.9157V15.9044V15.8931V15.8817V15.8702V15.8586V15.847V15.8354V15.8236V15.8119V15.8V15.7881V15.7762V15.7642V15.7521V15.74V15.7278V15.7155V15.7032V15.6909V15.6785V15.666V15.6535V15.641V15.6284V15.6157V15.603V15.5902V15.5774V15.5645V15.5516V15.5386V15.5256V15.5125V15.4994V15.4862V15.473V15.4597V15.4464V15.4331V15.4197V15.4062V15.3927V15.3792V15.3656V15.3519V15.3383V15.3245V15.3108V15.3003C12.5878 16.0288 11.1356 16.5 9.5 16.5C7.8644 16.5 6.41223 16.0288 5.5 15.3003Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.521 8.76383C16.7963 9.19865 15.7306 9.5 14.5 9.5C14.403 9.5 14.3071 9.49813 14.2122 9.49447C14.3986 9.80881 14.5 10.1473 14.5 10.5C16.1356 10.5 17.5878 10.0288 18.5 9.30029V9.30207V9.3099V9.31362V9.31772V9.32555V9.32849V9.33338V9.34122V9.3434V9.34905V9.35688V9.35833V9.36471V9.37255V9.37329V9.38038V9.38821V9.38829V9.39605V9.40332V9.40388V9.41171V9.41837V9.41954V9.42737V9.43345V9.43521V9.44304V9.44857V9.45086V9.45869V9.46371V9.46652V9.47434V9.47888V9.48217V9.48999V9.49408V9.49781V9.50563V9.5093V9.51344V9.52126V9.52456V9.52907V9.53688V9.53983V9.54469V9.55249V9.55514V9.56029V9.56809V9.57047V9.57589V9.58368V9.58583V9.59147V9.59926V9.60121V9.60704V9.61482V9.61661V9.6226V9.63037V9.63204V9.63814V9.64591V9.6475V9.65367V9.66142V9.66297V9.66917V9.67692V9.67847V9.68466V9.6924V9.694V9.70014V9.70786V9.70954V9.71559V9.72331V9.72511V9.73102V9.73873V9.7407V9.74643V9.75412V9.75631V9.76181V9.7695V9.77194V9.77717V9.78485V9.78759V9.79251V9.80017V9.80326V9.80782V9.81547V9.81895V9.82311V9.83074V9.83466V9.83837V9.84598V9.85039V9.85359V9.8612V9.86614V9.86879V9.87638V9.8819V9.88396V9.89153V9.89768V9.8991V9.90665V9.91348V9.9142V9.92174V9.92927V9.9293V9.9368V9.94431V9.94513V9.95182V9.95931V9.96098V9.9668V9.97428V9.97685V9.98174V9.9892V9.99273V9.99665V10.0041V10.0086V10.0115V10.0189V10.0245V10.0264V10.0338V10.0405V10.0411V10.0485V10.0559V10.0564V10.0632V10.0706V10.0723V10.0779V10.0853V10.0883V10.0926V10.0999V10.1043V10.1072V10.1144V10.1203V10.1217V10.129V10.1362V10.1363V10.1434V10.1507V10.1523V10.1579V10.1651V10.1683V10.1722V10.1794V10.1843V10.1866V10.1937V10.2004V10.2009V10.208V10.2151V10.2164V10.2222V10.2293V10.2325V10.2363V10.2434V10.2486V10.2504V10.2574V10.2644V10.2646V10.2714V10.2784V10.2807V10.2854V10.2923V10.2968V10.2993V10.3062V10.3129V10.3131V10.32V10.3269V10.329V10.3337V10.3406V10.3452V10.3474V10.3542V10.361V10.3613V10.3678V10.3746V10.3774V10.3813V10.3881V10.3936V10.3948V10.4015V10.4082V10.4097V10.4149V10.4215V10.4258V10.4282V10.4348V10.4414V10.442V10.448V10.4545V10.4581V10.4611V10.4676V10.4741V10.4743V10.4806V10.4871V10.4905V10.4936V10.5C18.5 10.8392 18.2656 11.3171 17.521 11.7638C16.7963 12.1986 15.7306 12.5 14.5 12.5V13.5C16.1356 13.5 17.5878 13.0288 18.5 12.3003V12.3108V12.3245V12.3383V12.3519V12.3656V12.3792V12.3927V12.4062V12.4197V12.4331V12.4464V12.4597V12.473V12.4862V12.4994V12.5125V12.5256V12.5386V12.5516V12.5645V12.5774V12.5902V12.603V12.6157V12.6284V12.641V12.6535V12.666V12.6785V12.6909V12.7032V12.7155V12.7278V12.74V12.7521V12.7642V12.7762V12.7881V12.8V12.8119V12.8236V12.8354V12.847V12.8586V12.8702V12.8817V12.8931V12.9044V12.9157V12.927V12.9382V12.9493V12.9603V12.9713V12.9822V12.9931V13.0039V13.0146V13.0253V13.0359V13.0464V13.0569V13.0673V13.0776V13.0879V13.0981V13.1082V13.1183V13.1283V13.1382V13.1481V13.1578V13.1675V13.1772V13.1868V13.1962V13.2057V13.215V13.2243V13.2335V13.2426V13.2517V13.2607V13.2696V13.2784V13.2872V13.2959V13.3045V13.313V13.3214V13.3298V13.3381V13.3463V13.3544V13.3625V13.3705V13.3784V13.3862V13.3939V13.4016V13.4092V13.4166V13.4241V13.4314V13.4386V13.4458V13.4529V13.4598V13.4668V13.4736V13.4803V13.487V13.4935V13.5C18.5 13.8392 18.2656 14.3171 17.521 14.7638C16.7963 15.1986 15.7306 15.5 14.5 15.5V16.5C17.2614 16.5 19.5 15.1569 19.5 13.5V10.5V7.5C19.5 5.84315 17.2614 4.5 14.5 4.5C11.7386 4.5 9.5 5.84315 9.5 7.5C9.84332 7.5 10.1786 7.52076 10.5024 7.56031C10.5008 7.53976 10.5 7.51965 10.5 7.5C10.5 7.16083 10.7344 6.68293 11.479 6.23617C12.2037 5.80135 13.2694 5.5 14.5 5.5C15.7306 5.5 16.7963 5.80135 17.521 6.23617C18.2656 6.68293 18.5 7.16083 18.5 7.5C18.5 7.83917 18.2656 8.31707 17.521 8.76383Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Mapper -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Mapper'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.25 6.75C14.25 5.09315 15.5931 3.75 17.25 3.75C18.9069 3.75 20.25 5.09315 20.25 6.75C20.25 8.40685 18.9069 9.75 17.25 9.75C15.5931 9.75 14.25 8.40685 14.25 6.75ZM17.25 5.25C16.4216 5.25 15.75 5.92157 15.75 6.75C15.75 7.57843 16.4216 8.25 17.25 8.25C18.0784 8.25 18.75 7.57843 18.75 6.75C18.75 5.92157 18.0784 5.25 17.25 5.25ZM4.75 4C4.33579 4 4 4.33579 4 4.75V8.75C4 9.16421 4.33579 9.5 4.75 9.5H8.75C9.16421 9.5 9.5 9.16421 9.5 8.75V4.75C9.5 4.33579 9.16421 4 8.75 4H4.75ZM5.5 8V5.5H8V8H5.5ZM15.5 14.5C15.0858 14.5 14.75 14.8358 14.75 15.25V19.25C14.75 19.6642 15.0858 20 15.5 20H19.5C19.9142 20 20.25 19.6642 20.25 19.25V15.25C20.25 14.8358 19.9142 14.5 19.5 14.5H15.5ZM18.75 18.5H16.25V16H18.75V18.5ZM6.75 14.25C5.09315 14.25 3.75 15.5931 3.75 17.25C3.75 18.9069 5.09315 20.25 6.75 20.25C8.40685 20.25 9.75 18.9069 9.75 17.25C9.75 15.5931 8.40685 14.25 6.75 14.25ZM5.25 17.25C5.25 16.4216 5.92157 15.75 6.75 15.75C7.57843 15.75 8.25 16.4216 8.25 17.25C8.25 18.0784 7.57843 18.75 6.75 18.75C5.92157 18.75 5.25 18.0784 5.25 17.25ZM9.89645 9.89645C10.0917 9.70118 10.4083 9.70118 10.6036 9.89645L12 11.2929L13.3964 9.89645C13.5917 9.70118 13.9083 9.70118 14.1036 9.89645C14.2988 10.0917 14.2988 10.4083 14.1036 10.6036L12.7071 12L14.1036 13.3964C14.2988 13.5917 14.2988 13.9083 14.1036 14.1036C13.9083 14.2988 13.5917 14.2988 13.3964 14.1036L12 12.7071L10.6036 14.1036C10.4083 14.2988 10.0917 14.2988 9.89645 14.1036C9.70118 13.9083 9.70118 13.5917 9.89645 13.3964L11.2929 12L9.89645 10.6036C9.70118 10.4083 9.70118 10.0917 9.89645 9.89645Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Map Builder -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Map Builder'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.5739 6.08223C4.73384 6.05485 4.89711 6.10677 5.01185 6.22151L6.17691 7.38657L6.7235 7.32584L6.78424 6.77925L5.61989 5.6149C5.50509 5.5001 5.45317 5.3367 5.48066 5.17668C5.50816 5.01667 5.61163 4.87997 5.75817 4.81006C6.97953 4.22744 8.487 4.44096 9.49951 5.45348C10.2855 6.23945 10.5899 7.32408 10.4145 8.34048L15.1568 13.0827C16.1739 12.9064 17.2598 13.2106 18.0464 13.9973C19.0598 15.0107 19.2729 16.5199 18.6883 17.7418C18.6183 17.8882 18.4816 17.9915 18.3217 18.0189C18.1617 18.0463 17.9985 17.9944 17.8837 17.8796L16.7186 16.7146L16.1721 16.7753L16.1113 17.3219L17.2757 18.4862C17.3905 18.6011 17.4424 18.7644 17.4149 18.9245C17.3874 19.0845 17.284 19.2212 17.1374 19.2911C15.916 19.8737 14.4086 19.6602 13.3961 18.6477C12.6109 17.8626 12.3064 16.7794 12.4805 15.764L7.7355 11.019C6.71928 11.1941 5.63493 10.8897 4.84911 10.1039C3.83571 9.09047 3.62269 7.58124 4.20725 6.35929C4.27727 6.21291 4.41397 6.10962 4.5739 6.08223ZM4.90002 7.52389C4.82571 8.19154 5.04481 8.88535 5.55622 9.39676C6.15463 9.99518 7.0023 10.1935 7.76712 9.98936C7.93955 9.94333 8.12344 9.9927 8.24963 10.1189L13.3804 15.2496C13.5065 15.3757 13.5558 15.5594 13.51 15.7317C13.3068 16.496 13.5053 17.3427 14.1032 17.9406C14.6136 18.4511 15.3059 18.6703 15.9724 18.5972L15.2343 17.8591C15.1269 17.7517 15.0741 17.6013 15.0909 17.4503L15.2223 16.2673C15.2482 16.0349 15.4316 15.8514 15.6641 15.8256L16.8471 15.6941C16.998 15.6774 17.1484 15.7301 17.2558 15.8375L17.9955 16.5772C18.0698 15.9096 17.8507 15.2158 17.3393 14.7044C16.7403 14.1053 15.8914 13.9072 15.1259 14.1125C14.9534 14.1587 14.7692 14.1094 14.6429 13.9831L9.51438 8.85456C9.38816 8.72834 9.3388 8.54441 9.38487 8.37195C9.58924 7.60701 9.39094 6.75912 8.7924 6.16058C8.28192 5.65011 7.58971 5.43088 6.92318 5.50398L7.66127 6.24207C7.76867 6.34947 7.82143 6.49987 7.80466 6.65084L7.67322 7.83382C7.64739 8.06625 7.46391 8.24973 7.23149 8.27555L6.0485 8.40699C5.89754 8.42377 5.74714 8.37101 5.63973 8.2636L4.90002 7.52389Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.549 6.30636C15.8493 6.44541 16.1243 6.65917 16.3879 6.92278L18.0926 8.62744C18.1161 8.65096 18.1309 8.68177 18.1346 8.71482C18.1938 9.24775 18.6145 9.66844 19.1474 9.72765C19.1805 9.73132 19.2113 9.74614 19.2348 9.76965L19.2878 9.82264C19.4284 9.96327 19.4284 10.1913 19.2878 10.3319L18.5325 11.0872C18.3919 11.2278 18.1639 11.2278 18.0232 11.0872L17.9702 11.0342C17.9467 11.0107 17.9319 10.9799 17.9283 10.9468C17.869 10.4139 17.4483 9.99319 16.9154 9.93398C16.8824 9.93031 16.8516 9.91549 16.828 9.89198L16.6807 9.74463L16.3012 9.36517L15.9495 9.77048C15.9453 9.77531 15.941 9.78009 15.9366 9.78482L13.6241 12.2568L14.3316 12.9643L16.3684 10.787C16.5021 10.8624 16.6504 10.9107 16.805 10.9279C16.8731 10.9354 16.9268 10.9892 16.9344 11.0572C16.9631 11.316 17.0791 11.5572 17.2631 11.7413L17.3161 11.7943C17.8473 12.3254 18.7085 12.3254 19.2396 11.7943L19.9949 11.039C20.526 10.5079 20.526 9.64669 19.9949 9.11554L19.9419 9.06254C19.7578 8.87846 19.5166 8.76252 19.2578 8.73377C19.1898 8.7262 19.136 8.67246 19.1285 8.60439C19.0997 8.34566 18.9838 8.10441 18.7997 7.92034L17.095 6.21567C16.7805 5.90114 16.4109 5.60344 15.9692 5.39893C15.4698 5.16769 14.6812 4.85856 13.7878 4.72183C12.8955 4.58529 11.8592 4.61504 10.9024 5.10929C10.6092 5.26074 10.4944 5.56838 10.5497 5.84041C10.6025 6.10038 10.8064 6.32406 11.0968 6.38357C13.1614 6.80668 13.6623 7.49457 13.7867 7.78304C13.7974 7.80798 13.808 7.83353 13.8188 7.86015L12.1026 9.46569L11.4466 10.0794L12.1541 10.7869L12.7857 10.196L14.6261 8.47432C14.6472 8.45455 14.6694 8.43716 14.6922 8.42201L15.0397 8.19165L14.8755 7.80841C14.8494 7.74745 14.8246 7.68421 14.7967 7.61319L14.7953 7.60977L14.7953 7.6097C14.7681 7.54052 14.7377 7.46314 14.7049 7.38704C14.4515 6.79947 13.8153 6.1502 12.38 5.68481C12.7949 5.62946 13.2206 5.64669 13.6365 5.71033C14.4035 5.8277 15.0976 6.09734 15.549 6.30636ZM10.1167 12.6928L9.4092 11.9853L5.21745 15.9066C4.59817 16.4859 4.58189 17.463 5.18153 18.0627L6.34825 19.2294C6.94789 19.829 7.92499 19.8127 8.50432 19.1935L12.4256 15.0017L11.7181 14.2942L7.77404 18.5103C7.58094 18.7167 7.25523 18.7222 7.05536 18.5223L5.88864 17.3556C5.68876 17.1557 5.69418 16.83 5.90061 16.6369L10.1167 12.6928Z"
      :fill="iconColor"
    />
  </svg>

  <!-- FlatFile Layout -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'FlatFile Layout'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 5.75C6.86193 5.75 6.75 5.86193 6.75 6V19C6.75 19.1381 6.86193 19.25 7 19.25H17C17.1381 19.25 17.25 19.1381 17.25 19V10.75H14C13.0335 10.75 12.25 9.9665 12.25 9V5.75H7ZM13.75 6.81066L16.1893 9.25H14C13.8619 9.25 13.75 9.13807 13.75 9V6.81066ZM5.25 6C5.25 5.0335 6.0335 4.25 7 4.25H13C13.1989 4.25 13.3897 4.32902 13.5303 4.46967L18.5303 9.46967C18.671 9.61032 18.75 9.80109 18.75 10V19C18.75 19.9665 17.9665 20.75 17 20.75H7C6.0335 20.75 5.25 19.9665 5.25 19V6Z"
      :fill="iconColor"
    />
    <path
      d="M8.25 12.75C8.25 13.1642 8.58579 13.5 9 13.5H15C15.4142 13.5 15.75 13.1642 15.75 12.75C15.75 12.3358 15.4142 12 15 12H9C8.58579 12 8.25 12.3358 8.25 12.75Z"
      :fill="iconColor"
    />
    <path
      d="M8.25 15.75C8.25 16.1642 8.58579 16.5 9 16.5H15C15.4142 16.5 15.75 16.1642 15.75 15.75C15.75 15.3358 15.4142 15 15 15H9C8.58579 15 8.25 15.3358 8.25 15.75Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Mapping Definition -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Mapping Definition'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 7.22936C11.8987 7.17085 11.7806 7.10484 11.6475 7.03401C11.1765 6.7834 10.5098 6.46825 9.72824 6.2131C8.18907 5.71062 6.06599 5.39773 4.13721 6.46372C3.89831 6.59576 3.75 6.84717 3.75 7.12014V16.5115C3.75 16.7434 3.85736 16.9624 4.04077 17.1044C4.22419 17.2465 4.46301 17.2956 4.68762 17.2376C6.02781 16.8913 7.75472 17.1019 9.22307 17.4414C9.94245 17.6077 10.5716 17.7981 11.0205 17.9468C11.2445 18.0211 11.4227 18.0846 11.5436 18.1291C11.6041 18.1514 11.6501 18.1688 11.6804 18.1804L11.7138 18.1934L11.7212 18.1963L11.7223 18.1967L11.7225 18.1968L11.7226 18.1968C11.9007 18.2677 12.0992 18.2678 12.2774 18.1968C12.2774 18.1968 12.2774 18.1968 12.2775 18.1968L12.2777 18.1967L12.2788 18.1963L12.2862 18.1934L12.3196 18.1804C12.3499 18.1688 12.3959 18.1514 12.4564 18.1291C12.5773 18.0846 12.7555 18.0211 12.9795 17.9468C13.4284 17.7981 14.0576 17.6077 14.7769 17.4414C16.2453 17.1019 17.9722 16.8913 19.3124 17.2376C19.537 17.2956 19.7758 17.2465 19.9592 17.1044C20.1426 16.9624 20.25 16.7434 20.25 16.5115V7.12014C20.25 6.84717 20.1017 6.59576 19.8628 6.46372C17.934 5.39773 15.8109 5.71062 14.2718 6.2131C13.4902 6.46825 12.8235 6.7834 12.3525 7.03401C12.2194 7.10484 12.1013 7.17085 12 7.22936ZM12.75 16.4443C13.2049 16.2995 13.7865 16.1308 14.439 15.9799C15.6883 15.6911 17.2771 15.448 18.75 15.615V7.58889C17.4495 7.04235 15.9917 7.22953 14.7373 7.63904C14.059 7.86048 13.4735 8.13664 13.0571 8.3582C12.9402 8.42042 12.8372 8.478 12.75 8.52839V16.4443ZM11.25 16.4443C10.7951 16.2995 10.2135 16.1308 9.56097 15.9799C8.31169 15.6911 6.72291 15.448 5.25 15.615V7.58889C6.55054 7.04235 8.00834 7.22953 9.26272 7.63904C9.94102 7.86048 10.5265 8.13664 10.9429 8.3582C11.0598 8.42042 11.1628 8.478 11.25 8.52839V16.4443Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2991 9.3529C14.4931 8.82874 16.2877 8.26996 18.0896 8.59777C18.3613 8.6472 18.5415 8.90751 18.4921 9.17919C18.4426 9.45088 18.1823 9.63105 17.9106 9.58163C16.4002 9.30685 14.8281 9.7738 13.7011 10.2685C13.4483 10.3795 13.1533 10.2646 13.0423 10.0117C12.9313 9.75886 13.0463 9.4639 13.2991 9.3529Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2991 11.3529C14.4931 10.8287 16.2877 10.27 18.0896 10.5978C18.3613 10.6472 18.5415 10.9075 18.4921 11.1792C18.4426 11.4509 18.1823 11.6311 17.9106 11.5816C16.4002 11.3068 14.8281 11.7738 13.7011 12.2685C13.4483 12.3795 13.1533 12.2646 13.0423 12.0117C12.9313 11.7589 13.0463 11.4639 13.2991 11.3529Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2991 13.3529C14.4931 12.8287 16.2877 12.27 18.0896 12.5978C18.3613 12.6472 18.5415 12.9075 18.4921 13.1792C18.4426 13.4509 18.1823 13.6311 17.9106 13.5816C16.4002 13.3068 14.8281 13.7738 13.7011 14.2685C13.4483 14.3795 13.1533 14.2646 13.0423 14.0117C12.9313 13.7589 13.0463 13.4639 13.2991 13.3529Z"
      :fill="iconColor"
    />
    <path
      d="M7.85795 9.67339C7.86017 9.6635 7.86577 9.65296 7.87474 9.64178C7.88537 9.63069 7.89762 9.62052 7.91149 9.61128C7.92536 9.60204 7.93993 9.59534 7.95518 9.59118C7.97053 9.58536 7.98486 9.58282 7.99817 9.58356L8.63718 9.6192C8.66547 9.62078 8.68909 9.63128 8.70803 9.6507C8.72708 9.66845 8.74122 9.68426 8.75046 9.69813L8.80493 9.84389L9.92688 13.2967C9.93834 13.3308 9.93431 13.3581 9.9148 13.3787C9.89538 13.3976 9.86321 13.4059 9.81828 13.4033L9.10189 13.3634C9.06362 13.3613 9.03403 13.3529 9.01314 13.3384C8.99401 13.3223 8.97955 13.2973 8.96975 13.2634C8.94121 13.1767 8.91344 13.0908 8.88647 13.0058C8.85958 12.9192 8.8327 12.8326 8.80581 12.7459L7.48037 12.672C7.44402 12.7551 7.40684 12.8382 7.36883 12.9212C7.33257 13.0026 7.29626 13.0849 7.25991 13.168C7.23484 13.2284 7.19069 13.2568 7.12746 13.2533L6.3911 13.2122C6.35948 13.2104 6.33332 13.2006 6.31262 13.1828C6.29358 13.165 6.29164 13.1399 6.30681 13.1073L7.85795 9.67339ZM8.25266 10.7671C8.21631 10.8502 8.17875 10.9399 8.13999 11.0362C8.1029 11.1326 8.06576 11.2299 8.02857 11.328C7.99139 11.426 7.95342 11.5232 7.91466 11.6196C7.87766 11.7143 7.84098 11.8033 7.80463 11.8864L8.57094 11.9291L8.25266 10.7671Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Reference Files -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Reference Files'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5124 6.62131C12.2697 4.86395 15.119 4.86395 16.8763 6.62131L17.0531 6.79809C18.7128 8.45782 18.7128 11.1488 17.0531 12.8085L12.8105 17.0511C12.805 17.0566 12.7994 17.062 12.7938 17.0673L12.1029 17.7582C10.8337 19.0274 8.77591 19.0274 7.5067 17.7582C6.2375 16.489 6.2375 14.4312 7.5067 13.162L8.21381 12.4549C8.2205 12.4482 8.22728 12.4417 8.23415 12.4353L11.9269 8.74253C12.708 7.96148 13.9743 7.96148 14.7553 8.74253C15.5364 9.52358 15.5364 10.7899 14.7553 11.571L11.3712 14.9551C11.0783 15.248 10.6034 15.248 10.3105 14.9551C10.0176 14.6622 10.0176 14.1874 10.3105 13.8945L13.6947 10.5103C13.8899 10.315 13.8899 9.99845 13.6947 9.80319C13.4994 9.60793 13.1828 9.60793 12.9876 9.80319L9.27526 13.5155C9.26857 13.5222 9.26179 13.5287 9.25492 13.5351L8.56736 14.2227C7.88395 14.9061 7.88395 16.0141 8.56736 16.6975C9.25078 17.3809 10.3588 17.3809 11.0422 16.6975L11.7493 15.9904C11.7548 15.9849 11.7604 15.9795 11.766 15.9742L15.9924 11.7478C17.0664 10.6739 17.0664 8.93269 15.9924 7.85875L15.8157 7.68197C14.6441 6.5104 12.7446 6.5104 11.573 7.68197L8.21426 11.0407C7.92137 11.3336 7.44649 11.3336 7.1536 11.0407C6.86071 10.7478 6.86071 10.273 7.1536 9.98007L10.5124 6.62131Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Codes -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Codes'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 5.75C10.4812 5.75 9.25 6.98122 9.25 8.5C9.25 10.0188 10.4812 11.25 12 11.25C13.5188 11.25 14.75 10.0188 14.75 8.5C14.75 6.98122 13.5188 5.75 12 5.75ZM7.75 8.5C7.75 6.15279 9.65279 4.25 12 4.25C14.3472 4.25 16.25 6.15279 16.25 8.5C16.25 10.8472 14.3472 12.75 12 12.75C9.65279 12.75 7.75 10.8472 7.75 8.5Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.974 15.25H9.88095C7.81402 15.25 6.10164 16.768 5.79788 18.75H13.5858C13.575 18.8516 13.5951 18.9574 13.6501 19.0527L14.1973 20.0004C14.2858 20.1537 14.4432 20.2424 14.6078 20.25H5.11905C4.63908 20.25 4.25 19.8609 4.25 19.381C4.25 16.2711 6.77106 13.75 9.88095 13.75H14.119C14.9718 13.75 15.7802 13.9395 16.5046 14.2788V14.4701C16.1438 14.5974 15.8053 14.7905 15.5087 15.0441L14.8798 14.6811C14.6407 14.543 14.3349 14.6249 14.1968 14.8641L13.974 15.25ZM19.621 19.8367L19.5933 19.8207C19.3944 19.9908 19.1766 20.1336 18.946 20.2476C19.2315 20.2265 19.4787 20.0674 19.621 19.8367ZM16.1617 20.25C16.1007 20.2198 16.0402 20.1875 15.9804 20.1529C15.8105 20.0549 15.6532 19.9433 15.5091 19.8204L14.8803 20.1835C14.8086 20.2248 14.731 20.2464 14.6537 20.25H16.1617Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2603 17.2644C17.1677 17.4248 17.2226 17.63 17.3831 17.7226C17.5435 17.8152 17.7486 17.7602 17.8413 17.5998C17.9339 17.4394 17.8789 17.2342 17.7185 17.1416C17.5581 17.049 17.3529 17.104 17.2603 17.2644ZM16.8831 18.5886C16.2443 18.2198 16.0255 17.4031 16.3943 16.7644C16.763 16.1257 17.5798 15.9068 18.2185 16.2756C18.8572 16.6444 19.0761 17.4611 18.7073 18.0998C18.3385 18.7385 17.5218 18.9574 16.8831 18.5886Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6128 16.9367C13.1345 16.6605 12.9706 16.049 13.2468 15.5707L13.7862 14.6363C14.0624 14.158 14.674 13.9941 15.1523 14.2703L15.4836 14.4616C15.6516 14.3448 15.8284 14.2432 16.0118 14.1572L16.0118 13.7747C16.0118 13.2224 16.4595 12.7747 17.0118 12.7747L18.0907 12.7747C18.643 12.7747 19.0907 13.2224 19.0907 13.7747L19.0907 14.1578C19.1816 14.2007 19.2714 14.2476 19.3598 14.2987C19.4484 14.3498 19.5341 14.4042 19.6167 14.4616L19.9483 14.2701C20.4266 13.994 21.0382 14.1579 21.3143 14.6362L21.8538 15.5705C22.1299 16.0488 21.9661 16.6604 21.4878 16.9365L21.1565 17.1278C21.1737 17.3295 21.174 17.5333 21.1569 17.737L21.4879 17.9281C21.9662 18.2042 22.1301 18.8158 21.8539 19.2941L21.3145 20.2285C21.0383 20.7067 20.4268 20.8706 19.9485 20.5945L19.6173 20.4033C19.4498 20.5197 19.2735 20.6211 19.0907 20.7069L19.0907 21.09L18.5907 21.09L19.0907 21.09C19.0907 21.6422 18.643 22.09 18.0907 22.09L17.0118 22.09C16.4595 22.09 16.0118 21.6422 16.0118 21.09L16.0118 20.7073C15.9205 20.6643 15.8303 20.6172 15.7415 20.5659C15.6528 20.5147 15.5671 20.4603 15.4843 20.4029L15.1527 20.5943C14.6744 20.8705 14.0628 20.7066 13.7867 20.2283L13.2472 19.2939C12.9711 18.8157 13.1349 18.2041 13.6132 17.9279L13.9448 17.7365C13.9277 17.5351 13.9273 17.3315 13.9444 17.1281L13.6128 16.9367ZM14.6523 15.1363L14.1128 16.0707L14.734 16.4293C14.9175 16.5352 15.0143 16.7453 14.9756 16.9537C14.9163 17.2726 14.9179 17.597 14.9763 17.9105C15.0151 18.1189 14.9183 18.3291 14.7347 18.4351L14.1132 18.7939L14.6527 19.7283L15.2737 19.3698C15.4571 19.2639 15.6872 19.285 15.8482 19.4224C15.9682 19.5247 16.0994 19.6178 16.2415 19.6999C16.3838 19.782 16.5301 19.8491 16.6789 19.9019C16.8784 19.9726 17.0118 20.1614 17.0118 20.3731L17.0118 21.09L18.0907 21.09L18.0907 20.3722C18.0907 20.1602 18.2243 19.9713 18.4242 19.9007C18.7247 19.7946 19.0063 19.6338 19.2528 19.4231C19.4138 19.2853 19.6442 19.2641 19.8277 19.3701L20.4485 19.7285L20.9879 18.7941L20.3673 18.4358C20.1837 18.3298 20.0869 18.1197 20.1257 17.9113C20.1851 17.5922 20.1835 17.2675 20.125 16.9538C20.0861 16.7454 20.1829 16.5352 20.3665 16.4292L20.9878 16.0705L20.4483 15.1362L19.8274 15.4946C19.6441 15.6005 19.414 15.5794 19.2529 15.4421C19.133 15.3398 19.0019 15.2467 18.8598 15.1647C18.7179 15.0828 18.5718 15.0158 18.4234 14.9631C18.224 14.8923 18.0907 14.7036 18.0907 14.4919L18.0907 13.7747L17.0118 13.7747L17.0118 14.492C17.0118 14.704 16.8781 14.893 16.6781 14.9635C16.3771 15.0697 16.0951 15.2307 15.8483 15.4418C15.6872 15.5796 15.4568 15.6008 15.2733 15.4948L14.6523 15.1363Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Users -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Users'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 7.5C14.0335 7.5 13.25 8.2835 13.25 9.25C13.25 10.2165 14.0335 11 15 11C15.9665 11 16.75 10.2165 16.75 9.25C16.75 8.2835 15.9665 7.5 15 7.5ZM12.25 9.25C12.25 7.73122 13.4812 6.5 15 6.5C16.5188 6.5 17.75 7.73122 17.75 9.25C17.75 10.7688 16.5188 12 15 12C13.4812 12 12.25 10.7688 12.25 9.25ZM7.25 10.25C7.25 9.2835 8.0335 8.5 9 8.5C9.9665 8.5 10.75 9.2835 10.75 10.25C10.75 11.2165 9.9665 12 9 12C8.0335 12 7.25 11.2165 7.25 10.25ZM9 7.5C7.48122 7.5 6.25 8.73122 6.25 10.25C6.25 11.7688 7.48122 13 9 13C10.5188 13 11.75 11.7688 11.75 10.25C11.75 8.73122 10.5188 7.5 9 7.5ZM7.94355 13.6667C5.76559 13.6667 4 15.4323 4 17.6102C4 17.9176 4.24914 18.1667 4.55645 18.1667H13.4435C13.7509 18.1667 14 17.9176 14 17.6102C14 17.4602 13.9916 17.3122 13.9753 17.1666H19.4167C19.7388 17.1666 20 16.9054 20 16.5832C20 14.4201 18.2464 12.6666 16.0833 12.6666H13.9167C12.8328 12.6666 11.8518 13.1068 11.1427 13.8182C10.7976 13.7195 10.4332 13.6667 10.0565 13.6667H7.94355ZM12.1461 14.2652C12.8573 14.7104 13.4163 15.3761 13.7274 16.1666H18.9704C18.7683 14.7531 17.5527 13.6666 16.0833 13.6666H13.9167C13.2508 13.6666 12.6371 13.8897 12.1461 14.2652ZM10.0565 14.6667C11.5314 14.6667 12.7529 15.7515 12.9668 17.1667H5.0332C5.24709 15.7515 6.46864 14.6667 7.94355 14.6667H10.0565Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Menu Data Source -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="
      iconColor = $vuetify.theme.dark
        ? active
          ? '#0082BA'
          : 'white'
        : active
        ? '#242A33'
        : '#9AAAC3'
    "
    v-else-if="iconName === 'Data Source'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.56505 5.77069C8.72535 5.28724 10.2936 5 12 5C13.7064 5 15.2747 5.28724 16.4349 5.77069C17.014 6.01197 17.5153 6.31199 17.8794 6.67069C18.2453 7.03113 18.5 7.48064 18.5 8V16C18.5 16.5194 18.2453 16.9689 17.8794 17.3293C17.5153 17.688 17.014 17.988 16.4349 18.2293C15.2747 18.7128 13.7064 19 12 19C10.2936 19 8.72535 18.7128 7.56505 18.2293C6.986 17.988 6.48475 17.688 6.12062 17.3293C5.75473 16.9689 5.5 16.5194 5.5 16V8C5.5 7.48064 5.75473 7.03113 6.12062 6.67069C6.48475 6.31199 6.986 6.01197 7.56505 5.77069ZM6.5 9.64815V11C6.5 11.171 6.58106 11.3792 6.8224 11.6169C7.06551 11.8564 7.44294 12.0951 7.94967 12.3062C8.96094 12.7276 10.3927 13 12 13C13.6073 13 15.0391 12.7276 16.0503 12.3062C16.5571 12.0951 16.9345 11.8564 17.1776 11.6169C17.4189 11.3792 17.5 11.171 17.5 11V9.64815C17.1947 9.86964 16.8332 10.0634 16.4349 10.2293C15.2747 10.7128 13.7064 11 12 11C10.2936 11 8.72535 10.7128 7.56505 10.2293C7.1668 10.0634 6.80535 9.86964 6.5 9.64815ZM17.5 8C17.5 8.171 17.4189 8.37917 17.1776 8.61692C16.9345 8.8564 16.5571 9.09509 16.0503 9.30623C15.0391 9.72759 13.6073 10 12 10C10.3927 10 8.96094 9.72759 7.94967 9.30623C7.44294 9.09509 7.06551 8.8564 6.8224 8.61692C6.58106 8.37917 6.5 8.171 6.5 8C6.5 7.829 6.58106 7.62083 6.8224 7.38308C7.06551 7.1436 7.44294 6.90491 7.94967 6.69377C8.96094 6.27241 10.3927 6 12 6C13.6073 6 15.0391 6.27241 16.0503 6.69377C16.5571 6.90491 16.9345 7.1436 17.1776 7.38308C17.4189 7.62083 17.5 7.829 17.5 8ZM17.5 12.6481C17.1947 12.8696 16.8332 13.0634 16.4349 13.2293C15.2747 13.7128 13.7064 14 12 14C10.2936 14 8.72535 13.7128 7.56505 13.2293C7.1668 13.0634 6.80535 12.8696 6.5 12.6481V13.5C6.5 13.671 6.58106 13.8792 6.8224 14.1169C7.06551 14.3564 7.44294 14.5951 7.94967 14.8062C8.96094 15.2276 10.3927 15.5 12 15.5C13.6073 15.5 15.0391 15.2276 16.0503 14.8062C16.5571 14.5951 16.9345 14.3564 17.1776 14.1169C17.4189 13.8792 17.5 13.671 17.5 13.5V12.6481ZM17.5 15.1481C17.1947 15.3696 16.8332 15.5634 16.4349 15.7293C15.2747 16.2128 13.7064 16.5 12 16.5C10.2936 16.5 8.72535 16.2128 7.56505 15.7293C7.1668 15.5634 6.80535 15.3696 6.5 15.1481V16C6.5 16.171 6.58106 16.3792 6.8224 16.6169C7.06551 16.8564 7.44294 17.0951 7.94967 17.3062C8.96094 17.7276 10.3927 18 12 18C13.6073 18 15.0391 17.7276 16.0503 17.3062C16.5571 17.0951 16.9345 16.8564 17.1776 16.6169C17.4189 16.3792 17.5 16.171 17.5 16V15.1481Z"
      :fill="iconColor"
    />
  </svg>
  <!-- Login Arrow -->
  <svg
    v-else-if="iconName === 'Login Arrow'"
    viewBox="0 0 53 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 22L50 22"
      :stroke="(iconColor = $vuetify.theme.dark ? '#FFFFFF' : '#12083F')"
      stroke-width="4"
    />
    <path
      d="M30 2L50 22L30 42"
      :stroke="(iconColor = $vuetify.theme.dark ? '#FFFFFF' : '#12083F')"
      stroke-width="4"
    />
  </svg>
  <!-- Load -->
  <svg
    v-else-if="iconName === 'Load'"
    width="44"
    height="14"
    viewBox="0 0 44 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1591_23488"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect
        width="14"
        height="14"
        :fill="$vuetify.theme.dark ? '#FFFFFF' : '#D9D9D9'"
      />
    </mask>
    <g mask="url(#mask0_1591_23488)">
      <path
        d="M2.39187 11.6669C2.0708 11.6669 1.78637 11.5428 1.53857 11.2945C1.29077 11.0467 1.16687 10.7625 1.16687 10.4419V3.5581C1.16687 3.2375 1.29077 2.9533 1.53857 2.7055C1.78637 2.45723 2.0708 2.3331 2.39187 2.3331H5.77497L6.94187 3.5H11.6669C11.9875 3.5 12.2621 3.6239 12.4908 3.8717C12.719 4.1195 12.8331 4.40393 12.8331 4.725H6.43157L5.26467 3.5581H2.39187V10.4419L3.80657 5.95H13.7081L12.1772 10.8353C12.0992 11.0882 11.9606 11.2901 11.7614 11.4408C11.5621 11.5915 11.336 11.6669 11.0831 11.6669H2.39187ZM3.67497 10.4419H11.025L12.075 7.1169H4.72497L3.67497 10.4419Z"
        :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
      />
    </g>
    <path
      d="M18.996 11V3.152H20.388V9.824H23.652V11H18.996ZM27.1591 11.144C26.6711 11.144 26.2151 11.024 25.7911 10.784C25.3671 10.536 25.0231 10.184 24.7591 9.728C24.4951 9.264 24.3631 8.708 24.3631 8.06C24.3631 7.404 24.4951 6.848 24.7591 6.392C25.0231 5.928 25.3671 5.576 25.7911 5.336C26.2151 5.088 26.6711 4.964 27.1591 4.964C27.6551 4.964 28.1151 5.088 28.5391 5.336C28.9631 5.576 29.3071 5.928 29.5711 6.392C29.8351 6.848 29.9671 7.404 29.9671 8.06C29.9671 8.708 29.8351 9.264 29.5711 9.728C29.3071 10.184 28.9631 10.536 28.5391 10.784C28.1151 11.024 27.6551 11.144 27.1591 11.144ZM27.1591 10.016C27.5911 10.016 27.9311 9.836 28.1791 9.476C28.4271 9.116 28.5511 8.644 28.5511 8.06C28.5511 7.468 28.4271 6.992 28.1791 6.632C27.9311 6.272 27.5911 6.092 27.1591 6.092C26.7271 6.092 26.3871 6.272 26.1391 6.632C25.8991 6.992 25.7791 7.468 25.7791 8.06C25.7791 8.644 25.8991 9.116 26.1391 9.476C26.3871 9.836 26.7271 10.016 27.1591 10.016ZM32.6204 11.144C32.1084 11.144 31.6884 10.984 31.3604 10.664C31.0404 10.344 30.8804 9.928 30.8804 9.416C30.8804 8.784 31.1564 8.296 31.7084 7.952C32.2604 7.6 33.1404 7.36 34.3484 7.232C34.3404 6.92 34.2564 6.652 34.0964 6.428C33.9444 6.196 33.6684 6.08 33.2684 6.08C32.9804 6.08 32.6964 6.136 32.4164 6.248C32.1444 6.36 31.8764 6.496 31.6124 6.656L31.1084 5.732C31.4364 5.524 31.8044 5.344 32.2124 5.192C32.6284 5.04 33.0684 4.964 33.5324 4.964C34.2684 4.964 34.8164 5.184 35.1764 5.624C35.5444 6.056 35.7284 6.684 35.7284 7.508V11H34.5884L34.4924 10.352H34.4444C34.1804 10.576 33.8964 10.764 33.5924 10.916C33.2964 11.068 32.9724 11.144 32.6204 11.144ZM33.0644 10.064C33.3044 10.064 33.5204 10.008 33.7124 9.896C33.9124 9.776 34.1244 9.616 34.3484 9.416V8.096C33.5484 8.2 32.9924 8.356 32.6804 8.564C32.3684 8.764 32.2124 9.012 32.2124 9.308C32.2124 9.572 32.2924 9.764 32.4524 9.884C32.6124 10.004 32.8164 10.064 33.0644 10.064ZM39.4439 11.144C38.7079 11.144 38.1199 10.872 37.6799 10.328C37.2399 9.784 37.0199 9.028 37.0199 8.06C37.0199 7.42 37.1359 6.868 37.3679 6.404C37.6079 5.94 37.9199 5.584 38.3039 5.336C38.6879 5.088 39.0919 4.964 39.5159 4.964C39.8519 4.964 40.1359 5.024 40.3679 5.144C40.6079 5.256 40.8399 5.412 41.0639 5.612L41.0159 4.664V2.528H42.3959V11H41.2559L41.1599 10.364H41.1119C40.8959 10.58 40.6439 10.764 40.3559 10.916C40.0679 11.068 39.7639 11.144 39.4439 11.144ZM39.7799 10.004C40.2199 10.004 40.6319 9.784 41.0159 9.344V6.596C40.8159 6.412 40.6159 6.284 40.4159 6.212C40.2159 6.14 40.0159 6.104 39.8159 6.104C39.4399 6.104 39.1159 6.276 38.8439 6.62C38.5799 6.956 38.4479 7.432 38.4479 8.048C38.4479 8.68 38.5639 9.164 38.7959 9.5C39.0279 9.836 39.3559 10.004 39.7799 10.004Z"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
  </svg>
  <!-- Copy DB -->
  <svg
    v-else-if="iconName === 'copy-db'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.64934 6.20769C7.64934 4.98842 8.63775 4 9.85703 4H17.7902C19.0095 4 19.9979 4.98842 19.9979 6.20769V14.1407C19.9979 15.3599 19.0095 16.3483 17.7902 16.3483H16.3486V17.7902C16.3486 19.0095 15.3602 19.9979 14.1409 19.9979H6.20769C4.98842 19.9979 4 19.0095 4 17.7902V9.85724C4 8.63796 4.98842 7.64954 6.20769 7.64954H7.64934V6.20769ZM9.04934 7.64954H14.1409C15.3602 7.64954 16.3486 8.63796 16.3486 9.85724V14.9483H17.7902C18.2363 14.9483 18.5979 14.5867 18.5979 14.1407V6.20769C18.5979 5.76162 18.2363 5.4 17.7902 5.4H9.85703C9.41095 5.4 9.04934 5.76162 9.04934 6.20769V7.64954ZM5.4 9.85724C5.4 9.41116 5.76162 9.04954 6.20769 9.04954H14.1409C14.587 9.04954 14.9486 9.41116 14.9486 9.85724V17.7902C14.9486 18.2363 14.587 18.5979 14.1409 18.5979H6.20769C5.76162 18.5979 5.4 18.2363 5.4 17.7902V9.85724Z"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
  </svg>
  <!-- New -->
  <svg
    v-else-if="iconName === 'New'"
    width="41"
    height="12"
    viewBox="0 0 41 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="12"
      height="1.71429"
      rx="0.857143"
      transform="matrix(-1 0 0 1 12 5.14285)"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
    <path
      d="M18.996 10V2.152H20.424L22.872 6.568L23.676 8.236H23.724C23.692 7.836 23.652 7.4 23.604 6.928C23.564 6.456 23.544 6 23.544 5.56V2.152H24.876V10H23.448L21 5.584L20.196 3.916H20.148C20.18 4.332 20.216 4.768 20.256 5.224C20.304 5.68 20.328 6.128 20.328 6.568V10H18.996ZM29.271 10.144C28.727 10.144 28.235 10.024 27.795 9.784C27.355 9.536 27.007 9.184 26.751 8.728C26.495 8.264 26.367 7.708 26.367 7.06C26.367 6.42 26.495 5.868 26.751 5.404C27.015 4.94 27.355 4.584 27.771 4.336C28.187 4.088 28.623 3.964 29.079 3.964C29.615 3.964 30.063 4.084 30.423 4.324C30.783 4.556 31.055 4.884 31.239 5.308C31.423 5.724 31.515 6.208 31.515 6.76C31.515 7.048 31.495 7.272 31.455 7.432H27.711C27.775 7.952 27.963 8.356 28.275 8.644C28.587 8.932 28.979 9.076 29.451 9.076C29.707 9.076 29.943 9.04 30.159 8.968C30.383 8.888 30.603 8.78 30.819 8.644L31.287 9.508C31.007 9.692 30.695 9.844 30.351 9.964C30.007 10.084 29.647 10.144 29.271 10.144ZM27.699 6.496H30.315C30.315 6.04 30.215 5.684 30.015 5.428C29.815 5.164 29.515 5.032 29.115 5.032C28.771 5.032 28.463 5.16 28.191 5.416C27.927 5.664 27.763 6.024 27.699 6.496ZM33.805 10L32.245 4.108H33.637L34.345 7.168C34.409 7.448 34.461 7.728 34.501 8.008C34.549 8.288 34.601 8.572 34.657 8.86H34.705C34.761 8.572 34.817 8.288 34.873 8.008C34.937 7.72 35.005 7.44 35.077 7.168L35.845 4.108H37.105L37.885 7.168C37.957 7.448 38.025 7.728 38.089 8.008C38.153 8.288 38.217 8.572 38.281 8.86H38.329C38.385 8.572 38.437 8.288 38.485 8.008C38.533 7.728 38.585 7.448 38.641 7.168L39.349 4.108H40.645L39.145 10H37.501L36.817 7.252C36.753 6.972 36.693 6.696 36.637 6.424C36.581 6.144 36.521 5.848 36.457 5.536H36.409C36.353 5.848 36.297 6.144 36.241 6.424C36.185 6.704 36.125 6.984 36.061 7.264L35.389 10H33.805Z"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
    <rect
      width="12"
      height="1.71429"
      rx="0.857143"
      transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 6.85718 12)"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
  </svg>
  <!-- Load & Copy -->
  <svg
    v-else-if="iconName === 'Load&Copy'"
    width="82"
    height="14"
    viewBox="0 0 82 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6035_1431"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect
        width="14"
        height="14"
        :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
      />
    </mask>
    <g mask="url(#mask0_6035_1431)">
      <path
        d="M2.39199 11.6669C2.07093 11.6669 1.78649 11.5428 1.53869 11.2945C1.29089 11.0467 1.16699 10.7625 1.16699 10.4419V3.5581C1.16699 3.2375 1.29089 2.9533 1.53869 2.7055C1.78649 2.45723 2.07093 2.3331 2.39199 2.3331H5.77509L6.94199 3.5H11.667C11.9876 3.5 12.2622 3.6239 12.4909 3.8717C12.7191 4.1195 12.8332 4.40393 12.8332 4.725H6.43169L5.26479 3.5581H2.39199V10.4419L3.80669 5.95H13.7082L12.1773 10.8353C12.0994 11.0882 11.9608 11.2901 11.7615 11.4408C11.5622 11.5915 11.3361 11.6669 11.0832 11.6669H2.39199ZM3.67509 10.4419H11.0251L12.0751 7.1169H4.72509L3.67509 10.4419Z"
        :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
      />
    </g>
    <path
      d="M18.996 11V3.152H20.388V9.824H23.652V11H18.996ZM27.1591 11.144C26.6711 11.144 26.2151 11.024 25.7911 10.784C25.3671 10.536 25.0231 10.184 24.7591 9.728C24.4951 9.264 24.3631 8.708 24.3631 8.06C24.3631 7.404 24.4951 6.848 24.7591 6.392C25.0231 5.928 25.3671 5.576 25.7911 5.336C26.2151 5.088 26.6711 4.964 27.1591 4.964C27.6551 4.964 28.1151 5.088 28.5391 5.336C28.9631 5.576 29.3071 5.928 29.5711 6.392C29.8351 6.848 29.9671 7.404 29.9671 8.06C29.9671 8.708 29.8351 9.264 29.5711 9.728C29.3071 10.184 28.9631 10.536 28.5391 10.784C28.1151 11.024 27.6551 11.144 27.1591 11.144ZM27.1591 10.016C27.5911 10.016 27.9311 9.836 28.1791 9.476C28.4271 9.116 28.5511 8.644 28.5511 8.06C28.5511 7.468 28.4271 6.992 28.1791 6.632C27.9311 6.272 27.5911 6.092 27.1591 6.092C26.7271 6.092 26.3871 6.272 26.1391 6.632C25.8991 6.992 25.7791 7.468 25.7791 8.06C25.7791 8.644 25.8991 9.116 26.1391 9.476C26.3871 9.836 26.7271 10.016 27.1591 10.016ZM32.6204 11.144C32.1084 11.144 31.6884 10.984 31.3604 10.664C31.0404 10.344 30.8804 9.928 30.8804 9.416C30.8804 8.784 31.1564 8.296 31.7084 7.952C32.2604 7.6 33.1404 7.36 34.3484 7.232C34.3404 6.92 34.2564 6.652 34.0964 6.428C33.9444 6.196 33.6684 6.08 33.2684 6.08C32.9804 6.08 32.6964 6.136 32.4164 6.248C32.1444 6.36 31.8764 6.496 31.6124 6.656L31.1084 5.732C31.4364 5.524 31.8044 5.344 32.2124 5.192C32.6284 5.04 33.0684 4.964 33.5324 4.964C34.2684 4.964 34.8164 5.184 35.1764 5.624C35.5444 6.056 35.7284 6.684 35.7284 7.508V11H34.5884L34.4924 10.352H34.4444C34.1804 10.576 33.8964 10.764 33.5924 10.916C33.2964 11.068 32.9724 11.144 32.6204 11.144ZM33.0644 10.064C33.3044 10.064 33.5204 10.008 33.7124 9.896C33.9124 9.776 34.1244 9.616 34.3484 9.416V8.096C33.5484 8.2 32.9924 8.356 32.6804 8.564C32.3684 8.764 32.2124 9.012 32.2124 9.308C32.2124 9.572 32.2924 9.764 32.4524 9.884C32.6124 10.004 32.8164 10.064 33.0644 10.064ZM39.4439 11.144C38.7079 11.144 38.1199 10.872 37.6799 10.328C37.2399 9.784 37.0199 9.028 37.0199 8.06C37.0199 7.42 37.1359 6.868 37.3679 6.404C37.6079 5.94 37.9199 5.584 38.3039 5.336C38.6879 5.088 39.0919 4.964 39.5159 4.964C39.8519 4.964 40.1359 5.024 40.3679 5.144C40.6079 5.256 40.8399 5.412 41.0639 5.612L41.0159 4.664V2.528H42.3959V11H41.2559L41.1599 10.364H41.1119C40.8959 10.58 40.6439 10.764 40.3559 10.916C40.0679 11.068 39.7639 11.144 39.4439 11.144ZM39.7799 10.004C40.2199 10.004 40.6319 9.784 41.0159 9.344V6.596C40.8159 6.412 40.6159 6.284 40.4159 6.212C40.2159 6.14 40.0159 6.104 39.8159 6.104C39.4399 6.104 39.1159 6.276 38.8439 6.62C38.5799 6.956 38.4479 7.432 38.4479 8.048C38.4479 8.68 38.5639 9.164 38.7959 9.5C39.0279 9.836 39.3559 10.004 39.7799 10.004ZM48.1637 4.952C48.1637 5.128 48.1917 5.312 48.2477 5.504C48.3037 5.696 48.3797 5.896 48.4757 6.104C48.8037 5.896 49.0797 5.684 49.3037 5.468C49.5277 5.252 49.6397 4.992 49.6397 4.688C49.6397 4.48 49.5917 4.304 49.4957 4.16C49.3997 4.016 49.2357 3.944 49.0037 3.944C48.7557 3.944 48.5517 4.036 48.3917 4.22C48.2397 4.404 48.1637 4.648 48.1637 4.952ZM48.5237 11.144C48.0037 11.144 47.5557 11.048 47.1797 10.856C46.8037 10.656 46.5157 10.392 46.3157 10.064C46.1157 9.728 46.0157 9.352 46.0157 8.936C46.0157 8.576 46.0837 8.26 46.2197 7.988C46.3637 7.716 46.5477 7.476 46.7717 7.268C47.0037 7.06 47.2517 6.868 47.5157 6.692C47.3557 6.388 47.2317 6.092 47.1437 5.804C47.0557 5.516 47.0117 5.236 47.0117 4.964C47.0117 4.604 47.0917 4.276 47.2517 3.98C47.4197 3.684 47.6517 3.448 47.9477 3.272C48.2437 3.096 48.5917 3.008 48.9917 3.008C49.5277 3.008 49.9477 3.164 50.2517 3.476C50.5637 3.78 50.7197 4.18 50.7197 4.676C50.7197 5.02 50.6357 5.328 50.4677 5.6C50.3077 5.864 50.0957 6.108 49.8317 6.332C49.5757 6.548 49.3037 6.756 49.0157 6.956C49.2557 7.276 49.5277 7.592 49.8317 7.904C50.1437 8.216 50.4677 8.5 50.8037 8.756C51.0197 8.468 51.2117 8.152 51.3797 7.808C51.5557 7.456 51.6957 7.076 51.7997 6.668H53.0717C52.9277 7.156 52.7437 7.632 52.5197 8.096C52.2957 8.552 52.0317 8.984 51.7277 9.392C51.9837 9.544 52.2317 9.676 52.4717 9.788C52.7117 9.9 52.9357 9.976 53.1437 10.016L52.7957 11.144C52.4997 11.072 52.1877 10.968 51.8597 10.832C51.5397 10.688 51.2157 10.512 50.8877 10.304C50.5757 10.56 50.2237 10.764 49.8317 10.916C49.4397 11.068 49.0037 11.144 48.5237 11.144ZM47.3357 8.852C47.3357 9.22 47.4637 9.516 47.7197 9.74C47.9757 9.964 48.2997 10.076 48.6917 10.076C48.9077 10.076 49.1197 10.036 49.3277 9.956C49.5437 9.868 49.7517 9.752 49.9517 9.608C49.6077 9.312 49.2757 8.996 48.9557 8.66C48.6357 8.324 48.3477 7.98 48.0917 7.628C47.8677 7.804 47.6837 7.992 47.5397 8.192C47.4037 8.392 47.3357 8.612 47.3357 8.852ZM59.8741 11.144C59.2181 11.144 58.6221 10.988 58.0861 10.676C57.5501 10.364 57.1221 9.908 56.8021 9.308C56.4901 8.7 56.3341 7.964 56.3341 7.1C56.3341 6.244 56.4941 5.512 56.8141 4.904C57.1421 4.288 57.5781 3.82 58.1221 3.5C58.6661 3.172 59.2661 3.008 59.9221 3.008C60.4181 3.008 60.8581 3.108 61.2421 3.308C61.6261 3.508 61.9421 3.74 62.1901 4.004L61.4461 4.904C61.2461 4.696 61.0221 4.532 60.7741 4.412C60.5341 4.284 60.2621 4.22 59.9581 4.22C59.5341 4.22 59.1541 4.336 58.8181 4.568C58.4901 4.792 58.2301 5.116 58.0381 5.54C57.8541 5.964 57.7621 6.472 57.7621 7.064C57.7621 7.96 57.9581 8.664 58.3501 9.176C58.7421 9.68 59.2661 9.932 59.9221 9.932C60.2741 9.932 60.5861 9.86 60.8581 9.716C61.1301 9.564 61.3781 9.368 61.6021 9.128L62.3461 10.004C62.0261 10.372 61.6581 10.656 61.2421 10.856C60.8341 11.048 60.3781 11.144 59.8741 11.144ZM65.9482 11.144C65.4602 11.144 65.0042 11.024 64.5802 10.784C64.1562 10.536 63.8122 10.184 63.5482 9.728C63.2842 9.264 63.1522 8.708 63.1522 8.06C63.1522 7.404 63.2842 6.848 63.5482 6.392C63.8122 5.928 64.1562 5.576 64.5802 5.336C65.0042 5.088 65.4602 4.964 65.9482 4.964C66.4442 4.964 66.9042 5.088 67.3282 5.336C67.7522 5.576 68.0962 5.928 68.3602 6.392C68.6242 6.848 68.7562 7.404 68.7562 8.06C68.7562 8.708 68.6242 9.264 68.3602 9.728C68.0962 10.184 67.7522 10.536 67.3282 10.784C66.9042 11.024 66.4442 11.144 65.9482 11.144ZM65.9482 10.016C66.3802 10.016 66.7202 9.836 66.9682 9.476C67.2162 9.116 67.3402 8.644 67.3402 8.06C67.3402 7.468 67.2162 6.992 66.9682 6.632C66.7202 6.272 66.3802 6.092 65.9482 6.092C65.5162 6.092 65.1762 6.272 64.9282 6.632C64.6882 6.992 64.5682 7.468 64.5682 8.06C64.5682 8.644 64.6882 9.116 64.9282 9.476C65.1762 9.836 65.5162 10.016 65.9482 10.016ZM70.1221 13.328V5.108H71.2621L71.3581 5.732H71.4061C71.6541 5.524 71.9301 5.344 72.2341 5.192C72.5461 5.04 72.8621 4.964 73.1821 4.964C73.9181 4.964 74.4861 5.236 74.8861 5.78C75.2941 6.324 75.4981 7.052 75.4981 7.964C75.4981 8.636 75.3781 9.212 75.1381 9.692C74.8981 10.164 74.5861 10.524 74.2021 10.772C73.8261 11.02 73.4181 11.144 72.9781 11.144C72.7221 11.144 72.4661 11.088 72.2101 10.976C71.9541 10.856 71.7061 10.696 71.4661 10.496L71.5021 11.48V13.328H70.1221ZM72.6901 10.004C73.0821 10.004 73.4101 9.832 73.6741 9.488C73.9381 9.144 74.0701 8.64 74.0701 7.976C74.0701 7.384 73.9701 6.924 73.7701 6.596C73.5701 6.268 73.2461 6.104 72.7981 6.104C72.3821 6.104 71.9501 6.324 71.5021 6.764V9.512C71.7181 9.688 71.9261 9.816 72.1261 9.896C72.3261 9.968 72.5141 10.004 72.6901 10.004ZM77.2212 13.424C77.0612 13.424 76.9212 13.412 76.8012 13.388C76.6812 13.364 76.5652 13.336 76.4532 13.304L76.7052 12.224C76.7612 12.24 76.8252 12.256 76.8972 12.272C76.9772 12.296 77.0532 12.308 77.1252 12.308C77.4372 12.308 77.6852 12.212 77.8692 12.02C78.0612 11.836 78.2052 11.596 78.3012 11.3L78.4092 10.928L76.0932 5.108H77.4972L78.5172 8C78.6052 8.256 78.6892 8.528 78.7692 8.816C78.8572 9.096 78.9452 9.376 79.0332 9.656H79.0812C79.1532 9.384 79.2252 9.108 79.2972 8.828C79.3772 8.54 79.4532 8.264 79.5252 8L80.4132 5.108H81.7452L79.6092 11.264C79.3612 11.928 79.0612 12.452 78.7092 12.836C78.3572 13.228 77.8612 13.424 77.2212 13.424Z"
      :fill="$vuetify.theme.dark ? '#FFFFFF' : '#497DDE'"
    />
  </svg>
  <!-- Eraser -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'Eraser'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="23"
      height="23"
      rx="2.5"
      :fill="$vuetify.theme.dark ? '#333640' : '#FFFFFF'"
      :stroke="$vuetify.theme.dark ? '' : '#C5D1E3'"
    />
    <g clip-path="url(#clip0_1591_25698)">
      <path
        d="M17.6705 12.4204C18.1098 11.981 18.1098 11.2687 17.6705 10.8294L13.9205 7.07939C13.4812 6.64005 12.7689 6.64003 12.3295 7.07939L6.3295 13.0794C5.89017 13.5187 5.89017 14.231 6.3295 14.6704L8.5795 16.9204C8.79049 17.1313 9.07664 17.2499 9.37502 17.2499H17.7188C17.8741 17.2499 18 17.124 18 16.9686V16.0311C18 15.8758 17.8741 15.7499 17.7188 15.7499H14.341L17.6705 12.4204ZM10.5777 10.9526L13.7974 14.1722L12.2197 15.7499H9.53036L7.65536 13.8749L10.5777 10.9526Z"
        :fill="iconColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1591_25698">
        <rect width="12" height="12" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>

  <!-- Comp Copy Light -->
  <svg
    @mouseover="iconColor = '#497DDE'"
    @mouseleave="iconColor = active ? '#497DDE' : '#111827'"
    v-else-if="iconName === 'comp-copy' && !$vuetify.theme.dark"
    viewBox="0 0 60 22"
    fill="none"
    :width="60"
    :height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="-1" width="56" height="18.4683" rx="8" fill="#EFF6FF" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.58211 5.20769C9.58211 3.98842 10.5705 3 11.7898 3H15.4248C16.6441 3 17.6325 3.98842 17.6325 5.20769V8.99334C17.6325 10.2126 16.6441 11.201 15.4248 11.201H15.4176V11.2606C15.4176 12.4799 14.4292 13.4683 13.2099 13.4683H9.57488C8.3556 13.4683 7.36719 12.4799 7.36719 11.2606V7.47494C7.36719 6.25566 8.3556 5.26724 9.57488 5.26724H9.58211V5.20769ZM10.9821 5.26724H13.2099C14.4292 5.26724 15.4176 6.25566 15.4176 7.47493V9.80103H15.4248C15.8709 9.80103 16.2325 9.43941 16.2325 8.99334V5.20769C16.2325 4.76162 15.8709 4.4 15.4248 4.4H11.7898C11.3437 4.4 10.9821 4.76162 10.9821 5.20769V5.26724ZM8.76719 7.47494C8.76719 7.02886 9.1288 6.66724 9.57488 6.66724H13.2099C13.656 6.66724 14.0176 7.02886 14.0176 7.47493V11.2606C14.0176 11.7067 13.656 12.0683 13.2099 12.0683H9.57488C9.1288 12.0683 8.76719 11.7067 8.76719 11.2606V7.47494Z"
      :fill="iconColor"
    />
    <path
      d="M25.7608 12.3781C25.1048 12.3781 24.5088 12.2221 23.9728 11.9101C23.4368 11.5981 23.0088 11.1421 22.6888 10.5421C22.3768 9.93413 22.2208 9.19813 22.2208 8.33413C22.2208 7.47813 22.3808 6.74613 22.7008 6.13813C23.0288 5.52213 23.4648 5.05413 24.0088 4.73413C24.5528 4.40613 25.1528 4.24213 25.8088 4.24213C26.3048 4.24213 26.7448 4.34213 27.1288 4.54213C27.5128 4.74213 27.8288 4.97413 28.0768 5.23813L27.3328 6.13813C27.1328 5.93013 26.9088 5.76613 26.6608 5.64613C26.4208 5.51813 26.1488 5.45413 25.8448 5.45413C25.4208 5.45413 25.0408 5.57013 24.7048 5.80213C24.3768 6.02613 24.1168 6.35013 23.9248 6.77413C23.7408 7.19813 23.6488 7.70613 23.6488 8.29813C23.6488 9.19413 23.8448 9.89813 24.2368 10.4101C24.6288 10.9141 25.1528 11.1661 25.8088 11.1661C26.1608 11.1661 26.4728 11.0941 26.7448 10.9501C27.0168 10.7981 27.2648 10.6021 27.4888 10.3621L28.2328 11.2381C27.9128 11.6061 27.5448 11.8901 27.1288 12.0901C26.7208 12.2821 26.2648 12.3781 25.7608 12.3781ZM31.8349 12.3781C31.3469 12.3781 30.8909 12.2581 30.4669 12.0181C30.0429 11.7701 29.6989 11.4181 29.4349 10.9621C29.1709 10.4981 29.0389 9.94213 29.0389 9.29413C29.0389 8.63813 29.1709 8.08213 29.4349 7.62613C29.6989 7.16213 30.0429 6.81013 30.4669 6.57013C30.8909 6.32213 31.3469 6.19813 31.8349 6.19813C32.3309 6.19813 32.7909 6.32213 33.2149 6.57013C33.6389 6.81013 33.9829 7.16213 34.2469 7.62613C34.5109 8.08213 34.6429 8.63813 34.6429 9.29413C34.6429 9.94213 34.5109 10.4981 34.2469 10.9621C33.9829 11.4181 33.6389 11.7701 33.2149 12.0181C32.7909 12.2581 32.3309 12.3781 31.8349 12.3781ZM31.8349 11.2501C32.2669 11.2501 32.6069 11.0701 32.8549 10.7101C33.1029 10.3501 33.2269 9.87813 33.2269 9.29413C33.2269 8.70213 33.1029 8.22613 32.8549 7.86613C32.6069 7.50613 32.2669 7.32613 31.8349 7.32613C31.4029 7.32613 31.0629 7.50613 30.8149 7.86613C30.5749 8.22613 30.4549 8.70213 30.4549 9.29413C30.4549 9.87813 30.5749 10.3501 30.8149 10.7101C31.0629 11.0701 31.4029 11.2501 31.8349 11.2501ZM36.0088 14.5621V6.34213H37.1488L37.2448 6.96613H37.2928C37.5408 6.75813 37.8168 6.57813 38.1208 6.42613C38.4328 6.27413 38.7488 6.19813 39.0688 6.19813C39.8048 6.19813 40.3728 6.47013 40.7728 7.01413C41.1808 7.55813 41.3848 8.28613 41.3848 9.19813C41.3848 9.87013 41.2648 10.4461 41.0248 10.9261C40.7848 11.3981 40.4728 11.7581 40.0888 12.0061C39.7128 12.2541 39.3048 12.3781 38.8648 12.3781C38.6088 12.3781 38.3528 12.3221 38.0968 12.2101C37.8408 12.0901 37.5928 11.9301 37.3528 11.7301L37.3888 12.7141V14.5621H36.0088ZM38.5768 11.2381C38.9688 11.2381 39.2968 11.0661 39.5608 10.7221C39.8248 10.3781 39.9568 9.87413 39.9568 9.21013C39.9568 8.61813 39.8568 8.15813 39.6568 7.83013C39.4568 7.50213 39.1328 7.33813 38.6848 7.33813C38.2688 7.33813 37.8368 7.55813 37.3888 7.99813V10.7461C37.6048 10.9221 37.8128 11.0501 38.0128 11.1301C38.2128 11.2021 38.4008 11.2381 38.5768 11.2381ZM43.1079 14.6581C42.9479 14.6581 42.8079 14.6461 42.6879 14.6221C42.5679 14.5981 42.4519 14.5701 42.3399 14.5381L42.5919 13.4581C42.6479 13.4741 42.7119 13.4901 42.7839 13.5061C42.8639 13.5301 42.9399 13.5421 43.0119 13.5421C43.3239 13.5421 43.5719 13.4461 43.7559 13.2541C43.9479 13.0701 44.0919 12.8301 44.1879 12.5341L44.2959 12.1621L41.9799 6.34213H43.3839L44.4039 9.23413C44.4919 9.49013 44.5759 9.76213 44.6559 10.0501C44.7439 10.3301 44.8319 10.6101 44.9199 10.8901H44.9679C45.0399 10.6181 45.1119 10.3421 45.1839 10.0621C45.2639 9.77413 45.3399 9.49813 45.4119 9.23413L46.2999 6.34213H47.6319L45.4959 12.4981C45.2479 13.1621 44.9479 13.6861 44.5959 14.0701C44.2439 14.4621 43.7479 14.6581 43.1079 14.6581Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Comp Copy Dark -->
  <svg
    @mouseover="iconColor = '#0082BA'"
    @mouseleave="iconColor = active ? '#0082BA' : '#FFFFFF'"
    v-else-if="iconName === 'comp-copy' && $vuetify.theme.dark"
    viewBox="0 0 60 22"
    fill="none"
    :width="60"
    :height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="-1" width="56" height="18.4683" rx="8" fill="#3b3e49" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.58211 5.20769C9.58211 3.98842 10.5705 3 11.7898 3H15.4248C16.6441 3 17.6325 3.98842 17.6325 5.20769V8.99334C17.6325 10.2126 16.6441 11.201 15.4248 11.201H15.4176V11.2606C15.4176 12.4799 14.4292 13.4683 13.2099 13.4683H9.57488C8.3556 13.4683 7.36719 12.4799 7.36719 11.2606V7.47494C7.36719 6.25566 8.3556 5.26724 9.57488 5.26724H9.58211V5.20769ZM10.9821 5.26724H13.2099C14.4292 5.26724 15.4176 6.25566 15.4176 7.47493V9.80103H15.4248C15.8709 9.80103 16.2325 9.43941 16.2325 8.99334V5.20769C16.2325 4.76162 15.8709 4.4 15.4248 4.4H11.7898C11.3437 4.4 10.9821 4.76162 10.9821 5.20769V5.26724ZM8.76719 7.47494C8.76719 7.02886 9.1288 6.66724 9.57488 6.66724H13.2099C13.656 6.66724 14.0176 7.02886 14.0176 7.47493V11.2606C14.0176 11.7067 13.656 12.0683 13.2099 12.0683H9.57488C9.1288 12.0683 8.76719 11.7067 8.76719 11.2606V7.47494Z"
      :fill="iconColor"
    />
    <path
      d="M25.7608 12.3781C25.1048 12.3781 24.5088 12.2221 23.9728 11.9101C23.4368 11.5981 23.0088 11.1421 22.6888 10.5421C22.3768 9.93413 22.2208 9.19813 22.2208 8.33413C22.2208 7.47813 22.3808 6.74613 22.7008 6.13813C23.0288 5.52213 23.4648 5.05413 24.0088 4.73413C24.5528 4.40613 25.1528 4.24213 25.8088 4.24213C26.3048 4.24213 26.7448 4.34213 27.1288 4.54213C27.5128 4.74213 27.8288 4.97413 28.0768 5.23813L27.3328 6.13813C27.1328 5.93013 26.9088 5.76613 26.6608 5.64613C26.4208 5.51813 26.1488 5.45413 25.8448 5.45413C25.4208 5.45413 25.0408 5.57013 24.7048 5.80213C24.3768 6.02613 24.1168 6.35013 23.9248 6.77413C23.7408 7.19813 23.6488 7.70613 23.6488 8.29813C23.6488 9.19413 23.8448 9.89813 24.2368 10.4101C24.6288 10.9141 25.1528 11.1661 25.8088 11.1661C26.1608 11.1661 26.4728 11.0941 26.7448 10.9501C27.0168 10.7981 27.2648 10.6021 27.4888 10.3621L28.2328 11.2381C27.9128 11.6061 27.5448 11.8901 27.1288 12.0901C26.7208 12.2821 26.2648 12.3781 25.7608 12.3781ZM31.8349 12.3781C31.3469 12.3781 30.8909 12.2581 30.4669 12.0181C30.0429 11.7701 29.6989 11.4181 29.4349 10.9621C29.1709 10.4981 29.0389 9.94213 29.0389 9.29413C29.0389 8.63813 29.1709 8.08213 29.4349 7.62613C29.6989 7.16213 30.0429 6.81013 30.4669 6.57013C30.8909 6.32213 31.3469 6.19813 31.8349 6.19813C32.3309 6.19813 32.7909 6.32213 33.2149 6.57013C33.6389 6.81013 33.9829 7.16213 34.2469 7.62613C34.5109 8.08213 34.6429 8.63813 34.6429 9.29413C34.6429 9.94213 34.5109 10.4981 34.2469 10.9621C33.9829 11.4181 33.6389 11.7701 33.2149 12.0181C32.7909 12.2581 32.3309 12.3781 31.8349 12.3781ZM31.8349 11.2501C32.2669 11.2501 32.6069 11.0701 32.8549 10.7101C33.1029 10.3501 33.2269 9.87813 33.2269 9.29413C33.2269 8.70213 33.1029 8.22613 32.8549 7.86613C32.6069 7.50613 32.2669 7.32613 31.8349 7.32613C31.4029 7.32613 31.0629 7.50613 30.8149 7.86613C30.5749 8.22613 30.4549 8.70213 30.4549 9.29413C30.4549 9.87813 30.5749 10.3501 30.8149 10.7101C31.0629 11.0701 31.4029 11.2501 31.8349 11.2501ZM36.0088 14.5621V6.34213H37.1488L37.2448 6.96613H37.2928C37.5408 6.75813 37.8168 6.57813 38.1208 6.42613C38.4328 6.27413 38.7488 6.19813 39.0688 6.19813C39.8048 6.19813 40.3728 6.47013 40.7728 7.01413C41.1808 7.55813 41.3848 8.28613 41.3848 9.19813C41.3848 9.87013 41.2648 10.4461 41.0248 10.9261C40.7848 11.3981 40.4728 11.7581 40.0888 12.0061C39.7128 12.2541 39.3048 12.3781 38.8648 12.3781C38.6088 12.3781 38.3528 12.3221 38.0968 12.2101C37.8408 12.0901 37.5928 11.9301 37.3528 11.7301L37.3888 12.7141V14.5621H36.0088ZM38.5768 11.2381C38.9688 11.2381 39.2968 11.0661 39.5608 10.7221C39.8248 10.3781 39.9568 9.87413 39.9568 9.21013C39.9568 8.61813 39.8568 8.15813 39.6568 7.83013C39.4568 7.50213 39.1328 7.33813 38.6848 7.33813C38.2688 7.33813 37.8368 7.55813 37.3888 7.99813V10.7461C37.6048 10.9221 37.8128 11.0501 38.0128 11.1301C38.2128 11.2021 38.4008 11.2381 38.5768 11.2381ZM43.1079 14.6581C42.9479 14.6581 42.8079 14.6461 42.6879 14.6221C42.5679 14.5981 42.4519 14.5701 42.3399 14.5381L42.5919 13.4581C42.6479 13.4741 42.7119 13.4901 42.7839 13.5061C42.8639 13.5301 42.9399 13.5421 43.0119 13.5421C43.3239 13.5421 43.5719 13.4461 43.7559 13.2541C43.9479 13.0701 44.0919 12.8301 44.1879 12.5341L44.2959 12.1621L41.9799 6.34213H43.3839L44.4039 9.23413C44.4919 9.49013 44.5759 9.76213 44.6559 10.0501C44.7439 10.3301 44.8319 10.6101 44.9199 10.8901H44.9679C45.0399 10.6181 45.1119 10.3421 45.1839 10.0621C45.2639 9.77413 45.3399 9.49813 45.4119 9.23413L46.2999 6.34213H47.6319L45.4959 12.4981C45.2479 13.1621 44.9479 13.6861 44.5959 14.0701C44.2439 14.4621 43.7479 14.6581 43.1079 14.6581Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Comp Clear Light -->
  <svg
    @mouseover="iconColor = '#497DDE'"
    @mouseleave="iconColor = active ? '#497DDE' : '#111827'"
    v-else-if="iconName === 'comp-clear' && !$vuetify.theme.dark"
    viewBox="0 0 60 22"
    fill="none"
    :width="60"
    :height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="-1" width="56" height="18.5" rx="8" fill="#EFF6FF" />
    <path
      d="M18.1705 8.6705C18.6098 8.23116 18.6098 7.51885 18.1705 7.07951L14.4205 3.32951C13.9812 2.89017 13.2689 2.89015 12.8295 3.32951L6.8295 9.32951C6.39017 9.76885 6.39017 10.4812 6.8295 10.9205L9.0795 13.1705C9.29049 13.3815 9.57664 13.5 9.87502 13.5H18.2188C18.3741 13.5 18.5 13.3741 18.5 13.2188V12.2813C18.5 12.1259 18.3741 12 18.2188 12H14.841L18.1705 8.6705ZM11.0777 7.20267L14.2974 10.4224L12.7197 12H10.0304L8.15536 10.125L11.0777 7.20267Z"
      :fill="iconColor"
    />
    <path
      d="M26.628 12.394C25.972 12.394 25.376 12.238 24.84 11.926C24.304 11.614 23.876 11.158 23.556 10.558C23.244 9.95 23.088 9.214 23.088 8.35C23.088 7.494 23.248 6.762 23.568 6.154C23.896 5.538 24.332 5.07 24.876 4.75C25.42 4.422 26.02 4.258 26.676 4.258C27.172 4.258 27.612 4.358 27.996 4.558C28.38 4.758 28.696 4.99 28.944 5.254L28.2 6.154C28 5.946 27.776 5.782 27.528 5.662C27.288 5.534 27.016 5.47 26.712 5.47C26.288 5.47 25.908 5.586 25.572 5.818C25.244 6.042 24.984 6.366 24.792 6.79C24.608 7.214 24.516 7.722 24.516 8.314C24.516 9.21 24.712 9.914 25.104 10.426C25.496 10.93 26.02 11.182 26.676 11.182C27.028 11.182 27.34 11.11 27.612 10.966C27.884 10.814 28.132 10.618 28.356 10.378L29.1 11.254C28.78 11.622 28.412 11.906 27.996 12.106C27.588 12.298 27.132 12.394 26.628 12.394ZM31.6341 12.394C31.1461 12.394 30.7981 12.246 30.5901 11.95C30.3901 11.654 30.2901 11.25 30.2901 10.738V3.778H31.6701V10.81C31.6701 10.978 31.7021 11.098 31.7661 11.17C31.8301 11.234 31.8981 11.266 31.9701 11.266C32.0021 11.266 32.0301 11.266 32.0541 11.266C32.0861 11.258 32.1301 11.25 32.1861 11.242L32.3661 12.274C32.2861 12.306 32.1821 12.334 32.0541 12.358C31.9341 12.382 31.7941 12.394 31.6341 12.394ZM36.0679 12.394C35.5239 12.394 35.0319 12.274 34.5919 12.034C34.1519 11.786 33.8039 11.434 33.5479 10.978C33.2919 10.514 33.1639 9.958 33.1639 9.31C33.1639 8.67 33.2919 8.118 33.5479 7.654C33.8119 7.19 34.1519 6.834 34.5679 6.586C34.9839 6.338 35.4199 6.214 35.8759 6.214C36.4119 6.214 36.8599 6.334 37.2199 6.574C37.5799 6.806 37.8519 7.134 38.0359 7.558C38.2199 7.974 38.3119 8.458 38.3119 9.01C38.3119 9.298 38.2919 9.522 38.2519 9.682H34.5079C34.5719 10.202 34.7599 10.606 35.0719 10.894C35.3839 11.182 35.7759 11.326 36.2479 11.326C36.5039 11.326 36.7399 11.29 36.9559 11.218C37.1799 11.138 37.3999 11.03 37.6159 10.894L38.0839 11.758C37.8039 11.942 37.4919 12.094 37.1479 12.214C36.8039 12.334 36.4439 12.394 36.0679 12.394ZM34.4959 8.746H37.1119C37.1119 8.29 37.0119 7.934 36.8119 7.678C36.6119 7.414 36.3119 7.282 35.9119 7.282C35.5679 7.282 35.2599 7.41 34.9879 7.666C34.7239 7.914 34.5599 8.274 34.4959 8.746ZM40.9173 12.394C40.4053 12.394 39.9853 12.234 39.6573 11.914C39.3373 11.594 39.1773 11.178 39.1773 10.666C39.1773 10.034 39.4533 9.546 40.0053 9.202C40.5573 8.85 41.4373 8.61 42.6453 8.482C42.6373 8.17 42.5533 7.902 42.3933 7.678C42.2413 7.446 41.9653 7.33 41.5653 7.33C41.2773 7.33 40.9933 7.386 40.7133 7.498C40.4413 7.61 40.1733 7.746 39.9093 7.906L39.4053 6.982C39.7333 6.774 40.1013 6.594 40.5093 6.442C40.9253 6.29 41.3653 6.214 41.8293 6.214C42.5653 6.214 43.1133 6.434 43.4733 6.874C43.8413 7.306 44.0253 7.934 44.0253 8.758V12.25H42.8853L42.7893 11.602H42.7413C42.4773 11.826 42.1933 12.014 41.8893 12.166C41.5933 12.318 41.2693 12.394 40.9173 12.394ZM41.3613 11.314C41.6013 11.314 41.8173 11.258 42.0093 11.146C42.2093 11.026 42.4213 10.866 42.6453 10.666V9.346C41.8453 9.45 41.2893 9.606 40.9773 9.814C40.6653 10.014 40.5093 10.262 40.5093 10.558C40.5093 10.822 40.5893 11.014 40.7493 11.134C40.9093 11.254 41.1133 11.314 41.3613 11.314ZM45.6768 12.25V6.358H46.8168L46.9128 7.402H46.9608C47.1688 7.018 47.4208 6.726 47.7168 6.526C48.0128 6.318 48.3168 6.214 48.6288 6.214C48.9088 6.214 49.1328 6.254 49.3008 6.334L49.0608 7.534C48.9568 7.502 48.8608 7.478 48.7728 7.462C48.6848 7.446 48.5768 7.438 48.4488 7.438C48.2168 7.438 47.9728 7.53 47.7168 7.714C47.4608 7.89 47.2408 8.202 47.0568 8.65V12.25H45.6768Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Comp Clear Dark -->
  <svg
    @mouseover="iconColor = '#0082BA'"
    @mouseleave="iconColor = active ? '#0082BA' : '#FFFFFF'"
    v-else-if="iconName === 'comp-clear' && $vuetify.theme.dark"
    viewBox="0 0 60 22"
    fill="none"
    :width="60"
    :height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="-1" width="56" height="18.5" rx="8" fill="#3b3e49" />
    <path
      d="M18.1705 8.6705C18.6098 8.23116 18.6098 7.51885 18.1705 7.07951L14.4205 3.32951C13.9812 2.89017 13.2689 2.89015 12.8295 3.32951L6.8295 9.32951C6.39017 9.76885 6.39017 10.4812 6.8295 10.9205L9.0795 13.1705C9.29049 13.3815 9.57664 13.5 9.87502 13.5H18.2188C18.3741 13.5 18.5 13.3741 18.5 13.2188V12.2813C18.5 12.1259 18.3741 12 18.2188 12H14.841L18.1705 8.6705ZM11.0777 7.20267L14.2974 10.4224L12.7197 12H10.0304L8.15536 10.125L11.0777 7.20267Z"
      :fill="iconColor"
    />
    <path
      d="M26.628 12.394C25.972 12.394 25.376 12.238 24.84 11.926C24.304 11.614 23.876 11.158 23.556 10.558C23.244 9.95 23.088 9.214 23.088 8.35C23.088 7.494 23.248 6.762 23.568 6.154C23.896 5.538 24.332 5.07 24.876 4.75C25.42 4.422 26.02 4.258 26.676 4.258C27.172 4.258 27.612 4.358 27.996 4.558C28.38 4.758 28.696 4.99 28.944 5.254L28.2 6.154C28 5.946 27.776 5.782 27.528 5.662C27.288 5.534 27.016 5.47 26.712 5.47C26.288 5.47 25.908 5.586 25.572 5.818C25.244 6.042 24.984 6.366 24.792 6.79C24.608 7.214 24.516 7.722 24.516 8.314C24.516 9.21 24.712 9.914 25.104 10.426C25.496 10.93 26.02 11.182 26.676 11.182C27.028 11.182 27.34 11.11 27.612 10.966C27.884 10.814 28.132 10.618 28.356 10.378L29.1 11.254C28.78 11.622 28.412 11.906 27.996 12.106C27.588 12.298 27.132 12.394 26.628 12.394ZM31.6341 12.394C31.1461 12.394 30.7981 12.246 30.5901 11.95C30.3901 11.654 30.2901 11.25 30.2901 10.738V3.778H31.6701V10.81C31.6701 10.978 31.7021 11.098 31.7661 11.17C31.8301 11.234 31.8981 11.266 31.9701 11.266C32.0021 11.266 32.0301 11.266 32.0541 11.266C32.0861 11.258 32.1301 11.25 32.1861 11.242L32.3661 12.274C32.2861 12.306 32.1821 12.334 32.0541 12.358C31.9341 12.382 31.7941 12.394 31.6341 12.394ZM36.0679 12.394C35.5239 12.394 35.0319 12.274 34.5919 12.034C34.1519 11.786 33.8039 11.434 33.5479 10.978C33.2919 10.514 33.1639 9.958 33.1639 9.31C33.1639 8.67 33.2919 8.118 33.5479 7.654C33.8119 7.19 34.1519 6.834 34.5679 6.586C34.9839 6.338 35.4199 6.214 35.8759 6.214C36.4119 6.214 36.8599 6.334 37.2199 6.574C37.5799 6.806 37.8519 7.134 38.0359 7.558C38.2199 7.974 38.3119 8.458 38.3119 9.01C38.3119 9.298 38.2919 9.522 38.2519 9.682H34.5079C34.5719 10.202 34.7599 10.606 35.0719 10.894C35.3839 11.182 35.7759 11.326 36.2479 11.326C36.5039 11.326 36.7399 11.29 36.9559 11.218C37.1799 11.138 37.3999 11.03 37.6159 10.894L38.0839 11.758C37.8039 11.942 37.4919 12.094 37.1479 12.214C36.8039 12.334 36.4439 12.394 36.0679 12.394ZM34.4959 8.746H37.1119C37.1119 8.29 37.0119 7.934 36.8119 7.678C36.6119 7.414 36.3119 7.282 35.9119 7.282C35.5679 7.282 35.2599 7.41 34.9879 7.666C34.7239 7.914 34.5599 8.274 34.4959 8.746ZM40.9173 12.394C40.4053 12.394 39.9853 12.234 39.6573 11.914C39.3373 11.594 39.1773 11.178 39.1773 10.666C39.1773 10.034 39.4533 9.546 40.0053 9.202C40.5573 8.85 41.4373 8.61 42.6453 8.482C42.6373 8.17 42.5533 7.902 42.3933 7.678C42.2413 7.446 41.9653 7.33 41.5653 7.33C41.2773 7.33 40.9933 7.386 40.7133 7.498C40.4413 7.61 40.1733 7.746 39.9093 7.906L39.4053 6.982C39.7333 6.774 40.1013 6.594 40.5093 6.442C40.9253 6.29 41.3653 6.214 41.8293 6.214C42.5653 6.214 43.1133 6.434 43.4733 6.874C43.8413 7.306 44.0253 7.934 44.0253 8.758V12.25H42.8853L42.7893 11.602H42.7413C42.4773 11.826 42.1933 12.014 41.8893 12.166C41.5933 12.318 41.2693 12.394 40.9173 12.394ZM41.3613 11.314C41.6013 11.314 41.8173 11.258 42.0093 11.146C42.2093 11.026 42.4213 10.866 42.6453 10.666V9.346C41.8453 9.45 41.2893 9.606 40.9773 9.814C40.6653 10.014 40.5093 10.262 40.5093 10.558C40.5093 10.822 40.5893 11.014 40.7493 11.134C40.9093 11.254 41.1133 11.314 41.3613 11.314ZM45.6768 12.25V6.358H46.8168L46.9128 7.402H46.9608C47.1688 7.018 47.4208 6.726 47.7168 6.526C48.0128 6.318 48.3168 6.214 48.6288 6.214C48.9088 6.214 49.1328 6.254 49.3008 6.334L49.0608 7.534C48.9568 7.502 48.8608 7.478 48.7728 7.462C48.6848 7.446 48.5768 7.438 48.4488 7.438C48.2168 7.438 47.9728 7.53 47.7168 7.714C47.4608 7.89 47.2408 8.202 47.0568 8.65V12.25H45.6768Z"
      :fill="iconColor"
    />
  </svg>

  <!-- Discard Changes -->
  <svg
    v-else-if="iconName === 'dis-change'"
    :width="24"
    :height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3_4452)">
      <path
        d="M21.8887 12.2222C21.8887 17.7462 17.4111 22.2222 11.8887 22.2222C6.36621 22.2222 1.88867 17.7462 1.88867 12.2222C1.88867 6.70132 6.36621 2.22217 11.8887 2.22217C17.4111 2.22217 21.8887 6.70132 21.8887 12.2222ZM11.8887 14.2383C10.8643 14.2383 10.0338 15.0687 10.0338 16.0931C10.0338 17.1175 10.8643 17.948 11.8887 17.948C12.9131 17.948 13.7435 17.1175 13.7435 16.0931C13.7435 15.0687 12.9131 14.2383 11.8887 14.2383ZM10.1277 7.57112L10.4268 13.055C10.4408 13.3116 10.6529 13.5125 10.9099 13.5125H12.8674C13.1244 13.5125 13.3366 13.3116 13.3506 13.055L13.6497 7.57112C13.6648 7.29394 13.4441 7.06088 13.1665 7.06088H10.6108C10.3332 7.06088 10.1125 7.29394 10.1277 7.57112Z"
        fill="#D65745"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_4452">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(1.88867 2.22217)"
        />
      </clipPath>
    </defs>
  </svg>

  <!-- Clear Text -->
  <svg
    v-else-if="iconName === 'clear-text'"
    :width="16"
    :height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#A2ADC3" />
    <path
      d="M4.91992 4.8573L11.2053 11.1427"
      stroke="white"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.2051 4.8573L4.91968 11.1427"
      stroke="white"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- Add Converter -->
  <svg
    v-else-if="iconName === 'add-conv'"
    :width="23"
    :height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="21"
      height="21"
      rx="4"
      transform="matrix(-1 0 0 1 22 1)"
      fill="white"
      stroke="#C5D1E3"
    />
    <rect
      width="8.86667"
      height="0.933333"
      rx="0.466667"
      transform="matrix(-1 0 0 1 15.9336 11.2667)"
      fill="#7B839D"
    />
    <rect
      width="8.86667"
      height="0.933333"
      rx="0.466667"
      transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 11.9668 16.1666)"
      fill="#7B839D"
    />
  </svg>

  <!-- Remove Converter -->
  <svg
    v-else-if="iconName === 'remove-conv'"
    :width="23"
    :height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="21"
      height="21"
      rx="4"
      transform="matrix(-1 0 0 1 22 1)"
      fill="white"
      stroke="#C5D1E3"
    />
    <rect
      width="8.86667"
      height="0.933333"
      rx="0.466667"
      transform="matrix(-1 0 0 1 15.9336 11.2667)"
      fill="#7B839D"
    />
  </svg>

  <!-- Download -->
  <svg
    @mouseover="iconColor = $vuetify.theme.dark ? '#0082BA' : '#242A33'"
    @mouseleave="iconColor = $vuetify.theme.dark ? 'white' : '#9AAAC3'"
    v-else-if="iconName === 'download'"
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.29012 13.957C5.68059 14.3477 6.31472 14.3477 6.70519 13.957L11.7032 8.95674C12.0937 8.56609 12.0937 7.93168 11.7032 7.54103C11.3128 7.15038 10.6786 7.15038 10.2882 7.54103L6.9957 10.8381V1.25006C6.9957 0.6969 6.549 0.25 5.99609 0.25C5.44318 0.25 4.99648 0.6969 4.99648 1.25006V10.835L1.70402 7.54416C1.31355 7.15351 0.679421 7.15351 0.288948 7.54416C-0.101524 7.9348 -0.101524 8.56921 0.288948 8.95986L5.287 13.9601L5.29012 13.957Z"
      :fill="iconColor"
    />
  </svg>

  <!-- completed -->
  <svg
    v-else-if="iconName === 'completed'"
    :width="size"
    :height="size"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C12 9.31372 9.31372 12 6 12C2.68628 12 0 9.31372 0 6C0 2.68628 2.68628 0 6 0C9.31372 0 12 2.68628 12 6ZM5.30598 9.17695L9.7576 4.72534C9.90876 4.57418 9.90876 4.32907 9.7576 4.17791L9.21017 3.63048C9.05901 3.4793 8.8139 3.4793 8.66272 3.63048L5.03226 7.26092L3.33728 5.56594C3.18612 5.41478 2.94102 5.41478 2.78983 5.56594L2.2424 6.11337C2.09124 6.26453 2.09124 6.50964 2.2424 6.6608L4.75853 9.17693C4.90972 9.32811 5.1548 9.32811 5.30598 9.17695Z"
      fill="#07BB89"
    />
  </svg>

  <!-- warning -->
  <svg
    v-else-if="iconName === 'warning'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1659_22200)">
      <path
        d="M22.9844 19.2936C23.6609 20.4663 22.8117 21.9321 21.4605 21.9321H3.87209C2.5183 21.9321 1.67305 20.464 2.34824 19.2936L11.1426 4.04571C11.8194 2.87254 13.5146 2.87466 14.1903 4.04571L22.9844 19.2936ZM12.6664 16.1412C11.7353 16.1412 10.9804 16.896 10.9804 17.8271C10.9804 18.7582 11.7353 19.5131 12.6664 19.5131C13.5975 19.5131 14.3524 18.7582 14.3524 17.8271C14.3524 16.896 13.5975 16.1412 12.6664 16.1412ZM11.0657 10.081L11.3376 15.0656C11.3503 15.2988 11.5432 15.4814 11.7768 15.4814H13.556C13.7896 15.4814 13.9825 15.2988 13.9952 15.0656L14.2671 10.081C14.2808 9.82909 14.0802 9.61724 13.8279 9.61724H11.5049C11.2525 9.61724 11.052 9.82909 11.0657 10.081Z"
        fill="#EAC645"
      />
    </g>
    <defs>
      <clipPath id="clip0_1659_22200">
        <rect
          width="21.1111"
          height="18.7654"
          fill="white"
          transform="translate(2.11108 3.16663)"
        />
      </clipPath>
    </defs>
  </svg>

  <!-- validate -->
  <svg
    v-else-if="iconName === 'validate'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C12 9.31444 9.31348 12 6 12C2.68652 12 0 9.31444 0 6C0 2.68749 2.68652 0 6 0C9.31348 0 12 2.68749 12 6ZM6 7.20968C5.38536 7.20968 4.8871 7.70794 4.8871 8.32258C4.8871 8.93722 5.38536 9.43548 6 9.43548C6.61464 9.43548 7.1129 8.93722 7.1129 8.32258C7.1129 7.70794 6.61464 7.20968 6 7.20968ZM4.9434 3.20937L5.12286 6.49969C5.13126 6.65366 5.25856 6.77419 5.41275 6.77419H6.58725C6.74144 6.77419 6.86874 6.65366 6.87714 6.49969L7.0566 3.20937C7.06568 3.04306 6.93327 2.90323 6.76672 2.90323H5.23326C5.06671 2.90323 4.93432 3.04306 4.9434 3.20937Z"
      fill="#D65745"
    />
  </svg>

  <!-- Filter Add -->
  <svg
    v-else-if="iconName === 'filter-add'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.48">
      <path
        d="M11.5 20.5L8.5 21.5V13L4.02 8.072C3.68545 7.70393 3.50005 7.2244 3.5 6.727V4.5H19.5V6.672C19.4999 7.20239 19.2891 7.71101 18.914 8.086L14.5 12.5V15.5M15.5 19.5H21.5M18.5 16.5V22.5"
        :stroke="strokeColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "edit",
    },
    size: {
      type: [Number, String],
      default: 20,
    },
    disabled: {
      type: [Boolean],
      default: false,
    },
    active: {
      type: [Boolean],
      default: false,
    },
    strokeColor: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {
      iconColor: "#FFFFFF",
    };
  },
  watch: {
    "$vuetify.theme.dark"(newVal, oldVal) {
      if (this.$vuetify.theme.dark) {
        this.iconColor = this.active
          ? "#0082BA"
          : this.disabled
          ? "#4C4F5A"
          : "#FFFFFF";
      } else {
        this.iconColor = this.active
          ? "#242A33"
          : this.disabled
          ? "#DFE1E5"
          : "#9AAAC3";
      }
    },
    disabled: function (newVal, oldVal) {
      if (this.$vuetify.theme.dark) {
        this.iconColor = this.disabled ? "#4C4F5A" : "#FFFFFF";
      } else {
        this.iconColor = this.disabled ? "#DFE1E5" : "#9AAAC3";
      }
    },
    active: function (newVal, oldVal) {
      if (this.$vuetify.theme.dark) {
        this.iconColor = this.active ? "#0082BA" : "#FFFFFF";
      } else {
        this.iconColor = this.active ? "#242A33" : "#9AAAC3";
      }
    },
  },
  created() {
    if (this.$vuetify.theme.dark) {
      if (this.disabled) this.iconColor = "#595C68";
      else if (this.active) this.iconColor = "#0082BA";
      else if (this.iconName === "proc-comm") this.iconColor = "#59AFED";
      else if (this.iconName === "proc-filter") this.iconColor = "#9A8FD6";
      else if (this.iconName === "proc-converter") this.iconColor = "#DD9696";
      else if (this.iconName === "proc-folder") this.iconColor = "#D0CC72";
      else if (this.iconName === "proc-mapper") this.iconColor = "#63CBAE";
      else if (this.iconName === "proc-dsm") this.iconColor = "#8895AA";
      else if (this.iconName === "proc-usr") this.iconColor = "#6673E3";
      else if (this.iconName === "proc-trigger") this.iconColor = "#61B0FF";
      else if (this.iconName === "proc-group") this.iconColor = "#C88D75";
      else if (this.iconName === "proc-ai") this.iconColor = "#43CADE";
      else if (this.iconName === "open-new-tab") this.iconColor = "#7d838d";
      else this.iconColor = "#FFFFFF";
    } else {
      if (this.disabled) this.iconColor = "#D1D6DA";
      else if (this.active) this.iconColor = "#242A33";
      else if (this.iconName === "proc-comm") this.iconColor = "#59AFED";
      else if (this.iconName === "proc-filter") this.iconColor = "#A15CFA";
      else if (this.iconName === "proc-converter") this.iconColor = "#EA6E6E";
      else if (this.iconName === "proc-folder") this.iconColor = "#F8C25A";
      else if (this.iconName === "proc-mapper") this.iconColor = "#00DDA0";
      else if (this.iconName === "proc-dsm") this.iconColor = "#92ADD9";
      else if (this.iconName === "proc-usr") this.iconColor = "#6673E3";
      else if (this.iconName === "proc-trigger") this.iconColor = "#497DDE";
      else if (this.iconName === "proc-group") this.iconColor = "#805C4D";
      else if (this.iconName === "comp-copy") this.iconColor = "#111827";
      else if (this.iconName === "proc-ai") this.iconColor = "#1AB2EF";
      else if (this.iconName === "comp-clear") this.iconColor = "#111827";
      else if (this.iconName === "open-new-tab") this.iconColor = "#6488aa";
      else this.iconColor = "#9AAAC3";
    }
  },
  methods: {},
};
</script>
